(function () {
  'use strict';

  var CORE_REVISION = '20261012-1';
  // This owner outlives core/runtime replacements. Never wrap its private transport twice.
  installCartAddOnce();
  // Keep only a valid same/newer core; bump this revision whenever the exported API changes.
  // An older core is upgraded in place (below) so scripts that captured it see the newer API.
  if (window.BGDesignerStorefrontCore && isCurrentCoreRevision(window.BGDesignerStorefrontCore.coreRevision)) return;

  function isCurrentCoreRevision(revision) {
    if (typeof revision !== 'string' || !/^\d{8}-\d+$/.test(revision)) return false;
    var loaded = revision.split('-');
    var current = CORE_REVISION.split('-');
    return loaded[0] > current[0] || (loaded[0] === current[0] && Number(loaded[1]) >= Number(current[1]));
  }

  function installCartAddOnce() {
    if (window.BGCartAddOnce || !window.document || !window.addEventListener) return;
    var doc = window.document;
    // Every browser page has window.fetch; the owner wraps it and never adds a
    // global the page did not have.
    var pageHasFetch = typeof window.fetch === 'function';
    var transport = (window.fetch || (typeof fetch === 'function' && fetch));
    if (!transport) return;
    transport = transport.bind(window);
    var PREFIX = 'bg:cart-add-once:';
    var RECOVERY = "We couldn't confirm this item was added. Check your cart before trying again.";
    // A contender refused while nothing of its own was sent (another add is being
    // prepared, a replacement, lock contention, a payload the owner cannot read).
    var BUSY = 'Your cart is busy. Please try again in a moment.';
    // A request that requires the existing cart (a guarded cart-line replacement)
    // found no cart cookie: refused before any cart is created (RCARTADD10).
    var NO_CART = 'Please reload the page and try again.';
    // Some of the intended units are in the cart (stock, or the customer lowered
    // the line): the customer settles it on the cart page.
    var PARTIAL = 'Part of this item is in your cart. Adjust its quantity there, or remove it before adding it again.';
    // A no-Web-Locks tab's add was released while its request was out, and it
    // completed after another add did.
    var TWICE = 'This item may be in your cart twice. Check your cart.';
    // A late answer whose read-back shows the whole add (Fable re-check 3, item 2).
    var EARLIER = 'Your earlier add reached the cart. Check your cart.';
    // Director decision (a3): the cart page lets the customer clear a hold that no
    // proof can clear (no Web Locks, a tab that ended without pagehide).
    var REVIEW_TEXT = 'We could not confirm this item was added. Your cart is shown below. If the item is missing, add it again.';
    var REVIEW_BUTTON = 'I checked my cart, add again';
    // A legacy (old product-form) add clears on the cart page (Director decision d).
    var LEGACY = "We couldn't confirm this item was added. Open your cart to review it. After that you can add items again.";
    var active = null;
    var acquiring = false;
    var replacing = false;
    var preparation = null;
    // Degraded (CART-ADD-STORAGE-FULL): this page saw journal storage fail; only a live request holds an add then
    // (OD-005, OD-100). memoryJournal: this page's copies, { text, failed, over } (over: what storage still holds).
    var degraded = false;
    var memoryJournal = Object.create(null);
    var noLocksCounted = false;
    var forms = new WeakSet();
    var listeners = [];
    // A page's send guard per form (ARTWORK-FLOW-3): asked last, right before an
    // add from that form is journaled and sent.
    var sendGuards = new WeakMap();
    var recoveryTimer = null;
    var sequence = 0;
    // Operations whose request this page sent (or whose legacy form this page
    // watches) and that have not settled yet: marked gone on a real unload.
    var inflightHere = [];
    var blockingStates = ['sent', 'committed-unknown', 'read-back', 'unresolved', 'handoff', 'quarantined'];

    function cookieIdentity() {
      try {
        var match = String(doc.cookie || '').match(/(?:^|;\s*)cart=([^;]+)/);
        return match ? decodeURIComponent(match[1]).split('?')[0].trim() : '';
      } catch (_) { return ''; }
    }
    function key(identity) { return PREFIX + encodeURIComponent(identity || 'unknown'); }
    function isBlocking(entry) { return entry && blockingStates.indexOf(entry.state) !== -1; }
    function degrade() { if (!degraded) { degraded = true; clearRecoveryUi(); } }
    function journalNames() {
      var names = [];
      try {
        for (var i = 0; i < window.localStorage.length; i += 1) {
          var name = window.localStorage.key(i);
          if (name && name.indexOf(PREFIX) === 0) names.push(name);
        }
      } catch (_) { degrade(); }
      return names.concat(Object.keys(memoryJournal).filter(function (name) { return names.indexOf(name) === -1; }));
    }
    // Storage first (other pages' newer records count); this page's copy while reads throw or while storage still
    // holds exactly what this page could not overwrite. An unreadable record is no record and degrades the page.
    function stored(keyName) {
      var memory = memoryJournal[keyName], raw, value = null;
      try { raw = window.localStorage.getItem(keyName); } catch (_) { degrade(); raw = memory ? memory.text : null; }
      if (memory && memory.failed && raw === memory.over) raw = memory.text;
      try { value = raw ? JSON.parse(raw) : null; } catch (_) {}
      if (raw && !(value && value.opId && value.state)) { degrade(); return null; }
      return value;
    }
    // Observation: the open operation of this page, else of any retained identity. It never holds by itself.
    function blocked() {
      if (isBlocking(active)) {
        var latest = stored(key(active.identity));
        if (latest && latest.opId === active.opId && !isBlocking(latest)) active = null;
        else {
          if (latest && isBlocking(latest)) active = latest;
          return active;
        }
      }
      // Check all retained identities: a rotated/missing cookie cannot escape an uncertain write.
      for (var i = 0, names = journalNames(); i < names.length; i += 1) {
        var entry = stored(names[i]);
        if (isBlocking(entry)) return entry;
      }
      return null;
    }
    // Admission. Normal mode: a journal hold as today, once a write probe shows storage still works. Degraded mode:
    // only a live request of this page (another page's: liveElsewhere in dispatch). Flags never hold when degraded.
    function held() {
      var entry = blocked();
      if (entry && !degraded) storageReady();
      return degraded ? liveHere() : entry;
    }
    function refused(form) { return (!degraded && (held() || acquiring || replacing || (preparation && preparation.form !== form)) && !degraded) || (degraded && liveHere()); }
    function settledFor(opId) {
      return journalNames().some(function (name) { var saved = stored(name); return !!saved && saved.opId === opId && !isBlocking(saved); });
    }
    function liveHere() { return inflightHere.some(function (entry) { return !settledFor(entry.opId); }); }
    async function liveElsewhere(locks) {
      var state = await locks.query();
      return (state && state.held || []).some(function (lock) {
        var name = String(lock.name || '');
        return name.indexOf(INFLIGHT_PREFIX) === 0 && !settledFor(name.slice(INFLIGHT_PREFIX.length));
      });
    }
    // A refused write keeps this page's copy, degrades the page and deletes nothing. A completed add or its
    // acknowledgement is then stored compact (no baseline), in the room of its own larger record.
    function persist(entry) {
      var name, text, over = null, prior = null;
      try { name = key(entry.identity); text = JSON.stringify(entry); } catch (_) { return false; }
      try {
        window.localStorage.setItem(name, text);
        if (window.localStorage.getItem(name) === text) { memoryJournal[name] = { text: text }; return true; }
      } catch (_) {}
      try { over = window.localStorage.getItem(name); prior = JSON.parse(over); } catch (_) {}
      memoryJournal[name] = { text: text, failed: true, over: over };
      degrade();
      if ((entry.state !== 'handoff' && entry.state !== 'acknowledged') || (isBlocking(prior) && prior.opId !== entry.opId)) return true;
      try {
        var compact = JSON.stringify(compactOf(entry));
        window.localStorage.setItem(name, compact);
        if (window.localStorage.getItem(name) === compact) memoryJournal[name].over = compact;
      } catch (_) {}
      return true;
    }
    // The comparison facts the late-result paths need, without the baseline cart.
    function compactOf(entry) {
      var out = { version: 1, opId: entry.opId, identity: entry.identity, state: entry.state, sentAt: entry.sentAt, intent: entry.intent };
      // The facts the readers use: the review reason, partial and late-landed marks, the legacy review counts.
      ['acknowledgeReason', 'partial', 'lateLandedAt', 'before', 'baselineVariants', entry.intent ? '' : 'reviewedVariants']
        .forEach(function (name) { if (name && entry[name] !== undefined) out[name] = entry[name]; });
      if (!entry.baseline) return out;
      var before = totals(entry.baseline);
      if (entry.baseline.length) out.baselineVariants = variantTotals(entry.baseline);
      out.before = (entry.intent || []).map(function (line) { return before[signature(line)] || 0; });
      return out;
    }
    // Degraded mode warns conservatively (other pages' records may be missing): the baseline cart or an open record
    // has a variant of this add, or another request of this page is unsettled.
    function possibleDuplicate(entry, cart) {
      var variants = entry.intent.map(function (line) { return line.variant; });
      var shares = function (lines) { return !lines || lines.some(function (line) { return variants.indexOf(String(line.variant)) !== -1; }); };
      return shares(cart.items.map(item)) || inflightHere.length > 0 || journalNames().some(function (name) {
        var other = stored(name);
        return isBlocking(other) && other.opId !== entry.opId && shares(other.intent);
      });
    }
    function storageReady() {
      try {
        var name = 'bg:cart-add-once-probe';
        window.localStorage.setItem(name, name);
        if (window.localStorage.getItem(name) === name) { window.localStorage.removeItem(name); return true; }
      } catch (_) {}
      degrade();
      return false;
    }
    function current(entry) {
      if (!entry || !entry.opId) return false;
      var saved = stored(key(entry.identity));
      return !!saved && saved.opId === entry.opId && isBlocking(saved);
    }
    function result(entry, data, cart) {
      var failed = entry.state === 'refused' || entry.state === 'baseline-unavailable';
      return { state: entry.state, opId: entry.opId || '', data: data || null, cart: cart || null,
        recovery: !failed && ['handoff', 'released', 'acknowledged', 'idle'].indexOf(entry.state) === -1,
        message: failed
          ? (window.BGDesignerStorefrontCore && window.BGDesignerStorefrontCore.buildCartFailureMessage('add')) || 'We could not add this item to your cart. Please try again.'
          : messageFor(entry) };
    }
    function announce(outcome, form) {
      // An operation that entered without a form (a repaired tab's old product
      // form goes through the fetch bridge) reports to every listener; a
      // rejected contender reports only to its own form.
      var broadcast = !form && outcome.state !== 'rejected';
      listeners.slice().forEach(function (listener) {
        if (broadcast || !listener.form || listener.form === form) {
          try { listener.callback(outcome); } catch (_) {}
        }
      });
      try { doc.dispatchEvent(new window.CustomEvent('bg:cart-add-once-outcome', { detail: outcome })); } catch (_) {}
    }
    function isLegacy(entry) { return !!(entry && entry.opId && String(entry.opId).indexOf('legacy-') === 0); }
    function messageFor(entry) { return entry && entry.partial ? PARTIAL : isLegacy(entry) ? LEGACY : RECOVERY; }
    // True when a control's centre is on screen and nothing (a fixed discount
    // strip, a chat button) sits on top of it.
    function clearOnScreen(control) {
      if (typeof doc.elementFromPoint !== 'function') return true;
      var box = control.getBoundingClientRect();
      var x = box.left + box.width / 2;
      var y = box.top + box.height / 2;
      if (y < 0 || x < 0 || y > (window.innerHeight || 0) || x > (window.innerWidth || 0)) return false;
      var hit = doc.elementFromPoint(x, y);
      return !!hit && (hit === control || control.contains(hit));
    }
    function shown(node) {
      if (!node || !node.isConnected || node.closest('[hidden]')) return false;
      var rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }
    function pinned(node) {
      for (var current = node; current && current.nodeType === 1; current = current.parentElement) {
        var position = '';
        try { position = window.getComputedStyle(current).position; } catch (_) {}
        if (position === 'fixed' || position === 'sticky') return true;
      }
      return false;
    }
    // The cart page is the theme's configured cart route (routes.cart_url), also
    // under a locale prefix (/fr/cart, /en-ca/cart); never a path that merely
    // ends in /cart (/products/cart, /pages/cart).
    function cartPath() {
      var configured = (window.routes && window.routes.cart_url) || (cartRoot() + 'cart');
      var path = '/cart';
      try { path = new URL(configured, window.location.href).pathname.replace(/\/+$/, '') || '/cart'; } catch (_) {}
      return path.replace(/^\/[a-z]{2}(?:-[a-z0-9]+)?(?=\/)/i, '');
    }
    function onCartPage() {
      var path = String(window.location.pathname || '').replace(/\/+$/, '');
      var bare = cartPath();
      if (path === bare) return true;
      if (path.length <= bare.length || path.slice(-bare.length).toLowerCase() !== bare.toLowerCase()) return false;
      return /^\/[a-z]{2}(?:-[a-z0-9]+)?$/i.test(path.slice(0, path.length - bare.length));
    }
    // Above the cart, inside the page's padded content column.
    function cartPageHost() {
      var main = doc.querySelector('main') || doc.body;
      return main.querySelector('.page-width') || main;
    }
    // The purchase control the customer used (or, after a reload, the first
    // visible one on the page): a visible add button that is not part of a fixed
    // or sticky bar. The recovery panel goes right after its row.
    var lastAddControl = null;
    function purchaseControl(target) {
      if (lastAddControl && shown(lastAddControl) && !pinned(lastAddControl)) return lastAddControl;
      var scope = (target && target.closest && target.closest('product-info')) || doc;
      var own = target && Array.prototype.find.call(target.querySelectorAll('[type="submit"]'), function (button) { return shown(button) && !pinned(button); });
      if (own) return own;
      return Array.prototype.find.call(scope.querySelectorAll('button, [role="button"]'), function (button) {
        return shown(button) && !pinned(button) && (/add to cart|adding/i.test(button.textContent || '') || (button.form && formAdd(button.form, button)));
      }) || null;
    }
    function recovery(form, entry) {
      try {
        var text = messageFor(entry || blocked());
        var target = form && form.isConnected ? form : doc.querySelector('form[action*="/cart/add"]');
        var host = target || doc.body;
        if (!host) return;
        // Show it where the customer is looking: on the cart page above the cart;
        // otherwise right after the visible purchase control the customer used
        // (guided pages and the phone experiences show their own purchase
        // controls, not the form), then beside the storefront message.
        var anchor = null;
        var top = null;
        if (onCartPage()) top = cartPageHost();
        else {
          var control = purchaseControl(target);
          if (control) anchor = control.parentElement && control.parentElement !== target ? control.parentElement : control;
          else if (target && !shown(target)) {
            var scope = target.closest('product-info') || doc;
            anchor = scope.querySelector('[data-bg-designer-block="message"]') || doc.querySelector('[data-bg-designer-block="message"]');
          }
        }
        var panel = doc.querySelector('[data-bg-cart-add-recovery]');
        // The customer review offered on the cart page (decision a3) stays as is.
        if (panel && panel.hasAttribute('data-bg-cart-add-review')) {
          if (onCartPage()) return;
          panel.remove(); panel = null;
        }
        var created = !panel;
        if (!panel) {
          panel = doc.createElement('div');
          panel.setAttribute('data-bg-cart-add-recovery', '');
          panel.setAttribute('role', 'alert');
          var message = doc.createElement('p');
          message.textContent = text;
          var view = doc.createElement('a');
          view.className = 'button button--secondary';
          view.href = cartRoot() + 'cart';
          view.textContent = 'View cart';
          var check = doc.createElement('button');
          check.type = 'button';
          check.className = 'button button--secondary';
          check.textContent = 'Check again';
          check.addEventListener('click', function () {
            check.disabled = true;
            owner.checkAgain().finally(function () { check.disabled = false; });
          });
          panel.appendChild(message); panel.appendChild(view); panel.appendChild(check);
          if (top) top.insertBefore(panel, top.firstChild);
          else if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(panel, anchor.nextSibling);
          else host.appendChild(panel);
        }
        else if (panel.firstChild && panel.firstChild.textContent !== text) panel.firstChild.textContent = text;
        // Bring View cart and Check again into view, clear of fixed overlays
        // (also when a restored page shows it without the form).
        if (created && shown(panel)) {
          var controls = panel.querySelectorAll('a, button');
          if (!Array.prototype.every.call(controls, clearOnScreen)) {
            try { panel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) {}
          }
        }
        if (target) {
          // A legacy (old-class) form keeps its spinner: its own request is still
          // live, and its button losing .loading is how this page learns it settled.
          var ownForm = isOwnerForm(target);
          Array.prototype.forEach.call(target.querySelectorAll('[type="submit"]'), function (button) {
            if (ownForm) button.classList.remove('loading');
            if (!degraded) { button.setAttribute('aria-disabled', 'true'); button.setAttribute('data-bg-cart-add-blocked', ''); }
          });
          if (ownForm) Array.prototype.forEach.call(target.querySelectorAll('.loading__spinner'), function (spinner) { spinner.classList.add('hidden'); });
          target.dispatchEvent(new window.CustomEvent('bg:designer-cart-submit-state', {
            bubbles: true, detail: { state: 'error', stage: 'cart-add', message: text }
          }));
        }
      } catch (_) { /* UI failure must never release the journal. */ }
    }
    // Removes the recovery state from this page: the panel, the sentence mirrored
    // into product-form boxes, and the disabled state the owner put on buttons.
    function clearRecoveryUi() {
      window.clearTimeout(recoveryTimer); recoveryTimer = null;
      Array.prototype.forEach.call(doc.querySelectorAll('[data-bg-cart-add-recovery]'), function (panel) { panel.remove(); });
      Array.prototype.forEach.call(doc.querySelectorAll('[data-bg-cart-add-blocked]'), function (button) {
        button.removeAttribute('data-bg-cart-add-blocked');
        button.removeAttribute('aria-disabled');
      });
      Array.prototype.forEach.call(doc.querySelectorAll('.product-form__error-message-wrapper'), function (wrapper) {
        var text = String(wrapper.textContent || '');
        if ([RECOVERY, BUSY, PARTIAL, LEGACY].some(function (known) { return text.indexOf(known) !== -1; })) wrapper.hidden = true;
      });
    }
    function armRecovery(entry, form) {
      if (recoveryTimer !== null) window.clearTimeout(recoveryTimer);
      recoveryTimer = window.setTimeout(function () {
        var pending = blocked();
        if (pending) { recovery(form, pending); announce(result(pending), form); }
      }, Math.max(0, (entry.sentAt || Date.now()) + 30000 - Date.now()));
    }
    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function bounded(promise, ms) {
      return new Promise(function (resolve, reject) {
        var timer = window.setTimeout(function () { reject(new Error('Cart read timed out')); }, Math.max(0, ms));
        Promise.resolve(promise).then(function (value) { window.clearTimeout(timer); resolve(value); }, function (error) { window.clearTimeout(timer); reject(error); });
      });
    }
    async function readCart(deadline) {
      function remaining() { return Math.max(0, Math.min(5000, deadline - Date.now())); }
      if (!remaining()) throw new Error('Cart read deadline');
      var response = await bounded(transport(cartRoot() + 'cart.js?_bg_cart_fresh=' + Date.now(), {
        credentials: 'same-origin', cache: 'no-store', headers: { accept: 'application/json', 'cache-control': 'no-cache', pragma: 'no-cache' }
      }), remaining());
      if (!response.ok || !remaining()) throw new Error('Cart read failed');
      var cart = await bounded(response.json(), remaining());
      if (!cart || !Array.isArray(cart.items)) throw new Error('Cart read invalid');
      return cart;
    }
    function properties(value) {
      var output = {};
      Object.keys(value || {}).sort().forEach(function (name) {
        if (value[name] !== null && value[name] !== undefined && String(value[name]) !== '') output[name] = String(value[name]);
      });
      return output;
    }
    function item(value) {
      var plan = value.selling_plan || (value.selling_plan_allocation && value.selling_plan_allocation.selling_plan && value.selling_plan_allocation.selling_plan.id) || '';
      return { variant: String(value.variant_id || value.id || ''), plan: String(plan), properties: properties(value.properties), quantity: Number(value.quantity == null ? 1 : value.quantity), key: String(value.key || '') };
    }
    function signature(value) { return JSON.stringify([value.variant, value.plan, value.properties]); }
    function totals(items) {
      var output = Object.create(null);
      items.forEach(function (line) { var id = signature(line); output[id] = (output[id] || 0) + line.quantity; });
      return output;
    }
    function compare(entry, cart) {
      if (!entry.baseline || !entry.intent) return 'conflict';
      var currentLines = cart.items.map(item);
      // Aggregation permits Shopify merges/key changes, but cannot hide a changed surviving baseline line.
      var changedExisting = entry.baseline.some(function (line) {
        var present = currentLines.find(function (candidate) { return line.key && candidate.key === line.key; });
        if (!present) return false;
        var intended = entry.intent.some(function (intent) { return signature(intent) === signature(line); });
        return signature(present) !== signature(line) || present.quantity < line.quantity || (!intended && present.quantity !== line.quantity);
      });
      if (changedExisting) return 'conflict';
      var before = totals(entry.baseline);
      var after = totals(currentLines);
      var wanted = totals(entry.intent);
      var exact = true;
      var unchanged = true;
      var conflict = false;
      Object.keys(Object.assign({}, before, after, wanted)).forEach(function (id) {
        var delta = (after[id] || 0) - (before[id] || 0);
        if (delta !== 0) unchanged = false;
        if (delta !== (wanted[id] || 0)) exact = false;
        if (delta !== 0 && delta !== (wanted[id] || 0)) conflict = true;
      });
      if (exact) return 'exact';
      if (unchanged) return 'unchanged';
      return conflict ? 'conflict' : 'partial';
    }
    async function parseIntent(input, init) {
      var body = init && init.body;
      var contentType = new Headers(init && init.headers || {}).get('content-type') || '';
      if (body == null && input && typeof input.clone === 'function') {
        var copy = input.clone();
        contentType = copy.headers.get('content-type') || '';
        body = contentType.indexOf('multipart/form-data') !== -1 ? await copy.formData() : await copy.text();
      }
      if (typeof body === 'string' && (contentType.indexOf('json') !== -1 || /^\s*\{/.test(body))) {
        var json = JSON.parse(body);
        return (json.items || [json]).map(item);
      }
      if (typeof body === 'string') body = new URLSearchParams(body);
      return entriesIntent(body);
    }
    function entriesIntent(body) {
      if (!body || typeof body.entries !== 'function') throw new Error('Cart payload unavailable');
      var single = { properties: {} };
      var batch = {};
      for (var pair of body.entries()) {
        if (typeof pair[1] !== 'string') throw new Error('Cart payload needs review');
        var name = pair[0];
        var value = pair[1];
        var match = name.match(/^items\[(\d+)\]\[(id|quantity|selling_plan|properties)\](?:\[([^\]]+)\])?$/);
        var target = single;
        if (match) {
          target = batch[match[1]] || (batch[match[1]] = { properties: {} });
          if (match[2] === 'properties') target.properties[match[3]] = value;
          else target[match[2]] = value;
        } else if (/^properties\[.+\]$/.test(name)) single.properties[name.slice(11, -1)] = value;
        else if (name === 'id' || name === 'quantity' || name === 'selling_plan') single[name] = value;
      }
      return (Object.keys(batch).length ? Object.keys(batch).map(function (id) { return batch[id]; }) : [single]).map(item);
    }
    function setState(entry, state, form, data, cart, verifiedComplete) {
      if (!current(entry)) return result(entry);
      var saved;
      try { saved = stored(key(entry.identity)); } catch (_) {}
      // Quarantine is left only when a fresh read shows the whole intended add.
      if (saved && saved.state === 'quarantined' && !(verifiedComplete && state === 'handoff')) { Object.assign(entry, saved); return result(entry); }
      if (saved && saved.state === 'handoff' && ['read-back', 'unresolved', 'refused'].indexOf(state) !== -1) return result(saved, data, cart);
      entry.everUncertain = !!(entry.everUncertain || (saved && saved.everUncertain));
      if (state === 'refused' && entry.everUncertain) state = 'unresolved';
      entry.state = state;
      if (state === 'unresolved' || state === 'quarantined') entry.everUncertain = true;
      if (!persist(entry)) { entry.state = 'quarantined'; active = entry; }
      if (active && active.opId === entry.opId) active = entry.state === 'refused' ? null : entry;
      var outcome = result(entry, data, cart);
      if (entry.state === 'unresolved' || entry.state === 'quarantined') recovery(form, entry);
      if (entry.state !== 'read-back') announce(outcome, form);
      return outcome;
    }
    async function reconcile(entry, deadline, answer, form) {
      var delays = [500, 1000, 2000, 4000, 8000];
      var attempt = 0;
      if (!current(entry)) return result(entry);
      // Quarantine is durable: unknown legacy baselines and conflicts cannot be cleared by a later coincidence.
      if (entry.state === 'quarantined') { recovery(form, entry); return result(entry); }
      var hadHandoff = entry.state === 'handoff';
      if (hadHandoff && !entry.baseline) return result(entry);
      if (!hadHandoff) setState(entry, 'read-back', form);
      while (Date.now() < deadline && current(entry)) {
        try {
          var cart = await readCart(deadline);
          if (!current(entry)) return result(entry);
          var latest = stored(key(entry.identity));
          if (latest) Object.assign(entry, latest);
          if (entry.state === 'quarantined') return result(entry);
          if (cookieIdentity() !== entry.identity) return setState(entry, 'quarantined', form);
          var match = compare(entry, cart);
          if (match === 'exact') {
            var data = answer && answer.data;
            if (!data || data.status) data = cart.items.find(function (line) { return signature(item(line)) === signature(entry.intent[0]); });
            return setState(entry, 'handoff', form, data, cart);
          }
          if (match !== 'unchanged' || hadHandoff) { entry.partial = landed(entry, cart) === 'partial'; return setState(entry, 'quarantined', form); }
          if (answer && answer.errorStatus && !entry.everUncertain) return setState(entry, 'refused', form, answer.data, cart);
        } catch (_) {}
        var delay = Math.min(delays[Math.min(attempt++, delays.length - 1)], deadline - Date.now());
        if (delay <= 0) break;
        await new Promise(function (resolve) { window.setTimeout(resolve, delay); });
      }
      return setState(entry, 'unresolved', form);
    }
    var INFLIGHT_PREFIX = 'bg-cart-add-inflight:';
    var HEARTBEAT_MS = 20000;
    var HEARTBEAT_STALE_MS = 60000;
    // Without Web Locks silence proves nothing (decision a3); after this much
    // silence the cart page offers the customer the explicit review control.
    var CUSTOMER_REVIEW_AFTER_MS = 600000;
    var RELEASE_AFTER_MS = 120000;
    // Durable facts about the request (settledAt, aliveAt) go onto the stored
    // entry of the same operation without touching its state.
    function markJournal(entry, fields) {
      try {
        var saved = stored(key(entry.identity));
        if (!saved || saved.opId !== entry.opId || !isBlocking(saved)) return false;
        Object.assign(saved, fields);
        Object.assign(entry, fields);
        if (active && active.opId === entry.opId) Object.assign(active, fields);
        return persist(saved);
      } catch (_) { return false; }
    }
    // The sender is provably gone, never merely suspended: its request settled
    // (settledAt), or its page really unloaded (pageGoneAt, not a BFCache
    // freeze), or, where Web Locks exist, nobody holds its in-flight lock AND its
    // heartbeat stopped. Without Web Locks silence is never proof (decision a3).
    // Returns the proof ('settled', 'page-gone', 'heartbeat-stale') or false.
    async function releasable(entry) {
      var locks = window.navigator && window.navigator.locks;
      var hasLocks = !!(locks && typeof locks.request === 'function');
      var basis = entry.settledAt ? 'settled' : entry.pageGoneAt ? 'page-gone' : '';
      var gone = entry.settledAt || entry.pageGoneAt || 0;
      if (!gone) {
        if (!hasLocks) return false;
        var lastAlive = entry.aliveAt || entry.sentAt || 0;
        if (!lastAlive || Date.now() - lastAlive <= HEARTBEAT_STALE_MS) return false;
        gone = lastAlive;
        basis = 'heartbeat-stale';
      }
      if (Date.now() - gone < RELEASE_AFTER_MS) return false;
      if (!hasLocks) return basis;
      try {
        var free = await locks.request(INFLIGHT_PREFIX + entry.opId, { mode: 'exclusive', ifAvailable: true }, function (lock) { return !!lock; });
        return free ? basis : false;
      } catch (_) { return false; }
    }
    // Decision (a3): the explicit customer review on the cart page is offered
    // only when no proof can come (no Web Locks) and the request has been silent
    // for ten minutes.
    function customerReviewable(entry) {
      var locks = window.navigator && window.navigator.locks;
      if (locks && typeof locks.request === 'function') return false;
      var lastAlive = entry.aliveAt || entry.sentAt || 0;
      return !!lastAlive && Date.now() - lastAlive >= CUSTOMER_REVIEW_AFTER_MS;
    }
    // Director decision (c2): a legacy (old product-form) request was sent before
    // this owner could see its body, so its item is unknown: any line in the cart
    // may be its trace (no narrowing to the form's current variant, which the
    // page may have changed since).
    function legacyTrace(entry, cart) { return cart.items.length > 0; }
    function markPartial(entry, partial) {
      if (!!entry.partial === partial) return;
      entry.partial = partial;
      persist(entry);
      if (active && active.opId === entry.opId) active.partial = partial;
    }
    // How much of the intended add is in the cart now, per intended line:
    // 'complete' (every intended line rose by at least its quantity: the add
    // landed, later customer edits aside), 'partial' (some rise, not all),
    // 'none' (no trace), 'unknown' (no intent: a legacy form's add).
    function landed(entry, cart) {
      if (!entry.intent || !(entry.baseline || entry.before)) return 'unknown';
      var before = entry.baseline ? totals(entry.baseline) : entry.intent.reduce(function (out, line, i) { out[signature(line)] = Math.max(0, Number(entry.before[i]) || 0); return out; }, {});
      var after = totals(cart.items.map(item));
      var wanted = totals(entry.intent);
      var full = true;
      var any = false;
      Object.keys(wanted).forEach(function (id) {
        var delta = (after[id] || 0) - (before[id] || 0);
        if (delta > 0) any = true;
        if (delta < wanted[id]) full = false;
      });
      return full && (entry.baseline || any) ? 'complete' : any ? 'partial' : 'none'; // a compact record proves nothing it cannot count
    }
    // Hold the in-flight lock and stamp aliveAt for an operation this page is
    // responsible for, until its request (or legacy form) settles.
    function watchInflight(entry) {
      var heartbeat = null;
      var done = false;
      var beat = function () {
        heartbeat = window.setTimeout(function () {
          if (done || !markJournal(entry, { aliveAt: Date.now() })) return;
          beat();
        }, HEARTBEAT_MS);
      };
      beat();
      var inflightDone = null;
      var inflightLocks = window.navigator && window.navigator.locks;
      if (inflightLocks && typeof inflightLocks.request === 'function') {
        var inflight = new Promise(function (resolve) { inflightDone = resolve; });
        try {
          Promise.resolve(inflightLocks.request(INFLIGHT_PREFIX + entry.opId, { mode: 'exclusive', ifAvailable: true }, function () { return inflight; })).catch(function () {});
        } catch (_) {}
      }
      inflightHere.push(entry);
      return function settle() {
        if (done) return;
        done = true;
        window.clearTimeout(heartbeat);
        if (inflightDone) inflightDone();
        inflightHere = inflightHere.filter(function (value) { return value !== entry; });
        markJournal(entry, { settledAt: Date.now() });
      };
    }
    // Any count increase for an intended line (variant, selling plan, the full
    // submitted properties including the context) is a trace of the add.
    function traceOfIntent(entry, cart) {
      if (!entry.intent || !entry.baseline) return false;
      var before = totals(entry.baseline);
      var after = totals(cart.items.map(item));
      return entry.intent.some(function (line) {
        var id = signature(line);
        return (after[id] || 0) > (before[id] || 0);
      });
    }
    function release(entry, reason, basis) {
      var saved;
      try { saved = stored(key(entry.identity)); } catch (_) { return result(entry); }
      if (!saved || saved.opId !== entry.opId || !isBlocking(saved)) return result(entry);
      var from = saved.state;
      saved.state = 'released';
      saved.releasedAt = Date.now();
      saved.releaseReason = reason;
      saved.releaseBasis = basis || '';
      if (!persist(saved)) return result(entry);
      if (active && active.opId === saved.opId) active = null;
      clearRecoveryUi();
      var detail = { reason: reason, basis: basis || '', from: from, ageMs: Date.now() - (saved.sentAt || Date.now()) };
      try { doc.dispatchEvent(new window.CustomEvent('bg:cart-add-once-released', { detail: detail })); } catch (_) {}
      try {
        if (window.BGDesignerTelemetry && window.BGDesignerTelemetry.emitEvent) window.BGDesignerTelemetry.emitEvent('cart_add_once_released', 'cart', detail, 'high');
      } catch (_) {}
      var outcome = result(saved);
      announce(outcome, null);
      return outcome;
    }
    // Director decisions (b) and (d): on the cart page, once its sender is
    // provably gone two minutes, a partial add or a legacy add with a line of its
    // item in the cart is acknowledged (not released): what the customer reviewed
    // in the cart stays, the next tap is a fresh add.
    function acknowledgeReviewed(entry, reason, basis) {
      var saved;
      try { saved = stored(key(entry.identity)); } catch (_) { return false; }
      if (!saved || saved.opId !== entry.opId || !isBlocking(saved)) return false;
      saved.state = 'acknowledged';
      saved.acknowledgedAt = Date.now();
      saved.acknowledgeReason = reason;
      if (basis) saved.acknowledgeBasis = basis;
      if (!persist(saved)) return false;
      if (active && active.opId === saved.opId) active = null;
      clearRecoveryUi();
      var detail = { reason: reason, basis: basis || '', ageMs: Date.now() - (saved.sentAt || Date.now()) };
      try {
        if (window.BGDesignerTelemetry && window.BGDesignerTelemetry.emitEvent) window.BGDesignerTelemetry.emitEvent(reason === 'partial-reviewed' ? 'cart_add_once_partial_acknowledged' : reason === 'customer-cart-review' ? 'cart_add_once_customer_reviewed' : 'cart_add_once_legacy_acknowledged', 'cart', detail, 'high');
      } catch (_) {}
      return true;
    }
    // A late-landing notice is journaled for the device so the next page shows it
    // too (a legacy form navigates to the cart right after its add), until the
    // customer has seen it on the cart page.
    var NOTICE_KEY = 'bg:cart-add-once-notice';
    function journalNotice(identity, kind) {
      try { window.localStorage.setItem(NOTICE_KEY, JSON.stringify({ kind: kind, at: Date.now() })); } catch (_) {}
    }
    function reloadCartPage() {
      try { window.location.reload(); } catch (_) {}
    }
    function showJournaledNotice() {
      try {
        var notice = JSON.parse(window.localStorage.getItem(NOTICE_KEY) || 'null');
        if (!notice || notice.seenAt) return;
        duplicateNotice(null, notice.kind === 'earlier' ? EARLIER : notice.kind === 'partial' ? PARTIAL : TWICE);
        // Seen only by a visible cart page (an old form's redirect in a background
        // tab does not count).
        if (onCartPage() && doc.visibilityState !== 'hidden') { notice.seenAt = Date.now(); window.localStorage.setItem(NOTICE_KEY, JSON.stringify(notice)); }
      } catch (_) {}
    }
    function duplicateNotice(form, text) {
      try {
        var existing = doc.querySelector('[data-bg-cart-add-duplicate]');
        if (existing) { if (existing.firstChild) existing.firstChild.textContent = text || TWICE; return; }
        var target = form && form.isConnected ? form : doc.querySelector('form[action*="/cart/add"]');
        var panel = doc.createElement('div');
        panel.setAttribute('data-bg-cart-add-duplicate', '');
        panel.setAttribute('role', 'alert');
        var message = doc.createElement('p');
        message.textContent = text || TWICE;
        var view = doc.createElement('a');
        view.className = 'button button--secondary';
        view.href = cartRoot() + 'cart';
        view.textContent = 'View cart';
        panel.appendChild(message); panel.appendChild(view);
        // Where the customer is looking, as the recovery panel: on the cart page
        // above the cart, otherwise beside the visible purchase control.
        var control = onCartPage() ? null : purchaseControl(target);
        var anchor = control ? (control.parentElement && control.parentElement !== target ? control.parentElement : control)
          : target && !shown(target) ? ((target.closest('product-info') || doc).querySelector('[data-bg-designer-block="message"]') || doc.querySelector('[data-bg-designer-block="message"]')) : null;
        var top = onCartPage() ? cartPageHost() : null;
        if (top) top.insertBefore(panel, top.firstChild);
        else if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(panel, anchor.nextSibling);
        else (target || doc.body).appendChild(panel);
        if (shown(panel) && !Array.prototype.every.call(panel.querySelectorAll('a, button'), clearOnScreen)) {
          try { panel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) {}
        }
      } catch (_) {}
    }
    function newestAfter(entry) {
      var newest = null;
      for (var i = 0, names = journalNames(); i < names.length; i += 1) {
        var value = stored(names[i]);
        if (value && value.opId !== entry.opId && (value.sentAt || 0) > (entry.sentAt || 0) && (!newest || value.sentAt > newest.sentAt)) newest = value;
      }
      return newest;
    }
    // Decisions (a3) and (e): the request of an operation this page sent
    // answered (any outcome) after the operation stopped being current (the
    // customer reviewed the cart page, or another page settled it). The cart is
    // read; nothing in it is ever changed:
    // - a newer add of this cart exists and this late add may have added (a 2xx,
    //   an unreadable cart, or its item in the cart): TWICE with View cart;
    // - still the newest operation, released: a read-back showing the whole
    //   intent makes it a hand-off (with the EARLIER notice), part of it a
    //   partial hold, a failed read or a 2xx with nothing an unresolved hold;
    // - still the newest operation, reviewed by the customer: the EARLIER notice
    //   when its item is in the cart (the customer decides, nothing re-blocks).
    async function lateResult(entry, outcome, form) {
      if (current(entry) || !entry.intent || !entry.baseline) return;
      var cart = null;
      try { cart = await readCart(Date.now() + 5000); } catch (_) {}
      var sameCart = cookieIdentity() === entry.identity;
      var newest = newestAfter(entry);
      var detail = { opId: entry.opId, status: outcome.status || 0 };
      if (newest) {
        if (!(outcome.ok || !cart || (sameCart && traceOfIntent(entry, cart)))) return;
        duplicateNotice(form, TWICE);
        journalNotice(entry.identity, 'twice');
        detail.outcome = 'possible-duplicate';
      } else {
        var saved;
        try { saved = stored(key(entry.identity)); } catch (_) { return; }
        if (!saved || saved.opId !== entry.opId) return;
        var state = !cart ? 'unread' : sameCart ? landed(saved, cart) : 'none';
        detail.outcome = 'late-' + state;
        if (saved.state === 'acknowledged' && saved.acknowledgeReason === 'customer-cart-review') {
          // A 2xx whose read failed may well be in the cart; a 2xx that a clean
          // read shows is not in the cart says nothing (decision e).
          if (state === 'complete' || state === 'partial' || (outcome.ok && state === 'unread')) { duplicateNotice(form, EARLIER); journalNotice(entry.identity, 'earlier'); }
        } else if (saved.state === 'released') {
          if (state === 'complete') saved.state = 'handoff';
          else if (state === 'partial') { saved.state = 'quarantined'; saved.partial = true; }
          else if (state === 'unread' || outcome.ok) saved.state = 'unresolved';
          saved.lateResultAt = Date.now();
          if (saved.state !== 'released') {
            saved.everUncertain = true;
            persist(saved);
            active = saved;
            if (saved.state === 'handoff') duplicateNotice(form, EARLIER);
            else recovery(form, saved);
          }
        } else return;
      }
      try {
        if (window.BGDesignerTelemetry && window.BGDesignerTelemetry.emitEvent) window.BGDesignerTelemetry.emitEvent('cart_add_once_late_result', 'cart', detail, 'high');
      } catch (_) {}
    }
    // A refused contender never adopts another operation's outcome: its state is
    // 'rejected'. When an add of this cart is journaled (sent, read back,
    // unresolved, handed off or quarantined) the customer is asked to check the
    // cart; when nothing is journaled, the cart is only busy.
    function rejectAdd(form, own, fromBridge) {
      if (own) {
        var ownOutcome = result(own);
        recovery(form, own); announce(ownOutcome, form);
        return Promise.resolve(ownOutcome);
      }
      var blocker = held();
      if (degraded) blocker = null;
      var uncertain = !!(blocker && isBlocking(blocker));
      var outcome = { state: 'rejected', blockedBy: blocker ? blocker.state : (replacing ? 'replacement' : 'busy'), opId: '',
        data: null, cart: null, recovery: uncertain, message: uncertain ? messageFor(blocker) : BUSY };
      if (uncertain) recovery(form, blocker);
      else if (form && fromBridge) {
        // The submit stopped here never reaches the form's own handler: show
        // the busy text in its product-form message box, and tell the runtime.
        try {
          var host = typeof form.closest === 'function' ? form.closest('product-form') : null;
          var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
          var text = wrapper && wrapper.querySelector('.product-form__error-message');
          if (text) { text.textContent = BUSY; wrapper.hidden = false; }
          form.dispatchEvent(new window.CustomEvent('bg:designer-cart-submit-state', {
            bubbles: true, detail: { state: 'error', stage: 'commerce-context', message: BUSY }
          }));
        } catch (_) {}
      }
      announce(outcome, form);
      return Promise.resolve(outcome);
    }
    // A guard's verdict: only an explicit ok (true or { ok: true }) lets the add go.
    function guardAllows(verdict) { return verdict === true || (!!verdict && typeof verdict === 'object' && verdict.ok === true); }
    async function execute(input, init, form, identity, intent, operation, guard, contended) {
      if (held() || cookieIdentity() !== identity) return rejectAdd(form);
      var baseline;
      try { baseline = await readCart(Date.now() + 5000); }
      catch (_) { var unavailable = result({ state: 'baseline-unavailable' }); announce(unavailable, form); return unavailable; }
      if (held() || cookieIdentity() !== identity) return rejectAdd(form);
      // The add the customer reviewed as missing (decision a3) may have landed
      // since: this baseline shows it -> nothing is sent; the customer is told,
      // and the next tap is a fresh add.
      try {
        // Every add the customer reviewed as missing on this device, under any
        // cart cookie (a sign-in merge may carry its line into a new cart).
        var prior = null;
        var reviewedPrior = false;
        var landedPrior = false, shown = false;
        var baseVariants = variantTotals(baseline.items);
        for (var k = 0, journals = journalNames(); k < journals.length && !landedPrior; k += 1) {
          var candidate = stored(journals[k]);
          if (!candidate || candidate.state !== 'acknowledged' || candidate.acknowledgeReason !== 'customer-cart-review' || candidate.lateLandedAt) continue;
          if (!prior || candidate.identity === identity) prior = candidate;
          reviewedPrior = true;
          if (candidate.intent && (candidate.baseline || candidate.before)) landedPrior = landed(candidate, baseline) !== 'none';
          else if (candidate.reviewedVariants) {
            // A legacy add (no intent): more of any variant than the cart the customer reviewed.
            landedPrior = Object.keys(baseVariants).some(function (variant) { return baseVariants[variant] > (candidate.reviewedVariants[variant] || 0); });
          }
          if (landedPrior) { prior = candidate; prior.identity = decodeURIComponent(journals[k].slice(PREFIX.length)); }
        }
        // An unseen "reached the cart" notice for this device refuses one tap.
        var earlierUnseen = null;
        try {
          earlierUnseen = JSON.parse(window.localStorage.getItem(NOTICE_KEY) || 'null');
          if (!earlierUnseen || earlierUnseen.kind !== 'earlier' || earlierUnseen.seenAt || earlierUnseen.refusedAt) earlierUnseen = null;
        } catch (_) { earlierUnseen = null; }
        if (earlierUnseen) {
          earlierUnseen.refusedAt = Date.now();
          try { window.localStorage.setItem(NOTICE_KEY, JSON.stringify(earlierUnseen)); } catch (_) { degrade(); }
          if (reviewedPrior) landedPrior = true;
          else {
            duplicateNotice(form, EARLIER); shown = true;
            var noticed = { state: 'rejected', blockedBy: 'late-landed', opId: '', data: null, cart: null, recovery: false, message: EARLIER };
            // Degraded mode: a notice, and the add goes on.
            if (!degraded) { announce(noticed, form); return noticed; }
          }
        }
        if (landedPrior) {
          prior.lateLandedAt = Date.now();
          persist(prior);
          duplicateNotice(form, EARLIER); shown = true;
          var arrived = { state: 'rejected', blockedBy: 'late-landed', opId: '', data: null, cart: null, recovery: false, message: EARLIER };
          if (!degraded) { announce(arrived, form); return arrived; }
        }
      } catch (_) {}
      // This request's send guard (captured in dispatch) decides last, after
      // every awaited read above and right before the journal and the send, once,
      // as guard(form, { operation }) with the caller's operation value: the page
      // checks that operation against its current choice. Anything but an
      // explicit ok (or a throw) is a pre-send refusal: nothing is journaled or
      // sent; the rejected outcome carries the page's reason and message (never
      // empty).
      if (guard) {
        var verdict;
        try { verdict = guard(form, { operation: operation }); } catch (_) { verdict = null; }
        if (!guardAllows(verdict)) {
          var guarded = { state: 'rejected', blockedBy: 'guard', opId: '', data: null, cart: null, recovery: false,
            reason: String((verdict && (verdict.reason || verdict.code)) || 'send-guard'), message: String((verdict && verdict.message) || BUSY) };
          announce(guarded, form);
          return guarded;
        }
      }
      var entry = { version: 1, opId: Date.now() + '-' + (++sequence) + '-' + Math.random().toString(36).slice(2),
        identity: identity, state: 'sent', sentAt: Date.now(), intent: intent, baseline: baseline.items.map(item) };
      entry.aliveAt = entry.sentAt;
      var duplicate = true; try { duplicate = contended || possibleDuplicate(entry, baseline); } catch (_) {} // before persist(); an error warns
      active = entry;
      if (!persist(entry)) { entry.state = 'quarantined'; return rejectAdd(form, entry); }
      if (degraded && !shown && duplicate) { duplicateNotice(form, TWICE); journalNotice(identity, 'twice'); }
      armRecovery(entry, form);
      // While the request is in flight this page stamps aliveAt and holds the
      // in-flight lock, so no other tab (and no later reload) can mistake a live
      // request for a gone one.
      var settle = watchInflight(entry);
      var deadline = entry.sentAt + 30000;
      var completed = false;
      var answer = null;
      var watchdog;
      // No abort or cleanup is evidence of server refusal. The original transport remains observed.
      var expiry = new Promise(function (resolve) {
        watchdog = window.setTimeout(function () { resolve(setState(entry, 'unresolved', form)); }, 30000);
      });
      var sent = Promise.resolve().then(function () { return transport(input, init); }).then(async function (response) {
        settle();
        void lateResult(entry, { ok: response.ok, status: response.status }, form);
        var data = null;
        try { data = await bounded(response.json(), 5000); } catch (_) {}
        answer = { data: data, errorStatus: response.status >= 400, status: response.status };
        if (completed && current(entry) && entry.state !== 'quarantined') {
          // A late answer confirmed by a read-back: say so (the page had shown
          // the recovery state; the next tap would otherwise repeat it).
          void reconcile(entry, Date.now() + 5000, answer, form).then(function (late) {
            if (late && late.state === 'handoff') duplicateNotice(form, EARLIER);
          });
        }
        return answer;
      }, function () { settle(); void lateResult(entry, { ok: false, status: 0 }, form); return null; });
      var work = bounded(sent, 5000).catch(function () { return null; }).then(function (value) {
        return reconcile(entry, deadline, value || answer, form);
      });
      var outcome = await Promise.race([work, expiry]);
      completed = true;
      window.clearTimeout(watchdog);
      return outcome;
    }
    async function dispatch(input, init, form, operation, requestGuard, existingCartOnly) {
      form = form || (preparation && preparation.form);
      // ARTWORK-FLOW-3: the request's guard is fixed here, before any await (a
      // later registration change affects later requests only). A per-request
      // guard replaces the form's registered one.
      var guard = typeof requestGuard === 'function' ? requestGuard : (form && sendGuards.get(form)) || null;
      if (refused(form)) return rejectAdd(form);
      acquiring = true;
      if (preparation) { window.clearTimeout(preparation.timer); preparation = null; }
      try {
        // Freeze mutable form/urlencoded bodies before the first asynchronous boundary.
        init = Object.assign({}, init || {});
        if (init.body && typeof init.body.entries === 'function') {
          var snapshot = new init.body.constructor();
          for (var pair of init.body.entries()) snapshot.append(pair[0], pair[1]);
          init.body = snapshot;
        }
        storageReady();
        var intent = await bounded(parseIntent(input, init), 5000);
        if (!intent.length || intent.some(function (line) { return !/^\d+$/.test(line.variant) || !Number.isSafeInteger(line.quantity) || line.quantity <= 0; })) return rejectAdd(form);
        var identity = cookieIdentity();
        if (!identity) {
          // Checked after the intent read and before any cart request: a request
          // that requires the existing cart never creates one. Nothing is sent,
          // journaled or held; its check is not asked.
          if (existingCartOnly) {
            var missing = { state: 'rejected', blockedBy: 'no-cart', opId: '', data: null, cart: null, recovery: false,
              reason: 'cart-missing', message: NO_CART };
            announce(missing, form);
            return missing;
          }
          var core = window.BGDesignerStorefrontCore;
          if (!core || !core.resolveDurableCartTokenHash) return rejectAdd(form);
          await bounded(core.resolveDurableCartTokenHash(), 5000);
          identity = cookieIdentity();
        }
        if (!identity || held()) return rejectAdd(form);
        var locks = window.navigator && window.navigator.locks;
        if (locks && typeof locks.request === 'function') {
          if (degraded && typeof locks.query === 'function' && await liveElsewhere(locks)) return rejectAdd(form);
          return await locks.request('bg-cart-add:' + identity, { mode: 'exclusive', ifAvailable: true }, function (lock) {
            return lock || degraded ? execute(input, init, form, identity, intent, operation, guard, !lock) : rejectAdd(form);
          });
        }
        if (!noLocksCounted) {
          noLocksCounted = true;
          // Ordinary pages may not load the telemetry client. Still emit the one page-level signal.
          try { doc.dispatchEvent(new window.CustomEvent('bg:cart-add-web-locks-unavailable', { detail: { count: 1 } })); } catch (_) {}
          try {
            if (window.BGDesignerTelemetry && window.BGDesignerTelemetry.emitEvent) window.BGDesignerTelemetry.emitEvent('cart_add_web_locks_unavailable', 'cart', {}, 'high');
          } catch (_) {}
        }
        return await execute(input, init, form, identity, intent, operation, guard);
      } catch (_) { return rejectAdd(form); }
      finally { acquiring = false; }
    }
    function isAdd(input, init) {
      try {
        var url = new URL(input && input.url || String(input), window.location.href);
        return url.origin === window.location.origin && /^(?:\/[a-z]{2}(?:-[a-z0-9]+)?)?\/cart\/add(?:\.js)?\/?$/i.test(url.pathname)
          && String(init && init.method || input && input.method || 'GET').toUpperCase() === 'POST';
      } catch (_) { return false; }
    }
    // A form submission is a cart add when its EFFECTIVE action (the submitter's
    // formaction, else the form's action) is this store's /cart/add, with any
    // method (Shopify also adds on a GET to /cart/add).
    function formAdd(form, submitter) {
      try {
        var action = submitter && typeof submitter.hasAttribute === 'function' && submitter.hasAttribute('formaction')
          ? submitter.getAttribute('formaction') : form.getAttribute('action');
        var method = String((submitter && typeof submitter.getAttribute === 'function' && submitter.getAttribute('formmethod')) || form.getAttribute('method') || 'get').toLowerCase();
        if (method === 'dialog') return false;
        var url = new URL(action || '', window.location.href);
        return url.origin === window.location.origin && /^(?:\/[a-z]{2}(?:-[a-z0-9]+)?)?\/cart\/add(?:\.js)?\/?$/i.test(url.pathname);
      } catch (_) { return false; }
    }
    // A form is the owner's when its product-form element runs the owner-aware
    // class (it calls runAdd), even if that element was built before this owner
    // installed (script order differs between sections).
    function isOwnerForm(form) {
      if (forms.has(form)) return true;
      var host = form && typeof form.closest === 'function' ? form.closest('product-form') : null;
      if (host && host.form === form && host.bgCartAddOnceAware === true) { forms.add(form); return true; }
      return false;
    }
    function quarantineLegacy() {
      if (active || acquiring || preparation) return;
      // Never write over an operation already journaled for this cart.
      if (blocked()) return;
      // A legacy (old-class) form is busy only while its add is in flight
      // (.loading); a disabled button alone is a sold-out or validation state.
      var legacy = Array.prototype.find.call(doc.querySelectorAll('product-form form'), function (form) {
        return !isOwnerForm(form) && form.querySelector('[type="submit"].loading');
      });
      if (!legacy) return;
      var entry = { version: 1, opId: 'legacy-' + Date.now(), identity: cookieIdentity(), state: 'quarantined', sentAt: Date.now(), aliveAt: Date.now() };
      active = entry;
      persist(entry); armRecovery(entry, legacy);
      // The old form's own request is live until its button stops loading; this
      // page stands in for it (heartbeat + in-flight lock) until then.
      var settle = watchInflight(entry);
      var button = legacy.querySelector('[type="submit"].loading');
      // Only that same button, still on the page, ending its loading state is the
      // old request settling. A replaced or removed button proves nothing: the
      // page keeps standing in for the request until it unloads.
      var check = function () {
        if (button.isConnected && !button.classList.contains('loading')) { settle(); void legacyLate(entry, legacy); return true; }
        return false;
      };
      if (!check() && typeof window.MutationObserver === 'function') {
        var observer = new window.MutationObserver(function () { if (check()) observer.disconnect(); });
        observer.observe(button, { attributes: true, attributeFilter: ['class'] });
        observer.observe(legacy, { childList: true, subtree: true });
      }
    }
    function variantTotals(lines) {
      var output = Object.create(null);
      (lines || []).forEach(function (line) {
        var value = line && line.variant !== undefined ? line : item(line || {});
        output[value.variant] = (output[value.variant] || 0) + Number(value.quantity || 0);
      });
      return output;
    }
    // A watched legacy add that completes after its hold was reviewed by the
    // customer (or released): its item is unknown, so a conservative read-back
    // compares every variant with what should be there (the newer add's
    // baseline plus its intent, else the cart the customer reviewed). More of any
    // variant (or an unreadable cart) -> the notice, journaled so the next page
    // shows it too. Nothing in the cart is changed.
    var LEGACY_CHECK_KEY = 'bg:cart-add-once-legacy-check';
    function newestJournal(after) {
      var newest = null;
      for (var i = 0, names = journalNames(); i < names.length; i += 1) {
        var value = stored(names[i]);
        if (value && (!newest || (value.sentAt || 0) > (newest.sentAt || 0))) newest = value;
      }
      return newest && (newest.sentAt || 0) > (after || 0) ? newest : null;
    }
    function legacyLate(entry, form) {
      if (current(entry)) return;
      var saved;
      try { saved = stored(key(entry.identity)); } catch (_) { saved = null; }
      // The newer add may live under another cart key (a legacy page can journal
      // before the cart cookie exists).
      var newer = newestJournal(entry.sentAt || 0);
      if (newer && newer.opId === entry.opId) newer = null;
      var reviewed = saved && saved.opId === entry.opId && (saved.state === 'released' || saved.acknowledgeReason === 'customer-cart-review') ? saved : null;
      if (!newer && !reviewed) return;
      // Proven quantities only (Astra RCARTADD7): a newer add counts its intent
      // only when a read-back verified it complete (hand-off); a pending,
      // refused or partial one proves nothing beyond its baseline, so any
      // increase over that baseline warns.
      var expected = null;
      if (newer && (newer.baseline || newer.before)) {
        expected = newer.baseline ? variantTotals(newer.baseline) : Object.assign({}, newer.baselineVariants);
        var proven = newer.state === 'handoff' || (newer.state === 'acknowledged' && !newer.acknowledgeReason);
        if (proven && newer.intent) newer.intent.forEach(function (line) { expected[line.variant] = (expected[line.variant] || 0) + Number(line.quantity || 0); });
      } else if (!newer && reviewed.reviewedVariants) expected = reviewed.reviewedVariants;
      // Journaled before the read: the old form navigates to the cart at once, and
      // the next page finishes the check.
      var check = { opId: entry.opId, kind: newer ? 'twice' : 'earlier', expected: expected, at: Date.now() };
      try { window.localStorage.setItem(LEGACY_CHECK_KEY, JSON.stringify(check)); } catch (_) {}
      return finishLegacyCheck(check, form);
    }
    function resumeLegacyCheck() {
      try {
        var check = JSON.parse(window.localStorage.getItem(LEGACY_CHECK_KEY) || 'null');
        if (check && check.opId) void finishLegacyCheck(check, null);
      } catch (_) {}
    }
    async function finishLegacyCheck(check, form) {
      var expected = check.expected;
      var kind = check.kind;
      var entry = { opId: check.opId };
      var cart = null;
      try { cart = await readCart(Date.now() + 5000); } catch (_) {}
      var more = !cart || !expected;
      if (cart && expected) {
        var now = variantTotals(cart.items);
        more = Object.keys(now).some(function (variant) { return now[variant] > (expected[variant] || 0); });
      }
      if (cart) { try { window.localStorage.removeItem(LEGACY_CHECK_KEY); } catch (_) {} }
      if (!more) return;
      duplicateNotice(form, kind === 'twice' ? TWICE : EARLIER);
      journalNotice('', kind);
      if (onCartPage()) showJournaledNotice();
      try {
        if (window.BGDesignerTelemetry && window.BGDesignerTelemetry.emitEvent) window.BGDesignerTelemetry.emitEvent('cart_add_once_late_result', 'cart', { opId: entry.opId, outcome: 'legacy-' + kind }, 'high');
      } catch (_) {}
    }
    function releasePreparation(form) {
      if (preparation && preparation.form === form) { window.clearTimeout(preparation.timer); preparation = null; }
    }
    function clearHandoff(entry) {
      if (!current(entry) || entry.state !== 'handoff') return false;
      try {
        // Keep an acknowledgement tombstone so a suspended old owner cannot resurrect this operation.
        entry.state = 'acknowledged';
        if (!persist(entry)) { entry.state = 'handoff'; return false; }
        if (active && active.opId === entry.opId) active = null;
        clearRecoveryUi();
        return true;
      } catch (_) { return false; }
    }
    // Check again: a fresh cart read. The whole intended add in the cart settles
    // it as success (the customer goes to the cart). An UNRESOLVED add with no
    // trace in the cart whose sender is provably gone for two minutes is
    // released (the one bounded exception to "uncertainty never expires"). A
    // partial add, a live request, or a quarantined add is never released here.
    async function checkAgain() {
      var entry = blocked();
      if (!entry) { clearRecoveryUi(); return { state: 'idle' }; }
      // A new cart cookie: checkout or expiry starts an empty cart, but a sign-in
      // merge carries the lines over. The same cart proof decides either way.
      var rotated = cookieIdentity() !== entry.identity;
      var known = !!(entry.intent && (entry.baseline || entry.before));
      if (rotated || ((entry.state === 'unresolved' || entry.state === 'quarantined') && known)) {
        var cart;
        try { cart = await readCart(Date.now() + 5000); } catch (_) { recovery(null, entry); return result(entry); }
        var latest = stored(key(entry.identity));
        if (!latest || latest.opId !== entry.opId || !isBlocking(latest)) return result(latest || entry);
        entry = latest;
        if (!known) {
          // A legacy add under a new cookie: released only without a line of its
          // item; Check again never acknowledges it (the cart page does).
          if (!legacyTrace(entry, cart)) {
            var legacyGone = await releasable(entry);
            if (legacyGone) return release(entry, 'cart-identity-rotated', legacyGone);
          }
          recovery(null, entry);
          return result(entry);
        }
        var state = landed(entry, cart);
        markPartial(entry, state === 'partial');
        if (state === 'complete') {
          var data = cart.items.find(function (line) { return signature(item(line)) === signature(entry.intent[0]); });
          var settled = setState(entry, 'handoff', null, data, cart, true);
          if (settled.state === 'handoff') window.location.assign(cartRoot() + 'cart');
          return settled;
        }
        if (state === 'none' && (entry.state === 'unresolved' || rotated)) {
          var gone = await releasable(entry);
          if (gone) return release(entry, rotated ? 'cart-identity-rotated' : 'request-gone-cart-without-trace', gone);
        }
        // A partial add is never acknowledged here (Director decision b).
        recovery(null, entry);
        return result(entry);
      }
      return reconcile(entry, Date.now() + 5000, null, null);
    }
    // The customer is on the cart page: a fresh read reviews the open add. A
    // hand-off, or an add whose whole intent is in the cart (customer edits
    // aside), is acknowledged. Once its sender is provably gone two minutes: an
    // add with no trace is released; a partial add, or a legacy add with a line
    // of its item, is acknowledged (the customer reviewed it here). Until then it
    // stays on hold.
    async function cartArrival() {
      var entry = blocked();
      if (!entry || !onCartPage()) return;
      // A request that is still being sent is left alone, unless it has been
      // silent long enough for the customer review (its page may be gone).
      if (['handoff', 'unresolved', 'quarantined'].indexOf(entry.state) === -1 && !customerReviewable(entry)) return;
      try {
        var reviewed = await readCart(Date.now() + 5000);
        // Still the cart page after the read (a same-document navigation may
        // have left it): otherwise no cart-page decision is taken.
        if (!onCartPage()) return;
        var saved = stored(key(entry.identity));
        if (!saved || saved.opId !== entry.opId || !isBlocking(saved)) return;
        if (saved.state === 'handoff') { clearHandoff(saved); return; }
        // A new cart cookie changes only the release reason: the reviewed read
        // of the (possibly merged) cart decides, as for the same cart.
        var rotated = cookieIdentity() !== saved.identity;
        var reason = rotated ? 'cart-identity-rotated' : 'cart-page-review';
        var gone;
        // Legacy add (Director decisions c and d): request proof AND cart proof
        // releases it; with a line of its item in the cart it is acknowledged.
        if (!saved.intent || !saved.baseline) {
          if ((gone = await releasable(saved))) {
            if (!onCartPage()) return;
            if (legacyTrace(saved, reviewed)) acknowledgeReviewed(saved, 'legacy-reviewed', gone);
            else release(saved, reason, gone);
            return;
          }
          holdOnCartPage(saved, reviewed); return;
        }
        var state = landed(saved, reviewed);
        markPartial(saved, state === 'partial');
        if (state === 'complete') { saved.state = 'handoff'; if (persist(saved)) clearHandoff(saved); return; }
        if (state === 'none' && (gone = await releasable(saved))) { if (onCartPage()) release(saved, reason, gone); return; }
        if (state === 'partial' && (gone = await releasable(saved))) { if (onCartPage()) acknowledgeReviewed(saved, 'partial-reviewed', gone); return; }
        holdOnCartPage(saved, reviewed);
      } catch (_) { recovery(null); }
    }
    // Decision (a3): a hold no proof can clear (no Web Locks, ten minutes of
    // silence) is offered to the customer, on the cart page only, with the cart
    // shown below: one explicit control journals it as reviewed by the customer.
    function holdOnCartPage(entry, reviewed) {
      if (!onCartPage()) return;
      if (!customerReviewable(entry)) { recovery(null, entry); return; }
      // The cart the customer is shown with the control (legacy adds have no
      // intent: the tap compares against it).
      if (reviewed) { entry.offeredVariants = variantTotals(reviewed.items); persist(entry); }
      try {
        Array.prototype.forEach.call(doc.querySelectorAll('[data-bg-cart-add-recovery]'), function (node) { node.remove(); });
        var panel = doc.createElement('div');
        panel.setAttribute('data-bg-cart-add-recovery', '');
        panel.setAttribute('data-bg-cart-add-review', '');
        panel.setAttribute('role', 'alert');
        var message = doc.createElement('p');
        message.textContent = REVIEW_TEXT;
        var confirm = doc.createElement('button');
        confirm.type = 'button';
        confirm.className = 'button button--secondary';
        confirm.textContent = REVIEW_BUTTON;
        confirm.addEventListener('click', function () {
          confirm.disabled = true;
          customerReviewed(entry).then(function (done) {
            if (done) return;
            // A failed cart read keeps the panel as it is.
            if (done === null) { confirm.disabled = false; return; }
            // Refused (the sender came back, or the add settled meanwhile): say why.
            var latest = blocked();
            panel.remove();
            if (latest) recovery(null, latest);
            else clearRecoveryUi();
          });
        });
        panel.appendChild(message); panel.appendChild(confirm);
        var top = cartPageHost();
        top.insertBefore(panel, top.firstChild);
      } catch (_) { recovery(null, entry); }
    }
    // The customer's review is taken on a fresh read, never on the arrival read:
    // the add may have landed meanwhile (a frozen tab resumed). The whole add in
    // the cart -> a completed add (acknowledged); part of it -> the partial is
    // acknowledged; only nothing of it -> reviewed as missing. Returns true when
    // done, null when the read failed (the panel stays), false when refused.
    async function customerReviewed(entry) {
      var saved;
      try { saved = stored(key(entry.identity)); } catch (_) { return false; }
      if (!saved || saved.opId !== entry.opId || !isBlocking(saved) || !onCartPage()) return false;
      if (saved.state !== 'handoff' && !customerReviewable(saved)) return false;
      var cart;
      try { cart = await readCart(Date.now() + 5000); } catch (_) { return null; }
      // Still the cart page after the read, or no decision (Astra RCARTADD7).
      if (!onCartPage()) return false;
      try { saved = stored(key(entry.identity)); } catch (_) { return false; }
      if (!saved || saved.opId !== entry.opId || !isBlocking(saved)) return false;
      // A legacy add (no intent): more of any variant than the cart the control
      // was offered with (else, without that record, any line) means it reached
      // the cart: say so and reload. A settled request with no growth (it may
      // have been refused) is acknowledged silently, as on cart arrival.
      if (saved.state !== 'handoff' && !(saved.intent && saved.baseline)) {
        var nowVariants = variantTotals(cart.items);
        var grew = saved.offeredVariants
          ? Object.keys(nowVariants).some(function (variant) { return nowVariants[variant] > (saved.offeredVariants[variant] || 0); })
          : legacyTrace(saved, cart);
        if (grew) {
          if (!acknowledgeReviewed(saved, 'legacy-reviewed', 'customer-cart-review')) return false;
          duplicateNotice(null, EARLIER);
          journalNotice('', 'earlier');
          reloadCartPage();
          return true;
        }
        if (saved.settledAt) return acknowledgeReviewed(saved, 'legacy-reviewed', 'customer-cart-review');
      }
      var state = saved.state === 'handoff' ? 'complete' : saved.intent && saved.baseline ? landed(saved, cart) : 'none';
      // The cart just read differs from the one on screen: the notice is
      // journaled and the cart page reloads at once (no tap can come between),
      // so the customer sees the line before adding again (Astra RCARTADD7).
      if (state === 'complete') {
        saved.state = 'handoff';
        if (!persist(saved) || !clearHandoff(saved)) return false;
        duplicateNotice(null, EARLIER);
        journalNotice('', 'earlier');
        reloadCartPage();
        return true;
      }
      if (state === 'partial') {
        if (!acknowledgeReviewed(saved, 'partial-reviewed', 'customer-cart-review')) return false;
        duplicateNotice(null, PARTIAL);
        journalNotice('', 'partial');
        reloadCartPage();
        return true;
      }
      if (!customerReviewable(saved)) return false;
      saved.reviewedVariants = variantTotals(cart.items);
      persist(saved);
      return acknowledgeReviewed(saved, 'customer-cart-review', 'customer-cart-review');
    }
    var owner = window.BGCartAddOnce = {
      revision: '20260928-1',
      recoveryMessage: RECOVERY,
      runAdd: function (options) {
        options = options || {};
        var init = Object.assign({ method: 'POST', credentials: 'same-origin' }, options.config || {});
        if (options.formData) init.body = options.formData;
        // options.operation: the caller's opaque value for this add, handed to its
        // send guard with the send; options.sendGuard: this add's own guard, in
        // place of the form's registered one (ARTWORK-FLOW-3);
        // options.existingCartOnly: add only into the existing cart, never create one.
        return dispatch(options.url || cartRoot() + 'cart/add.js', init, options.form, options.operation,
          typeof options.sendGuard === 'function' ? options.sendGuard : null, options.existingCartOnly === true);
      },
      registerForm: function (form) { forms.add(form); },
      // ARTWORK-FLOW-3: a form's send guard (a function; anything else removes it).
      acceptsSendGuard: true,
      setSendGuard: function (form, guard) {
        if (!form) return;
        if (typeof guard === 'function') sendGuards.set(form, guard);
        else sendGuards.delete(form);
      },
      // A registered product form preparing its add (context save, signing):
      // other forms are refused until it sends or finishes. Release-only
      // timer: nothing was sent, so this never becomes a recovery state.
      beginPreparation: function (form) {
        if (preparation && preparation.form !== form && !degraded) return false;
        releasePreparation(form);
        preparation = { form: form, timer: window.setTimeout(function () { releasePreparation(form); }, 60000) };
        return true;
      },
      finishPreparation: releasePreparation,
      showRecovery: recovery,
      isDegraded: function () { return degraded; },
      getState: function () { return (blocked() || {}).state || (acquiring || preparation ? 'busy' : replacing ? 'replacement' : 'idle'); },
      subscribe: function (form, callback) {
        var listener = { form: form, callback: callback }; listeners.push(listener);
        return function () { listeners = listeners.filter(function (value) { return value !== listener; }); };
      },
      checkAgain: checkAgain,
      verifyReplacementRemoval: async function (opId, lineKey) {
        var entry = blocked();
        if (!entry || entry.opId !== opId || entry.state !== 'handoff' || !entry.baseline) return false;
        var original = entry.baseline.find(function (line) { return line.key === lineKey; });
        if (!original) return false;
        var adjusted = Object.assign({}, entry, { baseline: entry.baseline.filter(function (line) { return line.key !== lineKey; }) });
        var cart = await readCart(Date.now() + 5000);
        if (!current(entry) || cookieIdentity() !== entry.identity || compare(adjusted, cart) !== 'exact') return false;
        entry.baseline = adjusted.baseline;
        return persist(entry);
      },
      // This is a synchronous reservation, not a wait-then-replace promise. No add can enter the gap.
      reserveReplacement: function () {
        quarantineLegacy();
        if (refused(null)) return null;
        replacing = true;
        return { release: function () { replacing = false; } };
      },
      whenReplaceable: function () { quarantineLegacy(); return Promise.resolve(!refused(null)); },
      acknowledgeDrawer: async function (opId, drawer) {
        var entry = blocked();
        if (!entry || entry.opId !== opId || entry.state !== 'handoff' || !drawer || !drawer.isConnected) return false;
        // Dawn opens its drawer in two timer turns. Observe its acknowledgement once, never poll the cart count.
        await new Promise(function (resolve) { window.setTimeout(resolve, 0); });
        await new Promise(function (resolve) { window.setTimeout(resolve, 0); });
        var opened = drawer.classList.contains('active') || !!drawer.querySelector('#cart-notification.active');
        if (!opened) return false;
        try {
          var cart = await readCart(Date.now() + 5000);
          if (cookieIdentity() !== entry.identity || compare(entry, cart) !== 'exact') return false;
          var lines = cart.items.filter(function (line) { return entry.intent.some(function (intent) { return signature(item(line)) === signature(intent); }); });
          var rendered = lines.every(function (line) {
            return Array.prototype.some.call(drawer.querySelectorAll('[data-key], [data-line-key], [id]'), function (node) {
              return node.getAttribute('data-key') === line.key || node.getAttribute('data-line-key') === line.key || node.id === 'cart-notification-product-' + line.key;
            });
          });
          // Notification strips the keyed wrapper while rendering. Its retained key is the explicit acknowledgement.
          if (!rendered && !(drawer.cartItemKey && lines.length === 1 && drawer.cartItemKey === lines[0].key && drawer.querySelector('#cart-notification-product')?.textContent.trim())) return false;
          return clearHandoff(entry);
        } catch (_) { return false; }
      }
    };
    if (pageHasFetch) window.fetch = function (input, init) {
      if (!isAdd(input, init)) return transport(input, init);
      return dispatch(input, init).then(function (outcome) {
        if (outcome.state === 'handoff') return new Response(JSON.stringify(outcome.data || {}), { status: 200, headers: { 'content-type': 'application/json' } });
        return new Response(JSON.stringify({ status: 409, message: outcome.message, description: outcome.message }), { status: 409, headers: { 'content-type': 'application/json' } });
      });
    };
    // HTMLFormElement.submit() bypasses the submit event (including the runtime's native fallback).
    var formPrototype = window.HTMLFormElement && window.HTMLFormElement.prototype;
    if (formPrototype) {
      var nativeSubmit = formPrototype.submit;
      formPrototype.submit = function () {
        if (!formAdd(this, null)) return nativeSubmit.apply(this, arguments);
        var form = this;
        void owner.runAdd({ form: form, formData: new window.FormData(form) }).then(function (outcome) {
          if (outcome.state === 'handoff') window.location.assign(cartRoot() + 'cart');
        });
      };
    }
    // Remember the purchase control the customer used (the recovery panel goes
    // beside it).
    var trackAddControl = function (event) {
      var node = event.target && typeof event.target.closest === 'function' ? event.target.closest('button, [role="button"]') : null;
      if (node && (/add to cart|adding/i.test(node.textContent || '') || (node.form && formAdd(node.form, node)))) lastAddControl = node;
    };
    window.addEventListener('pointerdown', trackAddControl, true);
    window.addEventListener('click', trackAddControl, true);
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || !formAdd(form, event.submitter)) return;
      quarantineLegacy();
      if (refused(form)) {
        event.preventDefault(); event.stopImmediatePropagation(); void rejectAdd(form, null, true); return;
      }
      if (!form.closest('product-form') && form.dataset.bgDesignerCompletionBound !== '1') {
        event.preventDefault(); event.stopImmediatePropagation();
        void owner.runAdd({ form: form, formData: new window.FormData(form) }).then(function (outcome) {
          if (outcome.state === 'handoff') window.location.assign(cartRoot() + 'cart');
        });
        return;
      }
      // A registered product form or the storefront runtime gates this submit
      // (validation, uploads, completion check, preparation). Nothing is sent
      // and nothing is uncertain yet, so the owner starts no timer here: a
      // click the page refuses must never turn into a recovery state later.
      event.preventDefault();
    }, true);
    // A runtime-gated form without a registered product form: the runtime's
    // own prepared dispatch is the one submit that reaches the window (its
    // original submit is stopped by the runtime). The owner sends that add.
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || !formAdd(form, event.submitter)) return;
      if (isOwnerForm(form) || form.dataset.bgDesignerCompletionBound !== '1') return;
      event.preventDefault();
      if (refused(null)) { void rejectAdd(form, null, true); return; }
      void owner.runAdd({ form: form, formData: new window.FormData(form) }).then(function (outcome) {
        if (outcome.state === 'handoff') window.location.assign(cartRoot() + 'cart');
      });
    }, false);
    // A real unload (not a BFCache freeze) ends this page's requests: record it
    // so another tab can later prove the sender gone.
    window.addEventListener('pagehide', function (event) {
      if (event && event.persisted) return;
      inflightHere.slice().forEach(function (entry) { markJournal(entry, { pageGoneAt: Date.now() }); });
    });
    // Another tab (or a restored page) may have settled the add: nothing open ->
    // this page's recovery controls go and the forms it disabled work again.
    function reviewOpenAdd() {
      var entry = blocked();
      if (entry) armRecovery(entry, null);
      else if (!acquiring && !preparation) clearRecoveryUi();
      showJournaledNotice();
      resumeLegacyCheck();
    }
    window.addEventListener('pageshow', function () { quarantineLegacy(); reviewOpenAdd(); void cartArrival(); });
    window.addEventListener('storage', function (event) { if (!event.key || event.key.indexOf(PREFIX) === 0) reviewOpenAdd(); });
    function restore() { quarantineLegacy(); var entry = blocked(); if (entry) armRecovery(entry, null); showJournaledNotice(); resumeLegacyCheck(); void cartArrival(); }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', restore, { once: true });
    else restore();
  }

  var JSON_CACHE = Object.create(null);
  var BOOTSTRAP_PROMISES = Object.create(null);
  var BOOTSTRAP_PREWARM_FAILURES = Object.create(null);
  var SHELL_PROMISES = Object.create(null);
  var TEMPLATE_SUMMARY_PROMISES = Object.create(null);
  var CART_STATE_PROMISE = null;
  var LIGHTBOX_ID = 'bg-designer-storefront-preview-lightbox';
  var CART_TRANSFORM_STATE_MAP_KEY = 'bg_cart_transform_state_map_v1';
  var LEGACY_CART_TRANSFORM_STATE_MAP_KEY = '_bg_cart_transform_state_map_v1';
  // The editor-shell loading scrim is opaque, so a lost or foreign ready
  // message must never strand the customer behind it. Mirrors the 12s
  // shell-document-warm and product-editor-config watchdog windows.
  var EDITOR_SHELL_LOADING_WATCHDOG_MS = 12000;

  function text(value) {
    return String(value || '').trim();
  }

  function numberValue(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function roundMoney(value) {
    return Number(numberValue(value, 0).toFixed(2));
  }

  // EDDM-ROUTE-CENT (2026-10-02): the quote engine's money arithmetic
  // (apps/api foundation-authoritative-commerce-quote.ts moneyMicros,
  // roundRatio, centsFromMicros). The amount as authored becomes whole micros,
  // is scaled by numerator / denominator with one half-up integer division and
  // is rounded once to the cent, half away from zero. EXACT-CENTS-PR3
  // (2026-10-04): every product price, add-on and line is built with it; no
  // flag selects another arithmetic.
  var MONEY_MICROS_PER_UNIT = 1000000;
  var MONEY_MICROS_PER_CENT = 10000;

  function divideHalfAwayFromZero(value, divisor) {
    if (typeof value === 'bigint') {
      var half = divisor / BigInt(2);
      return value >= BigInt(0) ? (value + half) / divisor : -((-value + half) / divisor);
    }
    var negative = value < 0;
    var adjusted = (negative ? -value : value) + Math.floor(divisor / 2);
    var quotient = Math.floor(adjusted / divisor);
    var remainder = adjusted - (quotient * divisor);
    if (remainder < 0) quotient -= 1;
    else if (remainder >= divisor) quotient += 1;
    return negative ? -quotient : quotient;
  }

  function scaleMoney(value, numerator, denominator) {
    var amount = Number(value);
    var top = numerator === undefined ? 1 : Number(numerator);
    var bottom = denominator === undefined ? 1 : Number(denominator);
    if (!Number.isFinite(amount) || !Number.isSafeInteger(top) || !Number.isSafeInteger(bottom) || top < 0 || bottom <= 0) return NaN;
    var micros = Math.round(amount * MONEY_MICROS_PER_UNIT);
    if (!Number.isSafeInteger(micros)) return NaN;
    if (typeof BigInt === 'function') {
      var exactMicros = BigInt(micros);
      var exactScaled = top === bottom ? exactMicros : divideHalfAwayFromZero(exactMicros * BigInt(top), BigInt(bottom));
      return Number(divideHalfAwayFromZero(exactScaled, BigInt(MONEY_MICROS_PER_CENT))) / 100;
    }
    var product = micros * top;
    if (!Number.isSafeInteger(Math.abs(product) + bottom)) return roundMoney(amount * (top / bottom));
    var scaled = top === bottom ? micros : divideHalfAwayFromZero(product, bottom);
    return divideHalfAwayFromZero(scaled, MONEY_MICROS_PER_CENT) / 100;
  }

  // EXACT-CENTS-PLAN-PERCENT (2026-10-04): a plan or staff tier percentage on
  // money is the quote engine's percentOfCents (foundation-authoritative-
  // commerce-quote.ts calculateTierPrices): the amount in whole cents, times the
  // share kept, one half-up integer division. discountPct is a fraction (0.05)
  // or, above 1, a percent (50). A whole-cent amount times basis points over
  // 10,000 is exact in scaleMoney's micros.
  function keepShareOfMoney(amount, discountPct) {
    var pct = numberValue(discountPct, 0);
    var share = pct > 1 ? pct / 100 : pct;
    var keepBps = Math.min(10000, Math.max(0, Math.round((1 - share) * 10000)));
    var cents = scaleMoney(amount, 1, 1);
    return Number.isFinite(cents) ? scaleMoney(cents, keepBps, 10000) : NaN;
  }

  // FUNCTIONS-CURRENCY-AWARE (2026-10-12): the shop-to-presentment rule of the
  // Cart Transform and the checkout Validation, copied from the control plane's
  // exact_money.js (parsePresentmentRate, presentmentCents) so the page shows
  // what the cart charges in the shopper's currency:
  //
  //   presentmentCents = floor((shopCents x R + floor(P / 2)) / P)
  //
  // for a rate text that is exactly R / P (R its digits without the point, P ten
  // to the number of fraction digits; ^[0-9]{1,6}(\.[0-9]{1,18})?$ with R above
  // 0): one half-up division of exact integers, never a float. A rate of exactly
  // 1 returns the shop cents unchanged; any other text is unusable (null). Both
  // functions are the control plane's byte for byte in behavior: the control
  // plane's tests/presentment-cents.vectors.json is the one table every copy
  // reproduces (tests/bg-presentment-cents.test.mjs). presentmentCents takes
  // whole shop cents, 0 or more; the page converts through presentmentCentsOf.
  var PRESENTMENT_IDENTITY_RATE = { identity: true, digits: '1', units: 1, scale: 1, half: 0 };

  function parsePresentmentRate(rateText) {
    if (rateText === '1.0') return PRESENTMENT_IDENTITY_RATE;
    var match = typeof rateText === 'string' && /^([0-9]{1,6})(?:\.([0-9]{1,18}))?$/.exec(rateText);
    if (!match) return null;
    var digits = match[1] + (match[2] || '');
    var units = Number(digits);
    var scale = Number('1e' + (digits.length - match[1].length));
    return units > 0 ? { identity: units === scale && digits.length < 16, digits: digits, units: units, scale: scale, half: scale > 1 ? scale / 2 : 0 } : null;
  }

  function presentmentCents(shopCents, rate) {
    if (!rate) return NaN;
    if (rate.identity) return shopCents;
    var adjusted = shopCents * rate.units + rate.half;
    if (adjusted <= 9007199254740991) return (adjusted - (adjusted % rate.scale)) / rate.scale;
    if (!Number.isSafeInteger(shopCents) || typeof BigInt !== 'function') return NaN;
    var exact = Number((BigInt(shopCents) * BigInt(rate.digits) + BigInt(rate.half)) / BigInt(rate.scale));
    return Number.isSafeInteger(exact) ? exact : NaN;
  }

  // Whole cents of an amount as authored, half away from zero (exact_money.js
  // moneyCents); NaN when its micros are not a safe integer.
  function moneyCents(amount) {
    var micros = Math.round(Number(amount) * MONEY_MICROS_PER_UNIT);
    return Number.isSafeInteger(micros) ? divideHalfAwayFromZero(micros, MONEY_MICROS_PER_CENT) : NaN;
  }

  function parseJson(value, fallback) {
    try {
      return JSON.parse(String(value || ''));
    } catch (_) {
      return fallback;
    }
  }

  function deepClone(value, fallback) {
    try {
      return JSON.parse(JSON.stringify(value === undefined ? fallback : value));
    } catch (_) {
      return fallback;
    }
  }

  function encodeJsonParam(value) {
    if (!value || typeof value !== 'object') return '';
    try {
      return window.btoa(unescape(encodeURIComponent(JSON.stringify(value))));
    } catch (_) {
      return '';
    }
  }

  function normalizeProductPageExperimentContext(value) {
    var source = value && typeof value === 'object' && !Array.isArray(value) ? value : null;
    if (!source || source.version !== 1 || typeof source.presentation !== 'string' || typeof source.formattedPrice !== 'string') return null;
    var presentation = text(source.presentation).toLowerCase();
    if (presentation !== 'intent_first') return null;
    var formattedPrice = text(source.formattedPrice).slice(0, 32);
    var summaryParts = Array.isArray(source.summaryParts)
      ? source.summaryParts.map(function (entry) { return text(entry).slice(0, 80); }).filter(Boolean).slice(0, 6)
      : [];
    if (!formattedPrice) return null;
    return {
      version: 1,
      presentation: presentation,
      formattedPrice: formattedPrice,
      summaryParts: summaryParts
    };
  }

  // Copy and convert (2026-09-09): the product page's request to copy a
  // started design and convert the copy to the newly chosen style. Bounded
  // and validated here and again by the designer API; the editor applies it.
  function normalizeStyleConversionContext(value) {
    var source = value && typeof value === 'object' && !Array.isArray(value) ? value : null;
    if (!source || source.version !== 1) return null;
    var sourceProjectId = text(source.sourceProjectId).slice(0, 128);
    var holderId = text(source.holderId).slice(0, 120);
    var toValueId = text(source.toValueId).slice(0, 120);
    if (!sourceProjectId || !holderId || !toValueId) return null;
    var targetSelections = Array.isArray(source.targetSelections)
      ? source.targetSelections.map(function (entry) {
        var record = entry && typeof entry === 'object' ? entry : {};
        return { holderId: text(record.holderId).slice(0, 120), valueId: text(record.valueId).slice(0, 120) };
      }).filter(function (entry) { return entry.holderId && entry.valueId; }).slice(0, 24)
      : [];
    return {
      version: 1,
      sourceProjectId: sourceProjectId,
      holderId: holderId,
      fromValueId: text(source.fromValueId).slice(0, 120),
      toValueId: toValueId,
      fromLabel: text(source.fromLabel).slice(0, 120),
      toLabel: text(source.toLabel).slice(0, 120),
      targetSelections: targetSelections
    };
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function slugify(value) {
    return text(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function uniqueStrings(values) {
    var seen = Object.create(null);
    return (Array.isArray(values) ? values : []).map(text).filter(function (entry) {
      if (!entry || seen[entry]) return false;
      seen[entry] = true;
      return true;
    });
  }

  function normalizeArtworkMode(value) {
    var normalized = text(value).toLowerCase();
    if (!normalized) return '';
    if (
      normalized === 'designonline'
      || normalized === 'customize online'
      || normalized === 'design online'
      || normalized === 'edit artwork'
    ) {
      return 'designonline';
    }
    if (normalized === 'editservice' || normalized === 'template edit service') {
      return 'editservice';
    }
    if (normalized === 'uploadfiles' || normalized === 'upload artwork') {
      return 'uploadfiles';
    }
    if (normalized === 'uploadcanva' || normalized === 'upload canva pdf') {
      return 'uploadcanva';
    }
    if (normalized === 'share canva link' || normalized === 'share canva design' || normalized === 'share canva') {
      return 'uploadcanva';
    }
    if (
      normalized === 'youhaveart'
      || normalized === 'i have artwork'
      || normalized === 'send artwork after checkout'
      || normalized === 'send artwork later'
      || normalized === 'order now, send artwork later'
      || normalized === 'artwork coming later'
    ) {
      return 'youhaveart';
    }
    if (normalized === 'customdesign' || normalized === 'need a custom design' || normalized === 'custom design' || normalized === 'pro design') {
      return 'customdesign';
    }
    if (normalized === 'reorder' || normalized === 're-order') {
      return 'reorder';
    }
    if (normalized === 'recreate' || normalized === 'recreate a design' || normalized === 'recreate design' || normalized === 're-create design') {
      return 'recreate';
    }
    if (normalized === 'freesetup' || normalized === 'free setup' || normalized === 'free proof setup') {
      return 'freesetup';
    }
    return normalized;
  }

  function normalizeLaunchProvider(value) {
    var normalized = text(value).toLowerCase();
    if (!normalized) return '';
    if (normalized === 'pitchprint-legacy') return 'pitchprint';
    if (normalized === 'pitchprint') return 'pitchprint';
    if (normalized === 'self-hosted') return 'self-hosted';
    return normalized;
  }

  function normalizeCartDesignEditor(value) {
    var normalized = text(value).toLowerCase().replace(/[\s_]+/g, '-');
    return normalized === 'pitchprint-mini' ? normalized : '';
  }

  function normalizeCartQuantityMode(value) {
    var normalized = text(value).toLowerCase();
    if (!normalized) return '';
    if (normalized === 'print_qty' || normalized === 'print-qty' || normalized === 'printqty') {
      return 'print_qty';
    }
    if (normalized === 'set_count' || normalized === 'set-count' || normalized === 'setcount') {
      return 'set_count';
    }
    return '';
  }

  // Storefront data reads (GET only; no write passes through here). A network
  // failure (TypeError, before the headers or while the body streams), an
  // attempt that runs out of time, 408, 429 or 5xx is tried again up to
  // LOAD_JSON_MAX_ATTEMPTS times with exponential backoff and jitter, never
  // sooner than Retry-After; a Retry-After longer than LOAD_JSON_MAX_DELAY_MS,
  // any other answer and a body that is not JSON are final. One read chain
  // (headers, body and waits together) ends within LOAD_JSON_TOTAL_BUDGET_MS,
  // below the runtime's 12 s setup-data watchdog, so the watchdog never starts a
  // second, overlapping chain; each attempt is cut off (and aborted) after
  // LOAD_JSON_ATTEMPT_TIMEOUT_MS or the remaining budget. A failed read leaves
  // the cache so a later read can try again.
  var LOAD_JSON_MAX_ATTEMPTS = 3;
  var LOAD_JSON_BASE_DELAY_MS = 400;
  var LOAD_JSON_MAX_DELAY_MS = 4000;
  var LOAD_JSON_TOTAL_BUDGET_MS = 10000;
  var LOAD_JSON_ATTEMPT_TIMEOUT_MS = 7000;
  var LOAD_JSON_MIN_ATTEMPT_MS = 1000;

  function readRetryAfterMs(response) {
    var raw = text(response && response.headers && typeof response.headers.get === 'function'
      ? response.headers.get('retry-after')
      : '');
    if (!raw) return 0;
    if (/^\d+$/.test(raw)) return Number(raw) * 1000;
    var retryAt = Date.parse(raw);
    return Number.isFinite(retryAt) ? Math.max(0, retryAt - Date.now()) : 0;
  }

  function readJsonOnce(url, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var Controller = typeof AbortController === 'function' ? AbortController : window.AbortController;
      var controller = typeof Controller === 'function' ? new Controller() : null;
      var finished = false;
      var timer = window.setTimeout(function () {
        if (finished) return;
        finished = true;
        if (controller) {
          try { controller.abort(); } catch (_) {}
        }
        var timeout = new Error('Storefront data did not arrive in time from ' + url);
        timeout.status = 0;
        timeout.timedOut = true;
        timeout.retryable = true;
        reject(timeout);
      }, Math.max(0, timeoutMs));
      function settle(callback, value) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        callback(value);
      }
      var init = { credentials: 'same-origin', headers: { accept: 'application/json' } };
      if (controller) init.signal = controller.signal;
      fetch(url, init).then(function (response) {
        if (!response.ok) {
          var status = Number(response.status) || 0;
          var failure = new Error('Unable to load storefront data from ' + url);
          failure.status = status;
          failure.retryAfterMs = readRetryAfterMs(response);
          failure.retryable = status === 408 || status === 429 || (status >= 500 && status <= 599);
          // The refused answer's body is never read: release it before the
          // retry or the final failure so no stream stays open.
          try {
            if (response.body && typeof response.body.cancel === 'function') response.body.cancel().catch(function () {});
          } catch (_) {}
          if (controller) {
            try { controller.abort(); } catch (_) {}
          }
          settle(reject, failure);
          return;
        }
        response.json().then(function (payload) {
          settle(resolve, payload);
        }, function (bodyError) {
          // A network failure while the body streams is retried like one before
          // the headers; a body that is not JSON (SyntaxError) is final.
          var failure = bodyError && typeof bodyError === 'object' ? bodyError : new Error('Unable to read storefront data from ' + url);
          failure.status = Number(response.status) || 0;
          failure.retryable = Boolean(bodyError && bodyError.name === 'TypeError');
          settle(reject, failure);
        });
      }, function (networkError) {
        // Browsers reject fetch with a TypeError when the network fails; other
        // rejections (an aborted or refused request) are final.
        var failure = networkError instanceof Error ? networkError : new Error('Unable to reach storefront data at ' + url);
        failure.status = 0;
        failure.retryable = Boolean(networkError && networkError.name === 'TypeError');
        settle(reject, failure);
      });
    });
  }

  function loadJson(url) {
    var cleanUrl = text(url);
    if (!cleanUrl) return Promise.resolve(null);
    if (JSON_CACHE[cleanUrl]) return JSON_CACHE[cleanUrl];
    var startedAt = Date.now();
    function remainingMs() {
      return LOAD_JSON_TOTAL_BUDGET_MS - (Date.now() - startedAt);
    }
    function attemptLoad(attempt) {
      return readJsonOnce(cleanUrl, Math.min(LOAD_JSON_ATTEMPT_TIMEOUT_MS, remainingMs())).catch(function (error) {
        var retryAfterMs = Number(error && error.retryAfterMs) || 0;
        if (!error || error.retryable !== true || attempt >= LOAD_JSON_MAX_ATTEMPTS || retryAfterMs > LOAD_JSON_MAX_DELAY_MS) {
          throw error;
        }
        var backoffMs = LOAD_JSON_BASE_DELAY_MS * Math.pow(2, attempt - 1);
        var delayMs = Math.min(LOAD_JSON_MAX_DELAY_MS, Math.max(retryAfterMs, backoffMs / 2 + Math.random() * (backoffMs / 2)));
        // The next attempt must still fit inside this chain's budget.
        if (delayMs + LOAD_JSON_MIN_ATTEMPT_MS > remainingMs()) throw error;
        return new Promise(function (resolve) {
          window.setTimeout(resolve, delayMs);
        }).then(function () {
          // A pause can outlast its timer (a suspended tab, a busy page):
          // an expired budget ends the chain before any new request.
          if (remainingMs() < LOAD_JSON_MIN_ATTEMPT_MS) throw error;
          return attemptLoad(attempt + 1);
        });
      });
    }
    var request = attemptLoad(1);
    JSON_CACHE[cleanUrl] = request;
    request.catch(function () {
      if (JSON_CACHE[cleanUrl] === request) delete JSON_CACHE[cleanUrl];
    });
    return request;
  }

  function getRootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCurrencyCode() {
    return text(window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  // FUNCTIONS-CURRENCY-AWARE: the rate is the one Shopify renders into every
  // storefront page with the shopper's currency, Shopify.currency.rate (a
  // Decimal string, "1.44961285" for CAD on WCR, "1.0" in the shop currency).
  // It is the Markets rate the cart's presentmentCurrencyRate carries, it is
  // there before anything is in the cart, and it is the only rate the page has:
  // /cart.js returns converted amounts, not a rate, and only for lines already
  // added. Parsed once per text; null when absent or unusable.
  var presentmentRateCache = { text: null, rate: null };
  function getPresentmentRate() {
    var currency = window.Shopify && window.Shopify.currency;
    var rate = currency ? currency.rate : null;
    var rateText = typeof rate === 'number' ? String(rate) : rate;
    if (typeof rateText !== 'string') return null;
    if (rateText !== presentmentRateCache.text) {
      presentmentRateCache.text = rateText;
      presentmentRateCache.rate = parsePresentmentRate(rateText);
    }
    return presentmentRateCache.rate;
  }

  // True when the page shows prices in another currency than the shop's: a
  // usable rate other than 1. Without Shopify.currency, with an unusable rate
  // or at a rate of 1 every figure is the shop figure (today's page).
  function isPresentmentConverting() {
    var rate = getPresentmentRate();
    return !!(rate && !rate.identity);
  }

  // The page's conversion of whole shop cents into the shopper's cents
  // (presentmentCents; a negative amount is the sign times the rule on its
  // absolute value). The shop cents unchanged when the page does not convert,
  // for a value that is not whole cents, or past the safe integers.
  function presentmentCentsOf(shopCents) {
    var rate = getPresentmentRate();
    if (!rate || rate.identity || !Number.isSafeInteger(shopCents)) return shopCents;
    var converted = shopCents < 0 ? -presentmentCents(-shopCents, rate) : presentmentCents(shopCents, rate);
    return Number.isSafeInteger(converted) ? converted : shopCents;
  }

  // A shop amount in the shopper's currency: whole shop cents (moneyCents),
  // converted (presentmentCentsOf), back to an amount. The amount itself, not
  // re-rounded, when the page does not convert.
  function presentmentAmount(amount) {
    if (!isPresentmentConverting()) return amount;
    var cents = moneyCents(amount);
    return Number.isSafeInteger(cents) ? presentmentCentsOf(cents) / 100 : amount;
  }

  function formatCurrencyAmount(amount, currencyCode) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode
      }).format(amount);
    } catch (_) {
      return '$' + amount.toFixed(2);
    }
  }

  // A shop amount as the page shows it: converted into the shopper's currency
  // (Admin, theme-json and designer-api prices are shop currency). A price the
  // page computes from a whole line (a tier sale, a set-count package, a print
  // quantity split) is converted as a line first and then formatted with
  // formatPresentmentMoney, never through this; this is the amount of one
  // thing (an add-on, a fee, a per piece). Byte for byte today's text when the
  // page does not convert.
  function formatMoney(value) {
    return formatCurrencyAmount(presentmentAmount(numberValue(value, 0)), getCurrencyCode());
  }

  // An amount already in the shopper's currency (the cart's own figures from
  // /cart.js, or a figure the page converted as a line): formatted, never
  // converted again.
  function formatPresentmentMoney(value) {
    return formatCurrencyAmount(numberValue(value, 0), getCurrencyCode());
  }

  // The shop's own currency (layout/theme.liquid data-bg-shop-currency, from
  // Liquid's shop.currency; window.Shopify does not carry it). '' without it.
  function getShopCurrencyCode() {
    var root = window.document && window.document.documentElement;
    var code = root && typeof root.getAttribute === 'function' ? text(root.getAttribute('data-bg-shop-currency')) : '';
    return /^[A-Z]{3}$/.test(code) ? code : '';
  }

  // A record of a shop amount that a cart line property carries into the
  // order (Postage, which QPS invoices separately, and the artwork service
  // amounts): the shop number in the shop's currency, never converted, so the
  // record does not depend on the rate the page had. A page that does not
  // convert names the shopper's currency, which is then the shop's (today's
  // text); a converting page without the layout's shop currency shows the
  // converted amount rather than a shop number under the shopper's currency.
  // When the shopper's currency is not the shop's, the record names its
  // currency so nobody reads it as the shopper's: a bare "$" (US dollars)
  // takes the code's country letters, "US$12.50"; a symbol that already names
  // its currency (CA$, A$, a euro sign) stays as it is.
  function formatShopMoney(value) {
    var shopCode = getShopCurrencyCode();
    if (shopCode) {
      var record = formatCurrencyAmount(numberValue(value, 0), shopCode);
      return shopCode === getCurrencyCode() ? record : nameBareDollar(record, shopCode);
    }
    return isPresentmentConverting() ? formatMoney(value) : formatPresentmentMoney(value);
  }

  function nameBareDollar(formatted, currencyCode) {
    return formatted.replace(/(^|[^A-Za-z])\$/, function (match, lead) {
      return lead + currencyCode.slice(0, 2) + '$';
    });
  }

  function formatSignedMoneyProperty(value) {
    var amount = Number(numberValue(value, 0) || 0);
    if (Math.abs(amount) < 0.005) return '';
    return (amount < 0 ? '-' : '+') + formatShopMoney(Math.abs(amount));
  }

  function normalizeAddonType(value) {
    var normalized = text(value).toLowerCase().replace(/[^a-z]/g, '');
    if (normalized === 'flat') return 'flat';
    if (normalized === 'quantitybased') return 'quantityBased';
    return '';
  }

  function normalizeAddonSelection(entry) {
    var source = entry && typeof entry === 'object' ? entry : {};
    var targetingId = text(source.targetingId);
    var rawAddonKey = text(source.addonKey);
    var addonPrice = numberValue(source.addonBasePrice, NaN);
    if (!Number.isFinite(addonPrice)) addonPrice = numberValue(source.addonPrice, NaN);
    var explicitAddonType = normalizeAddonType(source.addonType);
    var hasNonZeroAddonPrice = Number.isFinite(addonPrice) && Math.abs(addonPrice) > 0.0001;
    var hasAddonKeyShape = /^addon-/i.test(rawAddonKey) || /^addon-/i.test(targetingId);
    var addonKey = text(
      hasAddonKeyShape
        ? (rawAddonKey || targetingId)
        : ((explicitAddonType || hasNonZeroAddonPrice) ? (rawAddonKey || targetingId) : '')
    ).toLowerCase();
    var addonType = explicitAddonType || ((addonKey || hasNonZeroAddonPrice) && Number.isFinite(addonPrice) ? 'quantityBased' : '');
    var hasAddon = !!addonKey || !!explicitAddonType || hasNonZeroAddonPrice;
    return {
      hasAddon: hasAddon,
      addonKey: addonKey,
      addonLabel: text(source.addonLabel),
      addonName: text(source.addonName),
      addonType: addonType,
      addonBasePrice: Number.isFinite(addonPrice) ? addonPrice : null,
      discountEligible: !!source.discountEligible,
      excludeFromCart: !!source.excludeFromCart,
      useTypedQuantity: !!source.useTypedQuantity,
      isPostage: !!source.isPostage,
      dontSayFree: !!source.dontSayFree
    };
  }

  // holdCreditsFromSale keeps a credit out of the discount base. That is only
  // correct where the submitted line price is grossed up to compensate, which is
  // the Product Commerce quote lane when the product carries a sale rate. Applying
  // it anywhere else makes the page quote a total the cart will not charge, so it
  // is off unless the caller can prove the gross-up is active.
  function calculateDesignerOptionAddOns(optionSelections, quantity, typedQuantity, options) {
    var settings = options && typeof options === 'object' ? options : {};
    var holdCreditsFromSale = settings.holdCreditsFromSale === true;
    var selectedQuantity = Math.max(1, numberValue(quantity, 1) || 1);
    var selectedTypedQuantity = Math.max(1, numberValue(typedQuantity, selectedQuantity) || selectedQuantity);
    var result = {
      cartIncludedTotal: 0,
      cartIncludedDiscountEligibleTotal: 0,
      cartIncludedNonDiscountEligibleTotal: 0,
      excludedTotal: 0,
      postageTotal: 0,
      displayOnlyTotal: 0,
      breakdown: []
    };
    (Array.isArray(optionSelections) ? optionSelections : []).forEach(function (entry) {
      var addon = normalizeAddonSelection(entry);
      if (!addon.hasAddon || !Number.isFinite(addon.addonBasePrice)) return;
      var unitQuantity = addon.useTypedQuantity ? selectedTypedQuantity : selectedQuantity;
      // Unit x quantity rounded once to the cent, like the quote engine.
      var amount = scaleMoney(addon.addonBasePrice, addon.addonType === 'flat' ? 1 : unitQuantity, 1);
      // A sale discounts what the customer is buying, never what they are
      // declining. A charge (upgraded stakes, mailing service) takes the discount
      // when its config allows it; a credit (no stakes) always comes off at face
      // value, because shrinking a credit by the sale percentage quietly hands
      // back less than the hardware the customer gave up is worth.
      var discountEligible = !!addon.discountEligible && (!holdCreditsFromSale || amount > 0);
      var cartIncluded = !(addon.isPostage || addon.excludeFromCart);
      if (addon.isPostage) {
        result.postageTotal = roundMoney(result.postageTotal + amount);
      } else if (!cartIncluded) {
        result.excludedTotal = roundMoney(result.excludedTotal + amount);
      } else {
        result.cartIncludedTotal = roundMoney(result.cartIncludedTotal + amount);
        if (discountEligible) {
          result.cartIncludedDiscountEligibleTotal = roundMoney(result.cartIncludedDiscountEligibleTotal + amount);
        } else {
          result.cartIncludedNonDiscountEligibleTotal = roundMoney(result.cartIncludedNonDiscountEligibleTotal + amount);
        }
      }
      result.displayOnlyTotal = roundMoney(result.excludedTotal + result.postageTotal);
      result.breakdown.push({
        order: Number(numberValue(entry && entry.order, 0) || 0),
        label: text(addon.addonLabel || addon.addonName || entry && (entry.valueLabel || entry.holderLabel)) || 'Add-on',
        amount: amount,
        unitPrice: addon.addonBasePrice,
        addonKey: addon.addonKey,
        addonType: addon.addonType,
        cartIncluded: cartIncluded,
        // Effective eligibility, so the summary row renders the same way the
        // totals above were composed.
        discountEligible: discountEligible,
        configuredDiscountEligible: !!addon.discountEligible,
        excludeFromCart: addon.excludeFromCart,
        useTypedQuantity: addon.useTypedQuantity,
        isPostage: addon.isPostage,
        dontSayFree: addon.dontSayFree,
        isNegative: amount < 0
      });
    });
    return result;
  }

  function sumOptionSelectionAddOnTotal(optionSelections, quantity) {
    return calculateDesignerOptionAddOns(optionSelections, quantity).cartIncludedTotal;
  }

  function resolveDesignerDesignFeeTotal(payload) {
    var source = payload && typeof payload === 'object' ? payload : {};
    var mode = normalizeArtworkMode(source.artworkMode);
    if (mode === 'editservice') {
      var templateAmount = numberValue(source.templatePersonalizationAmount, NaN);
      if (!Number.isFinite(templateAmount)) {
        templateAmount = numberValue(source.template && source.template.editServiceCost, NaN);
      }
      if (!Number.isFinite(templateAmount)) {
        templateAmount = numberValue(source.editServiceCost, 0);
      }
      return roundMoney(templateAmount);
    }
    if (mode === 'customdesign') {
      var customAmount = numberValue(source.customDesignAmount, NaN);
      if (!Number.isFinite(customAmount)) {
        customAmount = numberValue(source.customDesignCost, 0);
      }
      return roundMoney(customAmount);
    }
    return 0;
  }

  function buildDesignerSplitPrice(payload) {
    var source = payload && typeof payload === 'object' ? payload : {};
    var quantity = Math.max(1, numberValue(source.quantity, 1) || 1);
    var pricing = source.pricingMap && typeof source.pricingMap === 'object' ? source.pricingMap : {};
    var finalSku = text(source.finalSku);
    var baseSku = text(source.baseSku).replace(/-q$/i, '') || (finalSku ? finalSku.replace(/-q\d+$/i, '') : '');
    if (!finalSku && baseSku) {
      finalSku = baseSku + '-q' + String(quantity);
    }
    var priceRecord = finalSku ? pricing[finalSku] || null : null;
    var explicitBasePrice = Number(source.basePrice);
    var productBaseTotal = Number.isFinite(explicitBasePrice)
      ? roundMoney(explicitBasePrice)
      : roundMoney(numberValue(priceRecord && priceRecord.price, 0));
    var optionAddOns = calculateDesignerOptionAddOns(
      source.optionSelections,
      quantity,
      numberValue(source.typedQty || source.typedQuantity, quantity),
      { holdCreditsFromSale: source.holdCreditsFromSale === true }
    );
    var optionAddOnTotal = optionAddOns.cartIncludedTotal;
    var productTotal = roundMoney(productBaseTotal + optionAddOnTotal);
    var designFeeTotal = resolveDesignerDesignFeeTotal(source);
    var grandTotal = roundMoney(productTotal + designFeeTotal);
    return {
      quantity: quantity,
      baseSku: baseSku,
      finalSku: finalSku,
      priceRecord: priceRecord,
      productBaseTotal: productBaseTotal,
      optionAddOnTotal: optionAddOnTotal,
      optionAddOns: optionAddOns,
      excludedOptionAddOnTotal: optionAddOns.excludedTotal,
      postageOptionAddOnTotal: optionAddOns.postageTotal,
      productTotal: productTotal,
      designFeeTotal: designFeeTotal,
      grandTotal: grandTotal,
      productPerUnit: quantity > 0 ? roundMoney(productBaseTotal / quantity) : productBaseTotal,
      grandPerUnit: quantity > 0 ? roundMoney(grandTotal / quantity) : grandTotal
    };
  }

  function getCurrentAbsoluteUrl() {
    try {
      return new URL(String(window.location.href || ''), window.location.origin).toString();
    } catch (_) {
      return window.location.origin;
    }
  }

  function buildStableCacheKey(value) {
    var input = text(value);
    if (!input) return '';
    var hash = 5381;
    for (var index = 0; index < input.length; index += 1) {
      hash = ((hash << 5) + hash) ^ input.charCodeAt(index);
    }
    return 'bg' + (hash >>> 0).toString(36);
  }

  function getBootstrapCacheStorageKey(cacheKey) {
    var cleanKey = text(cacheKey);
    return cleanKey ? ('bg-designer-v2-bootstrap:v2:' + cleanKey) : '';
  }

  function getDesignerSessionTokenFromPage() {
    var bootstrap = window.BG_DESIGNER_BOOTSTRAP && typeof window.BG_DESIGNER_BOOTSTRAP === 'object'
      ? window.BG_DESIGNER_BOOTSTRAP
      : {};
    var session = bootstrap.session && typeof bootstrap.session === 'object' ? bootstrap.session : {};
    return text(bootstrap.sessionToken || session.token);
  }

  function getBootstrapCacheStore(targetWindow) {
    if (!targetWindow) return null;
    try {
      var existing = targetWindow.__BG_STOREFRONT_BOOTSTRAP_CACHE_V2__;
      if (existing && typeof existing === 'object') return existing;
      var nextStore = {};
      targetWindow.__BG_STOREFRONT_BOOTSTRAP_CACHE_V2__ = nextStore;
      return nextStore;
    } catch (_) {
      return null;
    }
  }

  function readCachedBootstrap(cacheKey) {
    var storageKey = getBootstrapCacheStorageKey(cacheKey);
    if (!storageKey) return null;
    var candidates = [window];
    try {
      if (window.parent && window.parent !== window) candidates.push(window.parent);
    } catch (_) {}
    for (var index = 0; index < candidates.length; index += 1) {
      var store = getBootstrapCacheStore(candidates[index]);
      var cachedValue = store && typeof store === 'object' ? store[storageKey] : null;
      if (cachedValue && cachedValue.bootstrap && cachedValue.launchContext) {
        return cachedValue;
      }
    }
    try {
      var raw = window.sessionStorage.getItem(storageKey);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.bootstrap && parsed.launchContext) {
        return parsed;
      }
    } catch (_) {}
    return null;
  }

  function writeCachedBootstrap(cacheKey, payload) {
    var storageKey = getBootstrapCacheStorageKey(cacheKey);
    if (!storageKey || !payload || typeof payload !== 'object') return false;
    var wroteMemory = false;
    var targets = [window];
    try {
      if (window.parent && window.parent !== window) targets.push(window.parent);
    } catch (_) {}
    targets.forEach(function (target) {
      var store = getBootstrapCacheStore(target);
      if (!store) return;
      store[storageKey] = payload;
      wroteMemory = true;
    });
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
      return true;
    } catch (_) {
      return wroteMemory;
    }
  }

  function deleteCachedBootstrap(cacheKey) {
    var storageKey = getBootstrapCacheStorageKey(cacheKey);
    if (!storageKey) return false;
    var removed = false;
    var targets = [window];
    try {
      if (window.parent && window.parent !== window) targets.push(window.parent);
    } catch (_) {}
    targets.forEach(function (target) {
      var store = getBootstrapCacheStore(target);
      if (store && Object.prototype.hasOwnProperty.call(store, storageKey)) {
        delete store[storageKey];
        removed = true;
      }
    });
    try {
      window.sessionStorage.removeItem(storageKey);
      return true;
    } catch (_) {
      return removed;
    }
  }

  function ensureOriginPreconnect(urlValue) {
    var cleanUrl = text(urlValue);
    if (!cleanUrl) return false;
    try {
      var absoluteUrl = new URL(cleanUrl, window.location.origin);
      var cacheKey = 'preconnect:' + absoluteUrl.origin;
      if (JSON_CACHE[cacheKey]) return true;
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = absoluteUrl.origin;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      JSON_CACHE[cacheKey] = Promise.resolve(true);
      return true;
    } catch (_) {
      return false;
    }
  }

  function collectProjectBoardPreviews(project) {
    var source = project && typeof project === 'object' ? project : {};
    var documentValue = source.document || {};
    var metadata = source.metadata || {};
    var documentMetadata = documentValue.metadata || {};
    var candidates = [source.boardPreviews, metadata.boardPreviews, documentMetadata.boardPreviews];
    var entries = candidates.find(function (value) { return Array.isArray(value); });
    if (!entries) return null; // Legacy records have no indexed preview contract.
    var boards = Array.isArray(documentValue.boards) ? documentValue.boards : [];
    var seen = Object.create(null);
    return entries.filter(function (entry) {
      var index = Number(entry && entry.boardIndex);
      if (!entry || entry.boardIndex === null || entry.boardIndex === undefined || !Number.isInteger(index) || index < 0 || !text(entry.url) || seen[index]) return false;
      if (boards.length && (!boards[index] || (text(entry.boardId) && text(boards[index].id) !== text(entry.boardId)))) return false;
      seen[index] = true;
      return true;
    }).map(function (entry) {
      return { boardId: text(entry.boardId), boardIndex: Number(entry.boardIndex), url: text(entry.url), isPrimary: entry.isPrimary === true };
    }).sort(function (left, right) { return left.boardIndex - right.boardIndex; });
  }

  function collectProjectPreviewUrls(project) {
    var seen = Object.create(null);
    var urls = [];

    function push(value) {
      var cleanValue = text(value);
      if (!cleanValue || seen[cleanValue]) return;
      seen[cleanValue] = true;
      urls.push(cleanValue);
    }

    var source = project && typeof project === 'object' ? project : {};
    var metadata = source.metadata && typeof source.metadata === 'object' ? source.metadata : {};
    var documentValue = source.document && typeof source.document === 'object' ? source.document : {};
    var documentMetadata = documentValue.metadata && typeof documentValue.metadata === 'object' ? documentValue.metadata : {};
    var renderArtifacts = metadata.renderArtifacts && typeof metadata.renderArtifacts === 'object' ? metadata.renderArtifacts : {};
    var documentRenderArtifacts = documentMetadata.renderArtifacts && typeof documentMetadata.renderArtifacts === 'object'
      ? documentMetadata.renderArtifacts
      : {};
    var previewArtifact = renderArtifacts.preview || documentRenderArtifacts.preview || null;
    var previewMetadata = previewArtifact && previewArtifact.metadata && typeof previewArtifact.metadata === 'object'
      ? previewArtifact.metadata
      : {};

    var boardPreviews = collectProjectBoardPreviews(source);
    if (boardPreviews) boardPreviews.forEach(function (entry) { push(entry.url); });

    push(previewMetadata.objectPublicUrl);
    push(previewArtifact && previewArtifact.url);
    // The worker's project GET projects the freshest render into a top-level
    // previewUrl and omits renderArtifacts entirely — without this, records
    // read over the app proxy contribute no preview at all.
    push(source.previewUrl);

    if (Array.isArray(source.previews)) source.previews.forEach(push);
    if (Array.isArray(metadata.previews)) metadata.previews.forEach(push);
    if (Array.isArray(documentMetadata.previews)) documentMetadata.previews.forEach(push);

    var boards = Array.isArray(documentValue.boards) ? documentValue.boards : [];
    boards.forEach(function (board) {
      var boardMeta = board && board.metadata && typeof board.metadata === 'object' ? board.metadata : {};
      push(boardMeta.previewUrl);
      if (Array.isArray(boardMeta.previews)) boardMeta.previews.forEach(push);
    });

    return urls;
  }

  function getDesignerProxyRoot(config) {
    var explicit = text(config && config.designer && config.designer.proxyRoot);
    if (explicit) return explicit.replace(/\/+$/, '');
    return '/apps/qps-commerce-control-plane/designer';
  }

  function getEditorBaseUrl(config) {
    var explicit = text(config && config.designer && config.designer.editorUrl);
    if (explicit) return explicit.replace(/\/+$/, '');
    return getDesignerProxyRoot(config) + '/editor-v2';
  }

  function getBootstrapBaseUrl(config) {
    var explicit = text(config && config.designer && config.designer.bootstrapUrl);
    if (explicit) return explicit.replace(/\/+$/, '');
    return getDesignerProxyRoot(config) + '/session/bootstrap';
  }

  function getProjectsUrl(config) {
    var explicit = text(config && config.designer && config.designer.projectsUrl);
    if (explicit) return explicit.replace(/\/+$/, '');
    return getDesignerProxyRoot(config) + '/projects';
  }

  function getTemplateSummaryUrl(config, params) {
    var source = params && typeof params === 'object' ? params : {};
    var lookup = text(source.lookup);
    var legacyId = text(source.legacyId);
    if (!lookup && !legacyId) return '';
    try {
      var requestUrl = new URL(getDesignerProxyRoot(config) + '/template-summary', window.location.origin);
      if (lookup) requestUrl.searchParams.set('lookup', lookup);
      if (legacyId) requestUrl.searchParams.set('legacyId', legacyId);
      return requestUrl.toString();
    } catch (_) {
      return '';
    }
  }

  function buildBootstrapRequestUrl(config, launchUrl) {
    var cleanUrl = text(launchUrl);
    if (!cleanUrl) return '';
    try {
      var requestUrl = new URL(cleanUrl, window.location.origin);
      requestUrl.pathname = new URL(getBootstrapBaseUrl(config), window.location.origin).pathname;
      requestUrl.searchParams.delete('adminEmbedded');
      requestUrl.searchParams.delete('adminHostOrigin');
      requestUrl.searchParams.delete('adminReturnUrl');
      requestUrl.searchParams.delete('adminNextUrl');
      requestUrl.searchParams.delete('bgEmbedded');
      requestUrl.searchParams.delete('bgHostOrigin');
      requestUrl.searchParams.delete('bgReturnUrl');
      requestUrl.searchParams.delete('bgNextUrl');
      requestUrl.searchParams.delete('bgEmbeddedSource');
      requestUrl.searchParams.delete('bgStorefrontFastLaunch');
      requestUrl.searchParams.delete('bgBootstrapCacheKey');
      // Display only (STUDIO-SALE-SENTENCE, SALE-DISPLAY-STRIKETHROUGH): the
      // editor reads them from its own address; the bootstrap request stays the
      // same with or without a sale.
      requestUrl.searchParams.delete('bgSalePending');
      requestUrl.searchParams.delete('bgSalePercent');
      requestUrl.searchParams.set('editorVariant', 'editor-v2');
      if (!requestUrl.searchParams.get('designId') && requestUrl.searchParams.get('id')) {
        requestUrl.searchParams.set('designId', text(requestUrl.searchParams.get('id')));
      }
      if (!requestUrl.searchParams.get('designNumber') && requestUrl.searchParams.get('designnum')) {
        requestUrl.searchParams.set('designNumber', text(requestUrl.searchParams.get('designnum')));
      }
      return requestUrl.toString();
    } catch (_) {
      return '';
    }
  }

  function getBootstrapCacheKeyForLaunchUrl(config, launchUrl) {
    return buildStableCacheKey(buildBootstrapRequestUrl(config, launchUrl));
  }

  function prewarmEditorBootstrap(config, launchUrl) {
    var bootstrapUrl = buildBootstrapRequestUrl(config, launchUrl);
    var cacheKey = getBootstrapCacheKeyForLaunchUrl(config, launchUrl);
    if (!bootstrapUrl || !cacheKey) return Promise.resolve(null);
    var cached = readCachedBootstrap(cacheKey);
    if (cached && cached.bootstrap && cached.launchContext) {
      return Promise.resolve({
        cacheKey: cacheKey,
        payload: cached,
        source: 'cache'
      });
    }
    if (BOOTSTRAP_PROMISES[bootstrapUrl]) return BOOTSTRAP_PROMISES[bootstrapUrl];
    // A prewarm the worker has already refused twice will keep failing on
    // every re-render; stop retrying and let open() fall back to direct
    // frame navigation, where the editor client authorizes itself.
    if (Number(BOOTSTRAP_PREWARM_FAILURES[bootstrapUrl] || 0) >= 2) return Promise.resolve(null);
    ensureOriginPreconnect(bootstrapUrl);
    var prewarmHeaders = { accept: 'application/json' };
    var prewarmProjectId = '';
    try {
      prewarmProjectId = text(new URL(bootstrapUrl, window.location.origin).searchParams.get('projectId'));
    } catch (_) {}
    if (prewarmProjectId) {
      // A guest-owned project bootstrap is denied without the original signed
      // session proof; present it the same way the commerce mint lane does.
      var prewarmGuestProof = readStoredGuestClaimProofToken(prewarmProjectId);
      if (prewarmGuestProof) prewarmHeaders['x-designer-session-token'] = prewarmGuestProof;
    }
    BOOTSTRAP_PROMISES[bootstrapUrl] = fetch(bootstrapUrl, {
      credentials: 'same-origin',
      headers: prewarmHeaders
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (payload) {
        if (
          !response.ok
          || !payload
          || typeof payload !== 'object'
          || payload.ok === false
          || !payload.bootstrap
          || !payload.launchContext
        ) {
          throw new Error('Unable to preload the editor session.');
        }
        writeCachedBootstrap(cacheKey, payload);
        delete BOOTSTRAP_PREWARM_FAILURES[bootstrapUrl];
        return {
          cacheKey: cacheKey,
          payload: payload,
          source: 'network'
        };
      });
    }).catch(function (error) {
      BOOTSTRAP_PREWARM_FAILURES[bootstrapUrl] = Number(BOOTSTRAP_PREWARM_FAILURES[bootstrapUrl] || 0) + 1;
      throw error;
    }).finally(function () {
      delete BOOTSTRAP_PROMISES[bootstrapUrl];
    });
    return BOOTSTRAP_PROMISES[bootstrapUrl];
  }

  function fetchTemplateSummary(config, params) {
    var requestUrl = getTemplateSummaryUrl(config, params);
    if (!requestUrl) return Promise.resolve(null);
    if (TEMPLATE_SUMMARY_PROMISES[requestUrl]) return TEMPLATE_SUMMARY_PROMISES[requestUrl];
    ensureOriginPreconnect(requestUrl);
    TEMPLATE_SUMMARY_PROMISES[requestUrl] = fetch(requestUrl, {
      credentials: 'same-origin',
      headers: {
        accept: 'application/json'
      }
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (payload) {
        if (!response.ok || !payload || payload.ok === false || !payload.summary || typeof payload.summary !== 'object') {
          return null;
        }
        return payload.summary;
      });
    }).finally(function () {
      delete TEMPLATE_SUMMARY_PROMISES[requestUrl];
    });
    return TEMPLATE_SUMMARY_PROMISES[requestUrl];
  }

  function parseSizeToken(value) {
    var match = text(value).match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);
    if (!match) return null;
    return {
      width: Number(match[1]),
      height: Number(match[2]),
      unit: 'inches'
    };
  }

  function normalizeProductOptionKey(value) {
    return text(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function buildProductOptionLaunchState(optionSelections) {
    var selectedOptions = [];
    var productOptions = {};
    var seen = Object.create(null);
    (Array.isArray(optionSelections) ? optionSelections : []).forEach(function (selection) {
      var source = selection && typeof selection === 'object' ? selection : {};
      var name = text(source.holderLabel || source.name || source.label || source.variantKey || source.holderParamKey);
      var value = text(
        buildSelectionDisplayLabel(source)
        || source.value
        || source.rawValue
        || source.paramValue
        || source.variantValue
      );
      if (!name || !value) return;
      var key = normalizeProductOptionKey(name);
      var holderId = text(source.holderId || source.optionHolderId);
      var valueId = text(source.valueId || source.variationId || source.hvid || source.hvId || source.id);
      var dedupe = holderId && valueId
        ? holderId + ':' + valueId
        : key + ':' + normalizeProductOptionKey(value);
      if (seen[dedupe]) return;
      seen[dedupe] = true;
      var selectedOption = {
        name: name,
        key: key,
        value: value,
        rawValue: text(source.rawValue || source.value || source.valueLabel || value),
        variantKey: name,
        variantValue: value
      };
      if (holderId) selectedOption.holderId = holderId;
      if (valueId) selectedOption.valueId = valueId;
      selectedOptions.push(selectedOption);
      productOptions[name] = value;
      productOptions[key] = value;
    });
    return {
      selectedOptions: selectedOptions,
      productOptions: productOptions
    };
  }

  function appendProductOptionLaunchParams(editorUrl, source) {
    var payload = source && typeof source === 'object' ? source : {};
    var optionState = buildProductOptionLaunchState(
      Array.isArray(payload.selectedOptions) ? payload.selectedOptions : payload.optionSelections
    );
    var selectedVariantId = text(payload.selectedVariantId || payload.variantId || payload.baseVariantId);
    var selectedVariantTitle = text(payload.selectedVariantTitle || payload.variantTitle);
    if (selectedVariantId) editorUrl.searchParams.set('selectedVariantId', selectedVariantId);
    if (selectedVariantTitle) editorUrl.searchParams.set('selectedVariantTitle', selectedVariantTitle);
    if (optionState.selectedOptions.length) editorUrl.searchParams.set('selectedOptions', JSON.stringify(optionState.selectedOptions));
    if (Object.keys(optionState.productOptions).length) editorUrl.searchParams.set('productOptions', JSON.stringify(optionState.productOptions));
  }

  function buildEditorUrl(config, context) {
    var source = context && typeof context === 'object' ? context : {};
    var editorUrl = new URL(getEditorBaseUrl(config), window.location.origin);
    var currentUrl = getCurrentAbsoluteUrl();
    var storeKey = text(source.storeKey || (config && (config.storeKey || config.storefront)));
    var productHandle = text(source.productHandle || (config && config.handle));
    var productId = text(source.productId || (config && config.productId));
    var runtimeVersion = text(source.runtimeVersion || (config && config.runtimeVersion));
    var projectId = text(source.projectId);
    var styleConversion = normalizeStyleConversionContext(source.styleConversion);
    var copiesProject = !!(styleConversion && styleConversion.sourceProjectId === projectId);
    var projectRefreshToken = text(source.projectRefreshToken);
    var designId = text(source.designId || (source.template && source.template.designId));
    var designNumber = text(source.designNumber || (source.template && source.template.designNumber));
    var templateLookup = text(source.templateLookup || (source.template && (source.template.templateLookup || source.template.templatePublicId || source.template.publicId)));
    var backer = text(source.backer || (source.template && source.template.backer));
    var orientation = text(source.selectedOrientation || (source.template && source.template.orientation));
    var launchMode = text(source.launchMode || source.bgLaunchMode).toLowerCase();
    if (launchMode !== 'blank' && launchMode !== 'upload') launchMode = '';
    var size = source.size && typeof source.size === 'object' ? source.size : {};
    var storefrontBinding = source.storefrontBinding && typeof source.storefrontBinding === 'object'
      ? deepClone(source.storefrontBinding, {})
      : {};
    var productPageExperimentContext = normalizeProductPageExperimentContext(source.productPageExperimentContext);
    var selectedSidesId = text(source.selectedSidesId);
    var selectedSidesLabel = text(source.selectedSidesLabel);
    var selectedSidesTargetingId = text(source.selectedSidesTargetingId);
    var selectedPrintingId = text(source.selectedPrintingId);
    var selectedPrintingLabel = text(source.selectedPrintingLabel);
    var selectedPrintingTargetingId = text(source.selectedPrintingTargetingId);
    var sidesPolicy = source.sidesPolicy && typeof source.sidesPolicy === 'object'
      ? deepClone(source.sidesPolicy, {})
      : null;
    var sizeToken = text(size.selectedSizeId || size.id || size.targetingId);
    var sizeLabel = text(size.selectedSizeLabel || size.label);
    var sizeDimensions = (
      numberValue(size.selectedWidth, NaN) > 0
      && numberValue(size.selectedHeight, NaN) > 0
    ) ? {
      width: Number(size.selectedWidth),
      height: Number(size.selectedHeight),
      unit: text(size.selectedUnit || size.unit) || 'inches'
    } : parseSizeToken(sizeLabel || sizeToken);

    if (projectId) {
      editorUrl.searchParams.set('mode', 'edit');
      editorUrl.searchParams.set('projectId', projectId);
      if (text(source.source) === 'product' && !copiesProject) editorUrl.searchParams.set('reconfigureProject', '1');
      if (projectRefreshToken) editorUrl.searchParams.set('bgProjectRefreshToken', projectRefreshToken);
    } else if (templateLookup || designId || designNumber) {
      editorUrl.searchParams.set('mode', 'new');
    } else {
      editorUrl.searchParams.set('mode', 'new');
    }

    if (productId) editorUrl.searchParams.set('productId', productId);
    if (storeKey) editorUrl.searchParams.set('storeKey', storeKey);
    if (productHandle) editorUrl.searchParams.set('productHandle', productHandle);
    if (templateLookup) {
      editorUrl.searchParams.set('templateLookup', templateLookup);
      editorUrl.searchParams.set('templatePublicId', templateLookup);
      editorUrl.searchParams.set('templateId', templateLookup);
    }
    if (designId) {
      editorUrl.searchParams.set('id', designId);
      editorUrl.searchParams.set('designId', designId);
    }
    if (designNumber) {
      editorUrl.searchParams.set('designnum', designNumber);
      editorUrl.searchParams.set('designNumber', designNumber);
    }
    if (backer) editorUrl.searchParams.set('backer', backer);
    if (sizeToken) {
      editorUrl.searchParams.set('size', sizeToken);
      editorUrl.searchParams.set('selectedSizeId', sizeToken);
    }
    if (sizeLabel) editorUrl.searchParams.set('selectedSizeLabel', sizeLabel);
    if (sizeDimensions && sizeDimensions.width > 0 && sizeDimensions.height > 0) {
      editorUrl.searchParams.set('selectedWidth', String(sizeDimensions.width));
      editorUrl.searchParams.set('selectedHeight', String(sizeDimensions.height));
      editorUrl.searchParams.set('selectedUnit', text(sizeDimensions.unit || 'inches'));
    }
    if (orientation) editorUrl.searchParams.set('selectedOrientation', orientation.toLowerCase());
    // Pass-through direct cart (Editor Commerce Contract, Decision A): the
    // launch context carries the RESOLVED per-product directToCart flag
    // (Product Commerce advancedMetadata.directToCart, falling back to the
    // store-wide designerDefaults.directToCart default, compiled into the
    // runtime bundle metadata by the API). An unset flag keeps the classic
    // return-to-product close.
    if (source.directToCart === true) {
      editorUrl.searchParams.set('completionDestination', 'add-to-cart');
    }
    if (selectedSidesId) editorUrl.searchParams.set('selectedSidesId', selectedSidesId);
    if (selectedSidesLabel) editorUrl.searchParams.set('selectedSidesLabel', selectedSidesLabel);
    if (selectedSidesTargetingId) editorUrl.searchParams.set('selectedSidesTargetingId', selectedSidesTargetingId);
    if (sidesPolicy) editorUrl.searchParams.set('sidesPolicy', JSON.stringify(sidesPolicy));
    if (selectedPrintingId) editorUrl.searchParams.set('selectedPrintingId', selectedPrintingId);
    if (selectedPrintingLabel) editorUrl.searchParams.set('selectedPrintingLabel', selectedPrintingLabel);
    if (selectedPrintingTargetingId) editorUrl.searchParams.set('selectedPrintingTargetingId', selectedPrintingTargetingId);
    if (launchMode) {
      editorUrl.searchParams.set('bgLaunchMode', launchMode);
      editorUrl.searchParams.set('launchMode', launchMode);
    }
    // S4 flow-back (ADR-021): the page's chosen quantity rides the launch
    // into the shared Configuration Session, and a relaunch re-adopts the
    // session the last editor visit minted or mutated.
    var launchQuantity = Number(source.quantity);
    if (Number.isInteger(launchQuantity) && launchQuantity > 0) {
      editorUrl.searchParams.set('quantity', String(launchQuantity));
    }
    var launchConfigurationSessionId = text(source.configurationSessionId);
    if (launchConfigurationSessionId) {
      editorUrl.searchParams.set('bgConfigurationSession', launchConfigurationSessionId);
    }
    appendProductOptionLaunchParams(editorUrl, source);

    if (!Object.keys(storefrontBinding).length) {
      var launchOptionState = buildProductOptionLaunchState(
        Array.isArray(source.selectedOptions) ? source.selectedOptions : source.optionSelections
      );
      storefrontBinding = {
        productId: productId,
        productHandle: productHandle,
        templateLookup: templateLookup,
        templateTitle: text(source.templateTitle || (source.template && source.template.title)),
        selection: {
          selectedSizeId: sizeToken,
          selectedSizeLabel: sizeLabel,
          selectedWidth: sizeDimensions && sizeDimensions.width > 0 ? Number(sizeDimensions.width) : null,
          selectedHeight: sizeDimensions && sizeDimensions.height > 0 ? Number(sizeDimensions.height) : null,
          selectedUnit: sizeDimensions ? text(sizeDimensions.unit || 'inches') : '',
          selectedOrientation: orientation,
          size: text(size.size || sizeLabel),
          unfoldedSize: text(size.unfoldedSize),
          selectedSidesId: selectedSidesId,
          selectedSidesLabel: selectedSidesLabel,
          selectedSidesTargetingId: selectedSidesTargetingId,
          sidesPolicy: sidesPolicy,
          selectedPrintingId: selectedPrintingId,
          selectedPrintingLabel: selectedPrintingLabel,
          selectedPrintingTargetingId: selectedPrintingTargetingId,
          backer: backer,
          printQuantity: Number.isSafeInteger(launchQuantity) && launchQuantity > 0 && launchQuantity <= 1000000 ? launchQuantity : null,
          optionSelections: Array.isArray(source.optionSelections) ? deepClone(source.optionSelections, []) : [],
          selectedVariantId: text(source.selectedVariantId || source.variantId || source.baseVariantId),
          selectedVariantTitle: text(source.selectedVariantTitle || source.variantTitle),
          selectedOptions: launchOptionState.selectedOptions,
          productOptions: launchOptionState.productOptions
        }
      };
      if (!storefrontBinding.selection.printQuantity) {
        delete storefrontBinding.selection.printQuantity;
      }
    }
    var bindingParam = encodeJsonParam(storefrontBinding);
    if (bindingParam) {
      editorUrl.searchParams.set('bgStorefrontBinding', bindingParam);
    }
    var experimentContextParam = encodeJsonParam(productPageExperimentContext);
    if (experimentContextParam) editorUrl.searchParams.set('bgProductPageExperimentContext', experimentContextParam);
    // STUDIO-SALE-SENTENCE (OD-122): the product page has a store sale
    // configured, so the Studio says the store pages' sentence beside every
    // price it shows (all before discounts). Only an explicit true sets it.
    if (source.salePending === true) editorUrl.searchParams.set('bgSalePending', '1');
    // SALE-DISPLAY-STRIKETHROUGH: the page shows the store's tier sale, so the
    // Studio shows its prices crossed out with the price after that sale
    // (Shopify's per-unit floor). Only a whole percent from 1 to 99 is written.
    var salePercent = source.salePercent;
    if (typeof salePercent === 'number' && Number.isInteger(salePercent) && salePercent > 0 && salePercent < 100) {
      editorUrl.searchParams.set('bgSalePercent', String(salePercent));
    }
    var styleConversionParam = encodeJsonParam(styleConversion);
    if (styleConversionParam) editorUrl.searchParams.set('bgStyleConversion', styleConversionParam);

    editorUrl.searchParams.set('bgEmbedded', '1');
    editorUrl.searchParams.set('bgHostOrigin', window.location.origin);
    editorUrl.searchParams.set('bgReturnUrl', currentUrl);
    editorUrl.searchParams.set('bgNextUrl', currentUrl);
    editorUrl.searchParams.set('bgEmbeddedSource', text(source.source) || 'product');
    editorUrl.searchParams.set('bgStorefrontFastLaunch', '1');
    if (runtimeVersion) editorUrl.searchParams.set('bgStorefrontRuntime', runtimeVersion);
    var cacheKey = getBootstrapCacheKeyForLaunchUrl(config, editorUrl.toString());
    if (cacheKey) editorUrl.searchParams.set('bgBootstrapCacheKey', cacheKey);
    return editorUrl.toString();
  }

  function buildUpdatedLaunchUrl(config, launchUrl, detail) {
    var cleanLaunchUrl = text(launchUrl);
    if (!cleanLaunchUrl) return '';
    try {
      var updatedUrl = new URL(cleanLaunchUrl, window.location.origin);
      var payload = detail && typeof detail === 'object' ? detail : {};
      var projectId = text(payload.projectId);
      var designId = text(payload.designId);
      var designNumber = text(payload.designNumber);
      if (projectId) updatedUrl.searchParams.set('projectId', projectId);
      if (designId) {
        updatedUrl.searchParams.set('id', designId);
        updatedUrl.searchParams.set('designId', designId);
      }
      if (designNumber) {
        updatedUrl.searchParams.set('designnum', designNumber);
        updatedUrl.searchParams.set('designNumber', designNumber);
      }
      var nextCacheKey = getBootstrapCacheKeyForLaunchUrl(config, updatedUrl.toString());
      if (nextCacheKey) {
        updatedUrl.searchParams.set('bgBootstrapCacheKey', nextCacheKey);
      } else {
        updatedUrl.searchParams.delete('bgBootstrapCacheKey');
      }
      return updatedUrl.toString();
    } catch (_) {
      return cleanLaunchUrl;
    }
  }

  function readConfig(root) {
    var rootNode = root && root.nodeType === 1 ? root : null;
    if (!rootNode) return null;
    var configId = text(rootNode.getAttribute('data-config-id'));
    if (!configId) return null;
    var node = document.getElementById(configId);
    if (!node) return null;
    return parseJson(node.textContent, null);
  }

  function buildSelectionDisplayLabel(selection) {
    var source = selection && typeof selection === 'object' ? selection : {};
    var valueLabel = text(source.valueLabel || source.label);
    var flavorText = text(source.flavorText);
    if (!flavorText) return valueLabel;
    if (!valueLabel) return flavorText;
    return valueLabel + ' (' + flavorText + ')';
  }

  function buildOptionSelection(holder, value, order) {
    var holderValue = holder && typeof holder === 'object' ? holder : {};
    var sourceValue = value && typeof value === 'object' ? value : {};
    return {
      order: Number(order || holderValue.sortOrder || 0) || 0,
      holderId: text(holderValue.id || holderValue.holderId),
      holderHtmlId: text(holderValue.htmlID || holderValue.holderHtmlId || slugify(holderValue.displayName)),
      holderLabel: text(holderValue.displayName || holderValue.holderLabel),
      valueLabel: text(sourceValue.label || sourceValue.valueLabel),
      flavorText: text(sourceValue.flavorText),
      targetingId: text(sourceValue.targetingID || sourceValue.targetingId),
      hvid: text(sourceValue.hvId || sourceValue.hvid),
      friendlySku: text(sourceValue.friendlySku),
      numericSku: text(sourceValue.numericSku),
      paramValue: text(sourceValue.value || sourceValue.targetingID || sourceValue.label),
      addonPrice: Number.isFinite(Number(sourceValue.addonPrice)) ? Number(sourceValue.addonPrice) : null
    };
  }

  function serializeOptionSelection(entry, compact) {
    var source = entry && typeof entry === 'object' ? entry : {};
    var addon = normalizeAddonSelection(source);
    var payload = {
      order: Number(numberValue(source.order, 0) || 0),
      holderHtmlId: text(source.holderHtmlId),
      holderLabel: text(source.holderLabel),
      valueLabel: text(source.valueLabel),
      targetingId: text(source.targetingId),
      numericSku: text(source.numericSku),
      addonPrice: Number.isFinite(Number(source.addonPrice)) ? Number(source.addonPrice) : null
    };
    if (!compact) {
      payload.holderId = text(source.holderId);
      payload.flavorText = text(source.flavorText);
      payload.hvid = text(source.hvid);
      payload.friendlySku = text(source.friendlySku);
      payload.paramValue = text(source.paramValue);
    }
    if (addon.hasAddon) {
      payload.addonKey = addon.addonKey;
      payload.addonLabel = addon.addonLabel;
      payload.addonName = addon.addonName;
      payload.addonType = addon.addonType;
      payload.addonBasePrice = addon.addonBasePrice;
      payload.discountEligible = addon.discountEligible;
      payload.excludeFromCart = addon.excludeFromCart;
      payload.useTypedQuantity = addon.useTypedQuantity;
      payload.isPostage = addon.isPostage;
      payload.dontSayFree = addon.dontSayFree;
    }
    return payload;
  }

  function serializeCartTransformSelection(entry) {
    var source = entry && typeof entry === 'object' ? entry : {};
    var addon = normalizeAddonSelection(source);
    var numericSku = text(source.numericSku);
    // Stable Product Commerce identity is required by the API-owned quote
    // resolver. Targeting IDs and numeric SKU segments are not unique on all
    // products (notably Postcards), so never compact these two fields away.
    var stableIdentity = {};
    var holderId = text(source.holderId);
    var valueId = text(source.hvid || source.valueId);
    if (holderId) stableIdentity.holderId = holderId;
    if (valueId) stableIdentity.valueId = valueId;
    if (addon.hasAddon) {
      if (addon.isPostage || addon.excludeFromCart || (Number.isFinite(addon.addonBasePrice) && Math.abs(addon.addonBasePrice) > 0.0001)) {
        var addonPayload = Object.assign({}, stableIdentity, {
          order: Number(numberValue(source.order, 0) || 0),
          holderHtmlId: text(source.holderHtmlId),
          targetingId: text(source.targetingId),
          addonKey: addon.addonKey || text(source.targetingId)
        });
        if (numericSku) addonPayload.numericSku = numericSku;
        if (addon.addonType) addonPayload.addonType = addon.addonType;
        if (Number.isFinite(addon.addonBasePrice)) addonPayload.addonBasePrice = addon.addonBasePrice;
        if (addon.discountEligible) addonPayload.discountEligible = true;
        if (addon.excludeFromCart) addonPayload.excludeFromCart = true;
        if (addon.useTypedQuantity) addonPayload.useTypedQuantity = true;
        if (addon.isPostage) addonPayload.isPostage = true;
        if (addon.dontSayFree) addonPayload.dontSayFree = true;
        return addonPayload;
      }
      if (numericSku && !/^addon-/i.test(text(source.addonKey)) && !/^addon-/i.test(text(source.targetingId))) {
        return Object.assign({}, stableIdentity, {
          order: Number(numberValue(source.order, 0) || 0),
          holderHtmlId: text(source.holderHtmlId),
          targetingId: text(source.targetingId),
          numericSku: numericSku
        });
      }
      var zeroAddonPayload = Object.assign({}, stableIdentity, {
        order: Number(numberValue(source.order, 0) || 0),
        holderHtmlId: text(source.holderHtmlId),
        targetingId: text(source.targetingId),
        addonKey: addon.addonKey || text(source.targetingId)
      });
      if (addon.addonType) zeroAddonPayload.addonType = addon.addonType;
      if (Number.isFinite(addon.addonBasePrice)) zeroAddonPayload.addonBasePrice = addon.addonBasePrice;
      if (addon.discountEligible) zeroAddonPayload.discountEligible = true;
      if (addon.useTypedQuantity) zeroAddonPayload.useTypedQuantity = true;
      if (addon.dontSayFree) zeroAddonPayload.dontSayFree = true;
      return zeroAddonPayload;
    }
    if (!numericSku && (!holderId || !valueId)) return null;
    var selectionPayload = Object.assign({}, stableIdentity, {
      order: Number(numberValue(source.order, 0) || 0),
      holderHtmlId: text(source.holderHtmlId),
      targetingId: text(source.targetingId)
    });
    if (numericSku) selectionPayload.numericSku = numericSku;
    return selectionPayload;
  }

  function serializeSelectedAddon(entry) {
    var source = entry && typeof entry === 'object' ? entry : {};
    var targetingId = text(source.targetingId);
    var rawKey = text(source.key || source.addonKey);
    var price = numberValue(source.pricing, numberValue(source.optionAddonPrice, numberValue(source.addonBasePrice, numberValue(source.addonPrice, NaN))));
    var explicitAddonType = normalizeAddonType(source.addonType);
    var hasNonZeroAddonPrice = Number.isFinite(price) && Math.abs(price) > 0.0001;
    var hasAddonKeyShape = /^addon-/i.test(rawKey) || /^addon-/i.test(targetingId);
    var key = text(
      hasAddonKeyShape
        ? (rawKey || targetingId)
        : ((explicitAddonType || hasNonZeroAddonPrice) ? (rawKey || targetingId) : '')
    ).toLowerCase();
    if (!key) return null;
    return {
      key: key,
      selectedLabel: text(source.selectedLabel || source.valueLabel || source.label || source.addonLabel)
    };
  }

  function normalizeSelectedAddons(value) {
    return (Array.isArray(value) ? value : []).map(serializeSelectedAddon).filter(Boolean).slice(0, 100);
  }

  function serializeAddonConfig(value, fallbackKey) {
    var source = value && typeof value === 'object' ? value : {};
    var key = text(source.key || source.addonKey || source.targetingId || fallbackKey).toLowerCase();
    if (!key) return null;
    var price = numberValue(
      source.pricing,
      numberValue(
        source.optionAddonPrice,
        numberValue(source.addonBasePrice, numberValue(source.addonPrice, NaN))
      )
    );
    return {
      key: key,
      addonLabel: text(source.addonLabel || source.label || source.holderLabel),
      addonName: text(source.addonName || source.name || source.valueLabel),
      addonType: normalizeAddonType(source.addonType) || (Number.isFinite(price) ? 'quantityBased' : 'flat'),
      pricing: Number.isFinite(price) ? price : 0,
      optionAddonPrice: Number.isFinite(price) ? price : null,
      discountEligible: !!source.discountEligible,
      excludeFromCart: !!source.excludeFromCart,
      useTypedQuantity: !!source.useTypedQuantity,
      isPostage: !!source.isPostage,
      dontSayFree: !!source.dontSayFree
    };
  }

  function normalizeAddonByKey(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    var result = {};
    Object.keys(value).slice(0, 100).forEach(function (key) {
      var addon = serializeAddonConfig(value[key], key);
      if (addon) result[addon.key] = addon;
    });
    return result;
  }

  // The context identity alone is selection-blind — printing/sides/variant/
  // option/quantity choices are launch params, not identity fields — which
  // let a relaunch after an option change silently reuse the previous editor
  // session (the fast-click stale-selection race). The bootstrap cache key
  // canonicalizes the launch URL: every selection-bearing param, none of the
  // volatile transport params (bgReturnUrl and friends are stripped), so two
  // launches share an identity only when they are the same launch.
  function buildEditorLaunchIdentity(config, context, launchUrl) {
    var identity = buildEditorContextIdentity(context);
    var launchKey = text(launchUrl) ? getBootstrapCacheKeyForLaunchUrl(config, launchUrl) : '';
    return launchKey ? identity + '|' + launchKey : identity;
  }

  function buildEditorContextIdentity(context) {
    var source = context && typeof context === 'object' ? context : {};
    var projectId = text(source.projectId);
    var projectRefreshToken = text(source.projectRefreshToken);
    var launchMode = text(source.launchMode || source.bgLaunchMode).toLowerCase();
    if (launchMode !== 'blank' && launchMode !== 'upload') launchMode = '';
    if (projectId) {
      return [
        'project',
        text(source.source),
        text(source.productHandle || source.handle),
        projectId,
        projectRefreshToken,
        launchMode
      ].join('|');
    }
    var template = source.template && typeof source.template === 'object' ? source.template : {};
    var size = source.size && typeof source.size === 'object' ? source.size : {};
    return [
      'template',
      text(source.source),
      text(source.productHandle || source.handle),
      text(source.templateLookup || template.templateLookup || template.templatePublicId || template.publicId),
      text(source.designId || template.designId),
      text(source.designNumber || template.designNumber),
      text(source.backer || template.backer),
      text(size.selectedSizeId || size.id || size.targetingId),
      text(source.selectedOrientation || size.selectedOrientation || template.orientation),
      launchMode
    ].join('|');
  }

  function normalizeCompletionConfirmation(value) {
    var source = value && typeof value === 'object' ? value : {};
    return {
      accepted: source.accepted === true,
      acceptedAt: text(source.acceptedAt),
      documentFingerprint: text(source.documentFingerprint),
      issueCodes: uniqueStrings(Array.isArray(source.issueCodes) ? source.issueCodes : [])
    };
  }

  function normalizeCompletionReview(value) {
    var source = value && typeof value === 'object' ? value : {};
    return {
      operatorReviewRequired: source.operatorReviewRequired === true,
      customerConfirmationRequired: source.customerConfirmationRequired === true,
      issueCodes: uniqueStrings(Array.isArray(source.issueCodes) ? source.issueCodes : []),
      notes: uniqueStrings(Array.isArray(source.notes) ? source.notes : [])
    };
  }

  function normalizeCompletionIssue(value) {
    var source = value && typeof value === 'object' ? value : {};
    var code = text(source.code);
    var title = text(source.title);
    if (!code || !title) return null;
    return {
      code: code,
      severity: text(source.severity) || 'warning',
      disposition: text(source.disposition) || 'advisory',
      occurrenceCount: Math.max(1, numberValue(source.occurrenceCount, 1) || 1),
      title: title,
      message: text(source.message)
    };
  }

  function normalizeCompletionIssues(value) {
    var source = Array.isArray(value) ? value : [];
    var seen = Object.create(null);
    return source.map(normalizeCompletionIssue).filter(function (entry) {
      if (!entry) return false;
      var key = entry.disposition + ':' + entry.code;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function normalizeCompletionState(value) {
    var source = value && typeof value === 'object' ? value : {};
    var decision = text(source.decision);
    var reason = text(source.reason);
    var checkedAt = text(source.checkedAt);
    var message = text(source.message);
    var allowed = typeof source.allowed === 'boolean'
      ? source.allowed
      : (decision === 'allowed' || decision === 'allowed_with_confirmation');
    var confirmation = normalizeCompletionConfirmation(source.confirmation);
    var review = normalizeCompletionReview(source.review);
    var issues = normalizeCompletionIssues(source.issues);
    if (!decision && !reason && !checkedAt && !message && allowed !== true && !confirmation.accepted && !confirmation.documentFingerprint && !review.issueCodes.length && !review.notes.length && !issues.length) {
      return null;
    }
    return {
      allowed: allowed,
      decision: decision,
      reason: reason,
      message: message,
      checkedAt: checkedAt,
      hardBlockCount: Math.max(0, numberValue(source.hardBlockCount, 0) || 0),
      confirmationRequiredCount: Math.max(0, numberValue(source.confirmationRequiredCount, 0) || 0),
      confirmation: confirmation,
      review: review,
      issues: issues
    };
  }

  function normalizeDesignerQuantityMode(value) {
    var normalized = text(value);
    if (normalized === 'promoSlider' || normalized === 'apparelMatrix' || normalized === 'dropdown') {
      return normalized;
    }
    return '';
  }

  function normalizeApparelSizes(value) {
    var source = value && typeof value === 'object' ? value : {};
    var sizes = {};
    Object.keys(source).forEach(function (key) {
      var cleanKey = text(key);
      var qty = Math.max(0, numberValue(source[key], 0) || 0);
      if (!cleanKey || qty <= 0) return;
      sizes[cleanKey] = Math.round(qty);
    });
    return sizes;
  }

  function normalizeStringList(value) {
    if (!Array.isArray(value)) return [];
    return uniqueStrings(value.map(text).filter(Boolean));
  }

  function normalizePositiveIntegerList(value) {
    if (!Array.isArray(value)) return [];
    return value.map(function (entry) {
      return Math.max(0, Math.round(numberValue(entry, 0) || 0));
    }).filter(function (entry, index, source) {
      return entry > 0 && source.indexOf(entry) === index;
    }).sort(function (left, right) {
      return left - right;
    });
  }

  function buildTurnaroundPropertyValue(value) {
    var clean = text(value).replace(/\s+/g, ' ');
    if (!clean) return '';
    if (/after proof approval\.?$/i.test(clean)) {
      return clean.replace(/\s*\.*$/, '.');
    }
    return clean.replace(/\s*\.*$/, '') + ' after proof approval.';
  }

  // PRICING-TIER-RENAME-A (2026-10-11): the staff-assigned Partner tier.
  // Release A reads a price record, cart line or customer tag under the tier's
  // former name too (pricing data, stored bundles and carts from before the
  // rename); everything the theme writes carries only the new name. Release B
  // removes the former name. The price slot (3, after the member plans) is unchanged.
  var PARTNER_TIER_PRICE_KEY = 'pricePartnerTier';
  var PARTNER_TIER_TAG = 'PartnerTier';
  var LEGACY_PARTNER_TIER_PRICE_KEY = 'priceMattSmith';
  var LEGACY_PARTNER_TIER_TAG = LEGACY_PARTNER_TIER_PRICE_KEY.slice('price'.length);

  // The amount a record holds for a price key. For the Partner tier the new
  // key wins when the record has a value there; the former key is read only
  // when it does not.
  function readTierPrice(record, key) {
    if (!record || typeof record !== 'object') return undefined;
    var value = record[key];
    if ((value === undefined || value === null) && key === PARTNER_TIER_PRICE_KEY) return record[LEGACY_PARTNER_TIER_PRICE_KEY];
    return value;
  }

  // A price record with the tier's former key written under the new key, in
  // the same place (the new key wins when both are there). A record without the
  // former key is returned as it is; otherwise a copy, never the shared object.
  function withPartnerTierPriceKey(record) {
    if (!record || typeof record !== 'object' || Array.isArray(record)) return record;
    if (!Object.prototype.hasOwnProperty.call(record, LEGACY_PARTNER_TIER_PRICE_KEY)) return record;
    var hasNewKey = record[PARTNER_TIER_PRICE_KEY] !== undefined && record[PARTNER_TIER_PRICE_KEY] !== null;
    var next = {};
    Object.keys(record).forEach(function (key) {
      if (key === LEGACY_PARTNER_TIER_PRICE_KEY) {
        if (!hasNewKey) next[PARTNER_TIER_PRICE_KEY] = record[key];
      } else if (key !== PARTNER_TIER_PRICE_KEY || hasNewKey) {
        next[key] = record[key];
      }
    });
    return next;
  }

  // Pricing data ({ pricing: { sku: row } }) with every row's tier under the
  // new key. Data without the former key is returned as it is.
  function withPartnerTierPricingData(data) {
    var pricing = data && typeof data === 'object' && data.pricing && typeof data.pricing === 'object' ? data.pricing : null;
    if (!pricing) return data;
    var changed = false;
    var nextPricing = {};
    Object.keys(pricing).forEach(function (sku) {
      var row = withPartnerTierPriceKey(pricing[sku]);
      if (row !== pricing[sku]) changed = true;
      nextPricing[sku] = row;
    });
    return changed ? Object.assign({}, data, { pricing: nextPricing }) : data;
  }

  function normalizePriceEntry(value, options) {
    var source = value && typeof value === 'object' ? value : {};
    var settings = options && typeof options === 'object' ? options : {};
    var payload = {};
    [
      'price',
      PARTNER_TIER_PRICE_KEY,
      'priceBrokerBasic',
      'priceBrokerPremium',
      'priceFriendsFamily'
    ].forEach(function (key) {
      var amount = numberValue(readTierPrice(source, key), NaN);
      // BD-ZERO-TIER-CELL: a staff tier at or below zero, blank or unreadable
      // is no tier price (retail), as the Worker's canonical row keeps it.
      if (key === 'price' ? Number.isFinite(amount) : amount > 0) {
        payload[key] = amount;
      }
    });
    if (!settings.compact) {
      var estTurnaround = buildTurnaroundPropertyValue(source.estTurnaround);
      if (estTurnaround) {
        payload.estTurnaround = estTurnaround;
      }
    }
    return Object.keys(payload).length ? payload : null;
  }

  function parseSkuQuantity(finalSku) {
    var match = text(finalSku).match(/q(\d+)$/i);
    return match ? Number(numberValue(match[1], NaN)) : NaN;
  }

  function calculateCartTransformAddonTotals(optionSelections, quantity, typedQuantity, selectedAddons, addonByKey) {
    var selectedQuantity = Math.max(1, numberValue(quantity, 1) || 1);
    var selectedTypedQuantity = Math.max(1, numberValue(typedQuantity, selectedQuantity) || selectedQuantity);
    var entries = [];
    var seenKeys = {};
    var pushEntry = function (entry) {
      if (!entry || typeof entry !== 'object') return;
      var key = text(entry.key || entry.addonKey || entry.targetingId);
      if (key) {
        if (seenKeys[key]) return;
        seenKeys[key] = true;
      }
      entries.push(entry);
    };
    (Array.isArray(optionSelections) ? optionSelections : []).forEach(pushEntry);
    (Array.isArray(selectedAddons) ? selectedAddons : []).forEach(pushEntry);
    var result = {
      eligibleTotal: 0,
      nonEligibleTotal: 0
    };
    entries.forEach(function (entry) {
      var key = text(entry.key || entry.addonKey || entry.targetingId);
      var mapped = key && addonByKey && typeof addonByKey === 'object' && addonByKey[key] && typeof addonByKey[key] === 'object'
        ? Object.assign({}, addonByKey[key], entry)
        : entry;
      if (mapped && typeof mapped === 'object' && !Number.isFinite(numberValue(mapped.addonBasePrice, NaN))) {
        var mappedPrice = numberValue(mapped.pricing, numberValue(mapped.optionAddonPrice, NaN));
        if (Number.isFinite(mappedPrice)) {
          mapped = Object.assign({}, mapped, { addonBasePrice: mappedPrice });
        }
      }
      var addon = normalizeAddonSelection(mapped);
      if (!addon.hasAddon || !Number.isFinite(addon.addonBasePrice)) return;
      if (Math.abs(addon.addonBasePrice) <= 0.0001) return;
      if (addon.isPostage || addon.excludeFromCart) return;
      var unitQuantity = addon.useTypedQuantity ? selectedTypedQuantity : selectedQuantity;
      var amount = scaleMoney(addon.addonBasePrice, addon.addonType === 'flat' ? 1 : unitQuantity, 1);
      if (Math.abs(amount) <= 0.0001) return;
      if (addon.discountEligible && amount > 0.005) {
        result.eligibleTotal = roundMoney(result.eligibleTotal + amount);
      } else {
        result.nonEligibleTotal = roundMoney(result.nonEligibleTotal + amount);
      }
    });
    return result;
  }

  function calculateCartTransformDesignAmount(payload, profile) {
    var source = payload && typeof payload === 'object' ? payload : {};
    var profileSettings = profile && typeof profile === 'object' ? profile : {};
    var mode = normalizeArtworkMode(source.artworkMode);
    var amount = 0;
    var discountPct = 0;
    if (mode === 'editservice') {
      amount = numberValue(source.editServiceCost, NaN);
      if (!Number.isFinite(amount)) {
        amount = numberValue(source.template && source.template.editServiceCost, 0);
      }
      discountPct = numberValue(profileSettings.editServiceDiscountPct, 0);
    } else if (mode === 'customdesign') {
      amount = numberValue(source.customDesignCost, NaN);
      if (!Number.isFinite(amount)) {
        amount = numberValue(source.customDesignAmount, 0);
      }
      discountPct = numberValue(profileSettings.customDesignDiscountPct, 0);
    }
    if (!(amount > 0.005)) return 0;
    var kept = keepShareOfMoney(amount, discountPct);
    return Number.isFinite(kept) ? kept : 0;
  }

  // EXACT-CENTS-CATALOG (2026-10-03): an authored value prices a line only for
  // the compact value it rounds to (half up, as the pricing map stores it). A
  // cart edit rebuilds the stored state with Object.assign, so the OLD authored
  // row can sit beside a NEW compact row; that row must never price another
  // bracket. A key that does not match keeps the compact value, scaled exactly.
  function overlayAuthoredPriceEntry(priceEntry, authoredPriceEntry) {
    var result = Object.assign({}, priceEntry);
    var authored = normalizePriceEntry(authoredPriceEntry, { compact: true });
    if (!authored) return result;
    Object.keys(authored).forEach(function (key) {
      var compactCents = Math.round(numberValue(priceEntry && priceEntry[key], NaN) * 100);
      var authoredCents = Math.round(scaleMoney(authored[key], 1, 1) * 100);
      if (Number.isFinite(compactCents) && compactCents === authoredCents) result[key] = authored[key];
    });
    return result;
  }

  function buildCartTransformLinePriceEntry(payload, priceEntry) {
    var source = payload && typeof payload === 'object' ? payload : {};
    var price = priceEntry && typeof priceEntry === 'object' ? priceEntry : null;
    if (!price || !Number.isFinite(numberValue(price.price, NaN))) return null;
    var finalSku = text(source.finalSku);
    var paidPrintQty = Math.max(1, numberValue(source.paidPrintQty || source.paidPrintQuantity || source.printQuantity, 1) || 1);
    var typedQty = Math.max(1, numberValue(source.typedQuantity || source.typedQty || source.printQuantity || paidPrintQty, paidPrintQty) || paidPrintQty);
    var bracketQty = parseSkuQuantity(finalSku);
    // EXACT-CENTS-PR3: every line is built from the row as authored (when the
    // state carries it) with the quote engine arithmetic, the number its page
    // shows. A state from older bytes without the authored row is scaled
    // exactly from the compact row it carries.
    var authored = overlayAuthoredPriceEntry(price, source.authoredPriceEntry);
    var scalePrice = function (amount) {
      var parsed = numberValue(amount, NaN);
      if (!Number.isFinite(parsed)) return NaN;
      return Number.isFinite(bracketQty) && bracketQty > 0 ? scaleMoney(parsed, paidPrintQty, bracketQty) : scaleMoney(parsed, 1, 1);
    };
    var retailProduct = scalePrice(authored.price);
    if (!Number.isFinite(retailProduct)) return null;
    var addonTotals = calculateCartTransformAddonTotals(
      source.optionSelections,
      paidPrintQty,
      typedQty,
      source.selectedAddons,
      source.addonByKey
    );
    var sizeSurchargeTotal = Number(numberValue(source.sizeSurchargeTotal, 0) || 0);
    var calculateProfile = function (profile) {
      var settings = profile && typeof profile === 'object' ? profile : {};
      var productAmount = retailProduct;
      if (settings.specialPriceKey) {
        var specialAmount = scalePrice(readTierPrice(authored, settings.specialPriceKey));
        productAmount = Number.isFinite(specialAmount) ? specialAmount : retailProduct;
      } else if (settings.productDiscountPct) {
        productAmount = keepShareOfMoney(retailProduct, settings.productDiscountPct);
      }
      // EXACT-CENTS-PLAN-PERCENT: each part in whole cents (the plan or tier
      // share of the product and of the eligible add-ons rounded on its own, as
      // the quote engine does), then the parts summed.
      var addonAmount = addonTotals.nonEligibleTotal + keepShareOfMoney(addonTotals.eligibleTotal, settings.discountAddons);
      return roundMoney(productAmount + sizeSurchargeTotal + addonAmount + calculateCartTransformDesignAmount(source, settings));
    };
    var entry = {
      price: calculateProfile({}),
      priceProPlan: calculateProfile({
        editServiceDiscountPct: 0.5,
        customDesignDiscountPct: 0.25
      }),
      priceUltimatePlan: calculateProfile({
        productDiscountPct: 0.05,
        editServiceDiscountPct: 1,
        customDesignDiscountPct: 0.5,
        discountAddons: 0.05
      })
    };
    [
      [PARTNER_TIER_PRICE_KEY, PARTNER_TIER_PRICE_KEY],
      ['priceBrokerBasic', 'priceBrokerBasic'],
      ['priceBrokerPremium', 'priceBrokerPremium'],
      ['priceFriendsFamily', 'priceFriendsFamily']
    ].forEach(function (pair) {
      var outputKey = pair[0];
      var sourceKey = pair[1];
      // BD-ZERO-TIER-CELL: only a positive tier cell prices the tier; any
      // other cell leaves the key out and the Cart Transform charges `price`.
      if (numberValue(readTierPrice(authored, sourceKey), NaN) > 0) {
        entry[outputKey] = calculateProfile({
          specialPriceKey: sourceKey,
          discountAddons: 0.3
        });
      }
    });
    return entry;
  }

  function normalizeApparelSizeSurcharges(value) {
    var source = value && typeof value === 'object' ? value : {};
    var next = {};
    Object.keys(source).forEach(function (key) {
      var cleanKey = text(key);
      if (!cleanKey) return;
      var amount = Number(numberValue(source[key], 0) || 0);
      if (amount > 0) {
        next[cleanKey] = amount;
      }
    });
    return next;
  }

  function buildApparelSizesPropertyValue(value) {
    var sizes = normalizeApparelSizes(value);
    var keys = Object.keys(sizes);
    if (!keys.length) return '';
    return keys.map(function (key) {
      return key + ': ' + String(sizes[key]);
    }).join(', ');
  }

  function truncatePropertyText(value, limit) {
    var clean = text(value);
    var max = Math.max(1, Number(limit || 0) || 1024);
    if (clean.length <= max) return clean;
    return clean.slice(0, Math.max(0, max - 1)).trim() + '…';
  }

  function normalizeEddmRoute(entry) {
    var source = entry && typeof entry === 'object' ? entry : {};
    var routeId = text(source.routeId || source.id || source.crid);
    var zip = text(source.zip || source.zipCode || source.zip_code);
    var crid = text(source.crid || source.cridId || source.crid_id);
    if (!routeId && zip && crid) routeId = zip + '-' + crid;
    return {
      routeId: routeId,
      zip: zip,
      crid: crid,
      routeType: text(source.routeType || source.route_type),
      dataVersion: text(source.dataVersion || source.data_version),
      residential: Number(numberValue(source.residential || source.residentialCount || source.res_cnt, 0) || 0),
      business: Number(numberValue(source.business || source.businessCount || source.bus_cnt, 0) || 0),
      total: Number(numberValue(source.total || source.totalCount || source.tot_cnt, 0) || 0)
    };
  }

  function normalizeEddmState(value) {
    var source = value && typeof value === 'object' ? value : null;
    if (!source) return null;
    var selectedRoutes = Array.isArray(source.selectedRoutes)
      ? source.selectedRoutes.map(normalizeEddmRoute).filter(function (entry) {
        return entry.routeId || entry.zip || entry.crid;
      })
      : [];
    var routeDetails = truncatePropertyText(source.routeDetails, 1400);
    var routeGroupUuid = text(source.routeGroupUuid);
    var totalAddresses = Number(numberValue(source.totalAddresses, 0) || 0);
    var routeCount = Number(numberValue(source.selectedRouteCount || source.routes || selectedRoutes.length, selectedRoutes.length) || 0);
    var hasSelection = !!(routeGroupUuid || routeDetails || totalAddresses > 0 || routeCount > 0 || selectedRoutes.length);
    if (!hasSelection && !source.active) return null;
    return {
      provider: text(source.provider),
      dataVersion: text(source.dataVersion),
      routeGroupUuid: routeGroupUuid,
      targetInMailboxDate: text(source.targetInMailboxDate),
      routesSelected: !!(source.routesSelected || hasSelection),
      selectedRouteCount: routeCount,
      residentialAddresses: Number(numberValue(source.residentialAddresses, 0) || 0),
      businessAddresses: Number(numberValue(source.businessAddresses, 0) || 0),
      totalAddresses: totalAddresses,
      residentialOnly: !!source.residentialOnly,
      politicalMailer: !!source.politicalMailer,
      routeDetails: routeDetails,
      selectedRoutes: selectedRoutes.slice(0, 100)
    };
  }

  function normalizeUploadFiles(value) {
    return (Array.isArray(value) ? value : []).map(function (entry) {
      var source = entry && typeof entry === 'object' ? entry : {};
      return {
        uploadRef: text(source.uploadRef),
        name: text(source.name || source.fileName),
        fileName: text(source.fileName || source.name),
        url: text(source.url || source.publicUrl),
        publicUrl: text(source.publicUrl || source.url),
        objectKey: text(source.objectKey),
        contentType: text(source.contentType),
        byteSize: Math.max(0, Number(numberValue(source.byteSize, 0) || 0)),
        storageTarget: text(source.storageTarget)
      };
    }).filter(function (entry) {
      return !!(entry.uploadRef || entry.name || entry.fileName || entry.url || entry.publicUrl || entry.objectKey);
    });
  }

  function normalizeUploads(value) {
    return (Array.isArray(value) ? value : []).map(function (entry) {
      var source = entry && typeof entry === 'object' ? entry : {};
      var files = normalizeUploadFiles(source.files);
      return {
        id: text(source.id),
        label: text(source.label || source.id),
        files: files
      };
    }).filter(function (entry) {
      return !!(entry.id || entry.label || entry.files.length);
    });
  }

  function collectUploadedFileNames(state) {
    var payload = state && typeof state === 'object' ? state : {};
    var names = [];
    normalizeUploads(payload.uploads).forEach(function (entry) {
      entry.files.forEach(function (file) {
        var fileName = text(file.fileName || file.name);
        if (fileName) names.push(fileName);
      });
    });
    return names;
  }

  function normalizeCustomerInputs(value) {
    var allowedTypes = {
      short_text: true,
      long_text: true,
      number: true,
      phone: true,
      email: true,
      url: true,
      date: true,
      checkbox: true
    };
    var seenIds = Object.create(null);
    var seenLabels = Object.create(null);
    return (Array.isArray(value) ? value : []).slice(0, 20).map(function (entry) {
      var source = entry && typeof entry === 'object' ? entry : {};
      var id = text(source.id).toLowerCase();
      var label = truncatePropertyText(source.label, 80);
      var type = text(source.type).toLowerCase();
      if (!/^[a-z][a-z0-9_]{0,47}$/.test(id) || !label || !allowedTypes[type]) return null;
      var labelKey = label.toLowerCase();
      if (seenIds[id] || seenLabels[labelKey]) return null;
      seenIds[id] = true;
      seenLabels[labelKey] = true;
      return {
        id: id,
        label: label,
        type: type,
        value: type === 'checkbox'
          ? source.value === true
          : truncatePropertyText(source.value, 1000)
      };
    }).filter(Boolean);
  }

  function readLegacyTemplateRowId(template) {
    var source = template && typeof template === 'object' ? template : {};
    var foundationTemplateId = text(source.foundationTemplateId);
    if (foundationTemplateId.indexOf('legacy_design_template_') === 0) return foundationTemplateId;
    var designId = text(source.designId);
    if (designId.indexOf('legacy_design_template_') === 0) return designId;
    return '';
  }

  function normalizeChannelOfferOrigin(value) {
    var source = value && typeof value === 'object' ? value : {};
    if (!text(source.offerId) || text(source.offerId).length > 160
      || !/^co1_[a-f0-9]{64}$/.test(text(source.revisionId))
      || !/^\d+$/.test(text(source.variantId))
      || !/^\d+$/.test(text(source.productId))
      || (source.mode !== 'native' && source.mode !== 'custom')) return null;
    return { offerId: text(source.offerId), revisionId: text(source.revisionId), variantId: text(source.variantId),
      productId: text(source.productId), mode: source.mode, designIncluded: source.designIncluded === true };
  }

  // Only a confirmed, same-product catalog can select merchandise on the page.
  // These browser helpers are not a pricing authority: the server validates
  // custom entitlements and Shopify owns a native variant's selling price.
  function normalizeChannelCatalog(value, productId) {
    var source = value && typeof value === 'object' ? value : {};
    var baseId = text(source.calculatorVariantId);
    if (source.version !== 1 || !/^\d+$/.test(baseId) || !Array.isArray(source.offers) || source.offers.length > 100) return null;
    var seen = Object.create(null);
    var offers = [];
    for (var i = 0; i < source.offers.length; i += 1) {
      var offer = source.offers[i] || {};
      var identity = normalizeChannelOfferOrigin({ offerId: offer.offerId, revisionId: offer.revisionId,
        variantId: offer.variantId, productId: offer.product && offer.product.id, mode: 'native', designIncluded: offer.designIncluded });
      var quantity = Number(offer.packageQuantity);
      var cents = Number(offer.price && offer.price.amountCents);
      if (!identity || identity.productId !== text(productId) || identity.variantId === baseId || seen[identity.variantId]
        || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 10000000
        || !Number.isSafeInteger(cents) || cents < 0 || !/^[A-Z]{3}$/.test(text(offer.price && offer.price.currency))
        || !offer.selections || typeof offer.selections !== 'object' || Array.isArray(offer.selections)) return null;
      var selections = Object.create(null);
      var keys = Object.keys(offer.selections);
      if (keys.length > 200) return null;
      for (var j = 0; j < keys.length; j += 1) {
        var key = keys[j];
        if (!key || /^(?:__proto__|constructor|prototype)$/.test(key) || typeof offer.selections[key] !== 'string' || !text(offer.selections[key])) return null;
        selections[key] = offer.selections[key];
      }
      var services = offer.designServiceChoices || [];
      if (!Array.isArray(services) || services.length > 100 || services.some(function (choice) {
        return !choice || typeof choice.holderId !== 'string' || !text(choice.holderId)
          || typeof choice.valueId !== 'string' || !text(choice.valueId);
      })) return null;
      seen[identity.variantId] = true;
      offers.push({ offerId: identity.offerId, revisionId: identity.revisionId, variantId: identity.variantId,
        productId: identity.productId, name: text(offer.name), packageQuantity: quantity, selections: selections,
        designServiceChoices: services.map(function (choice) { return { holderId: choice.holderId, valueId: choice.valueId }; }),
        designIncluded: identity.designIncluded, collectSizesAfterOrder: offer.collectSizesAfterOrder === true,
        includeSizeSurcharges: offer.includeSizeSurcharges === true,
        price: { amountCents: cents, currency: text(offer.price.currency) } });
    }
    return { version: 1, calculatorVariantId: baseId, offers: offers };
  }

  function findChannelOfferByVariant(catalog, variantId) {
    return catalog && Array.isArray(catalog.offers)
      ? catalog.offers.find(function (offer) { return offer.variantId === text(variantId); }) || null : null;
  }

  function channelOfferMatches(offer, current) {
    if (!offer || !current || Number(current.printQuantity) !== offer.packageQuantity) return false;
    var selections = current.selections && typeof current.selections === 'object' ? current.selections : {};
    var expected = Object.keys(offer.selections);
    if (Object.keys(selections).length !== expected.length || expected.some(function (key) { return selections[key] !== offer.selections[key]; })) return false;
    if (current.hasProject || current.hasTemplate || current.hasUploads || Number(current.artworkCharges || 0) !== 0) return false;
    if (current.apparelSizes && Object.keys(current.apparelSizes).some(function (size) { return Number(current.apparelSizes[size]) !== 0; })) return false;
    return current.artworkMode === 'customdesign' && offer.designIncluded || current.artworkMode === 'sendlater' || current.artworkMode === 'youhaveart';
  }

  function resolveChannelPurchase(catalog, origin, current) {
    var identity = normalizeChannelOfferOrigin(origin);
    var offer = identity && findChannelOfferByVariant(catalog, identity.variantId);
    if (!offer || identity.productId !== offer.productId || identity.offerId !== offer.offerId || identity.revisionId !== offer.revisionId) {
      return { pricingMode: 'custom', variantId: catalog ? catalog.calculatorVariantId : '', offer: null, designIncluded: false };
    }
    var native = channelOfferMatches(offer, current);
    return { pricingMode: native ? 'native' : 'custom', variantId: native ? offer.variantId : catalog.calculatorVariantId,
      offer: offer, designIncluded: offer.designIncluded };
  }

  function buildDesignerState(payload) {
    var source = payload && typeof payload === 'object' ? payload : {};
    // The protected sign lane quotes from the stored FULL state, so the
    // legacy edit-service lookup must live on its top level too (the
    // template block's templateLookup stays the launch-facing native id).
    var stateTemplateLookup = normalizeArtworkMode(source.artworkMode) === 'editservice'
      ? (text(source.templateLookup).indexOf('legacy_design_template_') === 0
        ? text(source.templateLookup)
        : readLegacyTemplateRowId(source.template))
      : '';
    var designerState = {
      runtimeVersion: text(source.runtimeVersion) || 'designer-storefront-v1',
      handle: text(source.handle),
      sourceHandle: text(source.sourceHandle),
      productId: text(source.productId),
      baseVariantId: text(source.baseVariantId),
      channelOffer: normalizeChannelOfferOrigin(source.channelOffer),
      templateLookup: stateTemplateLookup,
      quoteRevision: text(source.quoteRevision),
      pricingFingerprint: text(source.pricingFingerprint),
      quantityMode: normalizeDesignerQuantityMode(source.quantityMode),
      optionSelections: Array.isArray(source.optionSelections) ? source.optionSelections.map(function (entry) {
        return serializeOptionSelection(entry, false);
      }) : [],
      artworkSectionEnabled: source.artworkSectionEnabled !== false,
      artworkMode: normalizeArtworkMode(source.artworkMode),
      artworkLabel: text(source.artworkLabel),
      cartDesignEditor: normalizeCartDesignEditor(source.cartDesignEditor),
      launchProvider: normalizeLaunchProvider(
        source.launchProvider
        || source.provider
        || (source.project && source.project.provider)
      ),
      cartQuantityMode: normalizeCartQuantityMode(source.cartQuantityMode),
      template: source.template && typeof source.template === 'object' ? {
        designId: text(source.template.designId),
        designNumber: text(source.template.designNumber),
        templateLookup: text(source.template.templateLookup || source.template.templatePublicId || source.template.publicId),
        templatePublicId: text(source.template.templatePublicId || source.template.templateLookup || source.template.publicId),
        foundationTemplateId: text(source.template.foundationTemplateId),
        revision: text(source.template.revision || source.template.templateRevision),
        title: text(source.template.title),
        editServiceCost: Number(numberValue(source.template.editServiceCost, 0) || 0),
        editServiceOriginalCost: Number(numberValue(source.template.editServiceOriginalCost, source.template.editServiceCost) || 0),
        previewUrl: text(source.template.previewUrl || (Array.isArray(source.template.previews) ? source.template.previews[0] : '')),
        previews: Array.isArray(source.template.previews) ? source.template.previews.map(text).filter(Boolean) : [],
        backer: text(source.template.backer),
        backerLabel: text(source.template.backerLabel),
        orientation: text(source.template.orientation)
      } : null,
      project: source.project && typeof source.project === 'object' ? {
        projectId: text(source.project.projectId),
        designId: text(source.project.designId),
        designNumber: text(source.project.designNumber),
        title: text(source.project.title || source.project.name || source.project.designTitle),
        updatedAt: text(source.project.updatedAt || source.project.lastEditedAt || source.project.modifiedAt),
        documentOrientation: text(source.project.documentOrientation),
        previewUrl: text(source.project.previewUrl),
        previews: Array.isArray(source.project.previews) ? source.project.previews.map(text).filter(Boolean) : [],
        numPages: Number(numberValue(source.project.numPages || source.project.pages || source.project.pageCount || source.project.pageLength, 0) || 0),
        // EDITOR-LANES-EMPTY-SAVE-01: the document-derived artwork truth,
        // carried only once it is known (a reload must not invent one).
        hasArtwork: typeof source.project.hasArtwork === 'boolean' ? source.project.hasArtwork : undefined,
        refreshToken: text(source.project.refreshToken),
        provider: normalizeLaunchProvider(source.project.provider)
      } : null,
      completion: normalizeCompletionState(source.completion),
      canvaUrl: text(source.canvaUrl),
      guidedFill: source.guidedFill && typeof source.guidedFill === 'object' ? {
        armed: source.guidedFill.armed === true,
        projectId: text(source.guidedFill.projectId)
      } : null,
      customerInputs: normalizeCustomerInputs(source.customerInputs),
      uploads: normalizeUploads(source.uploads),
      finalSku: text(source.finalSku),
      priceEntry: normalizePriceEntry(source.priceEntry || source.priceRecord || source.priceObj),
      selectedAddons: normalizeSelectedAddons(source.selectedAddons),
      addonByKey: normalizeAddonByKey(source.addonByKey),
      editServiceCost: Number(numberValue(source.editServiceCost, 0) || 0),
      editServiceOriginalCost: Number(numberValue(source.editServiceOriginalCost, source.editServiceCost) || 0),
      customDesignCost: Number(numberValue(source.customDesignCost, 0) || 0),
      templatePersonalizationAmount: Number(numberValue(source.templatePersonalizationAmount, 0) || 0),
      customDesignAmount: Number(numberValue(source.customDesignAmount, 0) || 0),
      printQuantity: Number(numberValue(source.printQuantity, 0) || 0),
      typedQuantity: Number(numberValue(source.typedQuantity || source.typedQty, 0) || 0),
      paidPrintQty: Number(numberValue(source.paidPrintQty || source.paidPrintQuantity, 0) || 0),
      quantityLockedToPricingTable: source.quantityLockedToPricingTable === true || source.lockedToPricingTable === true,
      quantityPriceQuantities: normalizePositiveIntegerList(source.quantityPriceQuantities || source.priceQuantities),
      quantityMin: Number(numberValue(source.quantityMin, 0) || 0),
      quantityMax: Number(numberValue(source.quantityMax, 0) || 0),
      quantityStep: Number(numberValue(source.quantityStep, 0) || 0),
      setCount: Number(numberValue(source.setCount, 0) || 0),
      apparelSizes: normalizeApparelSizes(source.apparelSizes),
      sizeSurchargeTotal: Number(numberValue(source.sizeSurchargeTotal, 0) || 0),
      apparelAvailableSizes: normalizeStringList(source.apparelAvailableSizes),
      apparelSizeSurcharges: normalizeApparelSizeSurcharges(source.apparelSizeSurcharges),
      apparelMinQty: Number(numberValue(source.apparelMinQty, 0) || 0),
      apparelDefaultQty: Number(numberValue(source.apparelDefaultQty, 0) || 0),
      apparelDefaultSize: text(source.apparelDefaultSize),
      selectedSizeId: text(source.selectedSizeId),
      selectedSizeLabel: text(source.selectedSizeLabel),
      selectedWidth: text(source.selectedWidth),
      selectedHeight: text(source.selectedHeight),
      selectedUnit: text(source.selectedUnit),
      selectedOrientation: text(source.selectedOrientation),
      selectedSidesId: text(source.selectedSidesId),
      selectedSidesLabel: text(source.selectedSidesLabel),
      selectedSidesTargetingId: text(source.selectedSidesTargetingId),
      sidesPolicy: source.sidesPolicy && typeof source.sidesPolicy === 'object' ? deepClone(source.sidesPolicy, {}) : null,
      selectedPrintingId: text(source.selectedPrintingId),
      selectedPrintingLabel: text(source.selectedPrintingLabel),
      selectedPrintingTargetingId: text(source.selectedPrintingTargetingId),
      eddm: normalizeEddmState(source.eddm)
    };
    // EXACT-CENTS-PR3: the row as authored rides with the state whenever the
    // page or the cart wrote it, because every line is built from it. The core
    // never reads the per-line marker; it only carries it, since cart.js shows
    // a line signed before 2026-10-04 12:03Z (no marker) with its own arithmetic.
    // Same key order as before, so a marked state serializes byte for byte.
    if (source.quoteArithmetic === true) designerState.quoteArithmetic = true;
    var authoredPriceEntry = normalizePriceEntry(source.authoredPriceEntry, { compact: true });
    if (authoredPriceEntry) designerState.authoredPriceEntry = authoredPriceEntry;
    // MF-A: approval ticks ride the full state (never the compact one), so cart rebuilds keep them; only true is kept.
    var approvals = source.approvals && typeof source.approvals === 'object' ? source.approvals : {};
    if (approvals.designReviewApproved === true || approvals.customDesignApproved === true) {
      designerState.approvals = { designReviewApproved: approvals.designReviewApproved === true, customDesignApproved: approvals.customDesignApproved === true };
    }
    return designerState;
  }

  function buildPublicProperties(state) {
    var payload = state && typeof state === 'object' ? state : {};
    var properties = {};
    var selections = Array.isArray(payload.optionSelections)
      ? payload.optionSelections.slice().sort(function (a, b) {
        return (Number(a && a.order) || 0) - (Number(b && b.order) || 0);
      })
      : [];
    selections.forEach(function (entry) {
      var key = text(entry && entry.holderLabel);
      var value = buildSelectionDisplayLabel(entry);
      if (!key || !value) return;
      properties[key] = value;
    });
    if (payload.printQuantity) {
      properties.Quantity = String(payload.printQuantity);
    }
    var estTurnaround = buildTurnaroundPropertyValue(
      payload.estTurnaround
      || (payload.priceEntry && payload.priceEntry.estTurnaround)
      || (payload.priceRecord && payload.priceRecord.estTurnaround)
      || (payload.priceObj && payload.priceObj.estTurnaround)
    );
    if (estTurnaround) {
      properties['Est. Turnaround Time'] = estTurnaround;
    }
    var sizesSummary = buildApparelSizesPropertyValue(payload.apparelSizes);
    if (sizesSummary) {
      properties.Sizes = sizesSummary;
    }
    if (payload.setCount && payload.setCount > 1) {
      properties.Sets = String(payload.setCount);
    }
    if (payload.artworkSectionEnabled !== false && text(payload.artworkLabel)) {
      properties.Artwork = text(payload.artworkLabel);
    }
    if (payload.artworkMode === 'editservice') {
      var templatePersonalizationAmount = formatSignedMoneyProperty(payload.templatePersonalizationAmount);
      if (templatePersonalizationAmount) {
        properties['Template Personalization'] = templatePersonalizationAmount;
      }
    }
    if (payload.artworkMode === 'customdesign') {
      var customDesignAmount = formatSignedMoneyProperty(payload.customDesignAmount);
      if (customDesignAmount) {
        properties['Custom Design'] = customDesignAmount;
      }
    }
    if (text(payload.canvaUrl)) {
      properties['Canva Link'] = text(payload.canvaUrl);
    }
    normalizeCustomerInputs(payload.customerInputs).forEach(function (entry) {
      var value = entry.type === 'checkbox'
        ? (entry.value === true ? 'Yes' : '')
        : text(entry.value);
      if (!value || Object.prototype.hasOwnProperty.call(properties, entry.label)) return;
      properties[entry.label] = truncatePropertyText(value, 1000);
    });
    var uploadedFileNames = collectUploadedFileNames(payload);
    if (uploadedFileNames.length) {
      properties['Uploaded Files'] = uploadedFileNames.join(', ');
    }
    if (payload.project && text(payload.project.projectId)) {
      properties['Project ID'] = text(payload.project.projectId);
    }
    var designId = text(
      payload.project && payload.project.designId
        || payload.template && payload.template.designId
    );
    if (designId) {
      properties['_Design ID'] = designId;
    }
    var designNumber = text(
      payload.project && payload.project.designNumber
        || payload.template && payload.template.designNumber
    );
    if (designNumber) {
      properties['Design #'] = designNumber;
    }
    var backer = text(payload.template && (payload.template.backerLabel || payload.template.backer));
    if (backer) {
      properties.Backer = backer;
    }
    // RE1 reorder mark: staff and the customer see WHICH design is being
    // reordered (design number + title — never raw internal ids), or the
    // standing fallback promise when no design was picked. The value is
    // rebuilt from the stored designer state on every context sign, so
    // cart-side updates keep it consistent.
    var reorderState = payload.reorder && typeof payload.reorder === 'object' ? payload.reorder : null;
    if (reorderState) {
      var reorderValue = '';
      if (text(reorderState.source) === 'fallback') {
        reorderValue = 'We will reach out to you after checkout.';
      } else {
        var reorderNumber = text(reorderState.designNumber);
        var reorderTitle = text(reorderState.title);
        reorderValue = reorderNumber
          ? 'Design ' + reorderNumber + (reorderTitle ? ' "' + reorderTitle + '"' : '')
          : (reorderTitle || 'Previous design');
        // RE2 reference attach: a design from another product names its
        // source so staff know the artwork needs fitting to this order.
        var reorderSourceProduct = text(reorderState.sourceProduct);
        if (text(reorderState.source) === 'reference' && reorderSourceProduct) {
          reorderValue += ' — from ' + reorderSourceProduct;
        }
        // REORDER-REFERENCE-STAFF-REF: a reference loads no project, so a
        // design with no name and no number gave staff no pointer. Its lookup
        // rides one underscore property (hidden from the cart and checkout,
        // shown on the Shopify order). Reference mode only: a loaded-project
        // line keeps its single project id for the orders/create preflight.
        var reorderSourceRef = text(reorderState.sourceRef);
        if (text(reorderState.source) === 'reference' && reorderSourceRef) {
          properties['_Reorder Design ID'] = truncatePropertyText(reorderSourceRef, 255);
        }
      }
      properties.Reorder = truncatePropertyText(reorderValue, 255);
    }
    if (payload.eddm && typeof payload.eddm === 'object') {
      var eddm = normalizeEddmState(payload.eddm);
      if (eddm) {
        if (eddm.provider) properties['EDDM Provider'] = eddm.provider;
        if (eddm.dataVersion) properties['EDDM Data Version'] = eddm.dataVersion;
        if (eddm.routeGroupUuid) properties['EDDM Route Group'] = eddm.routeGroupUuid;
        if (eddm.targetInMailboxDate) properties['Target In-Mailbox Date'] = eddm.targetInMailboxDate;
        if (eddm.routesSelected || eddm.selectedRouteCount || eddm.residentialAddresses || eddm.businessAddresses || eddm.totalAddresses) {
          properties['EDDM Routes'] = String(eddm.selectedRouteCount || 0);
          properties['EDDM Residential Addresses'] = String(eddm.residentialAddresses || 0);
          properties['EDDM Business Addresses'] = String(eddm.businessAddresses || 0);
          properties['EDDM Total Addresses'] = String(eddm.totalAddresses || 0);
        }
        if (eddm.residentialOnly) properties['EDDM Residential Only'] = 'Yes';
        if (eddm.politicalMailer) properties['EDDM Political Mailer'] = 'Yes';
        if (eddm.routeDetails) properties['EDDM Route Details'] = truncatePropertyText(eddm.routeDetails, 1024);
      }
    }
    var postageTotal = calculateDesignerOptionAddOns(
      payload.optionSelections,
      payload.printQuantity || payload.paidPrintQty || payload.typedQuantity,
      payload.typedQuantity || payload.typedQty || payload.printQuantity
    ).postageTotal;
    if (postageTotal > 0.005) {
      properties.Postage = formatShopMoney(postageTotal) + ' will be invoiced separately.';
    }
    // MF-A: the approval rows are derived from the state, so signing and every re-sign rebuild them (staff keys below).
    var approvalState = payload.approvals && typeof payload.approvals === 'object' ? payload.approvals : {};
    if (approvalState.designReviewApproved === true) properties['Design Approval'] = 'I have reviewed and approve my design.';
    if (approvalState.customDesignApproved === true) properties.Approval = 'I acknowledge';
    return properties;
  }

  function buildCartTransformState(state) {
    var payload = state && typeof state === 'object' ? state : {};
    var selections = Array.isArray(payload.optionSelections)
      ? payload.optionSelections.map(function (entry) {
        return serializeCartTransformSelection(entry);
      }).filter(function (entry) {
        return !!(entry && typeof entry === 'object');
      })
      : [];
    var priceEntry = normalizePriceEntry(payload.priceEntry || payload.priceRecord || payload.priceObj, { compact: true });
    var linePriceEntry = buildCartTransformLinePriceEntry(payload, priceEntry);
    var selectedAddons = normalizeSelectedAddons(payload.selectedAddons);
    var addonByKey = normalizeAddonByKey(payload.addonByKey);
    var artworkMode = normalizeArtworkMode(payload.artworkMode || payload.artworkSelection || payload.artworkLabel);
    var compact = {
      runtimeVersion: text(payload.runtimeVersion || 'designer-storefront-v1'),
      handle: text(payload.handle),
      sourceHandle: text(payload.sourceHandle),
      productId: text(payload.productId),
      baseVariantId: text(payload.baseVariantId),
      finalSku: text(payload.finalSku),
    };
    if (!compact.handle) delete compact.handle;
    if (!compact.sourceHandle) delete compact.sourceHandle;
    if (!compact.productId) delete compact.productId;
    var quoteRevision = text(payload.quoteRevision);
    if (quoteRevision) compact.quoteRevision = quoteRevision;
    var pricingFingerprint = text(payload.pricingFingerprint);
    if (pricingFingerprint) compact.pricingFingerprint = pricingFingerprint;
    var channelOrigin = normalizeChannelOfferOrigin(payload.channelOffer);
    if (channelOrigin) compact.channelOffer = channelOrigin;
    if (priceEntry) compact.priceEntry = priceEntry;
    if (linePriceEntry) compact.linePriceEntry = linePriceEntry;
    var cartQuantityMode = normalizeCartQuantityMode(payload.cartQuantityMode);
    if (cartQuantityMode && (cartQuantityMode !== 'set_count' || channelOrigin)) compact.cartQuantityMode = cartQuantityMode;
    var printQuantity = Number(numberValue(payload.printQuantity, 0) || 0);
    if (printQuantity > 0) compact.printQuantity = printQuantity;
    var typedQty = Number(numberValue(payload.typedQuantity || payload.typedQty, 0) || 0);
    if (typedQty > 0 && typedQty !== printQuantity) compact.typedQty = typedQty;
    var paidPrintQty = Number(numberValue(payload.paidPrintQty || payload.paidPrintQuantity, 0) || 0);
    if (paidPrintQty > 0 && paidPrintQty !== printQuantity) compact.paidPrintQty = paidPrintQty;
    var sizeSurchargeTotal = Number(numberValue(payload.sizeSurchargeTotal, 0) || 0);
    if (sizeSurchargeTotal > 0) compact.sizeSurchargeTotal = sizeSurchargeTotal;
    var editServiceCost = Number(numberValue(payload.editServiceCost, 0) || 0);
    if (editServiceCost > 0) compact.editServiceCost = editServiceCost;
    var customDesignCost = Number(numberValue(payload.customDesignCost, 0) || 0);
    var customDesignAmount = Number(numberValue(payload.customDesignAmount, 0) || 0);
    if (artworkMode) {
      compact.artworkMode = artworkMode;
    }
    if (artworkMode === 'editservice') {
      // A legacy picker row is priced from ITS OWN legacy record, so its row
      // id must win over any product-level native lookup the selection
      // inherited (launch/bootstrap paths keep using template.templateLookup,
      // which stays untouched). Native selections never carry a
      // legacy_design_template_ id and keep the native lookup + revision.
      var legacyRowId = readLegacyTemplateRowId(payload.template);
      var templateLookup = legacyRowId
        || text(payload.templateLookup)
        || text(payload.template && (payload.template.templateLookup || payload.template.templatePublicId));
      if (templateLookup) compact.templateLookup = templateLookup;
      var templateRevision = text(payload.template && (payload.template.revision || payload.template.templateRevision));
      if (templateRevision && !legacyRowId) compact.templateRevision = templateRevision;
    }
    var quoteDiagnostics = {};
    if (artworkMode === 'editservice') {
      var diagnosticEditServiceCost = numberValue(payload.editServiceCost, NaN);
      var diagnosticEditServiceOriginalCost = numberValue(
        payload.editServiceOriginalCost,
        numberValue(payload.template && payload.template.editServiceOriginalCost, NaN)
      );
      if (Number.isFinite(diagnosticEditServiceCost) && diagnosticEditServiceCost >= 0) {
        quoteDiagnostics.editServiceCost = diagnosticEditServiceCost;
      }
      if (Number.isFinite(diagnosticEditServiceOriginalCost) && diagnosticEditServiceOriginalCost >= 0) {
        quoteDiagnostics.editServiceOriginalCost = diagnosticEditServiceOriginalCost;
      }
    } else if (artworkMode === 'customdesign') {
      var diagnosticCustomDesignCost = numberValue(payload.customDesignCost, NaN);
      if (Number.isFinite(diagnosticCustomDesignCost) && diagnosticCustomDesignCost >= 0) {
        quoteDiagnostics.customDesignCost = diagnosticCustomDesignCost;
      }
    }
    if (Object.keys(quoteDiagnostics).length) compact.quoteDiagnostics = quoteDiagnostics;
    if (artworkMode === 'customdesign' && customDesignAmount > 0) {
      compact.customDesignAmount = customDesignAmount;
    } else if (artworkMode === 'customdesign' && customDesignCost > 0) {
      compact.customDesignAmount = customDesignCost;
    }
    var templatePersonalizationAmount = Number(numberValue(payload.templatePersonalizationAmount, 0) || 0);
    if (templatePersonalizationAmount > 0) compact.templatePersonalizationAmount = templatePersonalizationAmount;
    var apparelSizes = normalizeApparelSizes(payload.apparelSizes);
    if (Object.keys(apparelSizes).length) compact.apparelSizes = apparelSizes;
    if (selections.length) compact.optionSelections = selections;
    if (!linePriceEntry && selectedAddons.length) compact.selectedAddons = selectedAddons;
    if (!linePriceEntry && Object.keys(addonByKey).length) compact.addonByKey = addonByKey;
    return compact;
  }

  function getCartTransformStateMapKey() {
    return CART_TRANSFORM_STATE_MAP_KEY;
  }

  function readDesignerStateFromProperties(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var serializedState = parseJson(source._bg_designer_state_v1, null);
    if (serializedState && typeof serializedState === 'object') {
      return serializedState;
    }
    var compactState = parseJson(source._bg_cart_transform_state_v1, null);
    if (compactState && typeof compactState === 'object') {
      return buildDesignerState(compactState);
    }
    return null;
  }

  var COMMERCE_CONTEXT_URL = '/apps/qps-commerce-control-plane/designer/commerce-contexts';
  var CART_TRANSFORM_SIGN_URL = '/apps/qps-commerce-control-plane/designer/cart-transform/sign';
  var COMMERCE_PROJECT_BOOTSTRAP_URL = '/apps/qps-commerce-control-plane/designer/session/bootstrap';
  var commerceContextCache = {};
  var commerceProjectSessionCache = Object.create(null);
  var STAFF_PROPERTY_KEYS = {
    Size: true,
    Paper: true,
    Material: true,
    Corners: true,
    Quantity: true,
    'Est. Turnaround Time': true,
    Sizes: true,
    Artwork: true,
    Reorder: true,
    '_Reorder Design ID': true,
    'Uploaded Files': true,
    '_Design ID': true,
    'Design #': true,
    '_Production SKU': true,
    '_Context ID': true,
    'Design Approval': true,
    Approval: true
  };
  var EXTRA_PUBLIC_PROPERTY_KEYS = [
    'Project ID',
    'Design ID',
    'Context ID',
    'QPS Context ID',
    'Production SKU',
    'Template Personalization',
    'Custom Design',
    'Est. Turnaround Time',
    'Canva Link',
    'Sets',
    'QR Code Link',
    'Imprint Information',
    'Design Approval',
    'Approval',
    'Uploaded Files'
  ];

  function readCommerceContextIdProperty(properties, fallback) {
    var source = properties && typeof properties === 'object' ? properties : {};
    return text(
      fallback
      || source._bg_context_id
      || source['_Context ID']
      || source['Context ID']
      || source['QPS Context ID']
    );
  }

  function readCommerceContextVersion(context, fallback) {
    var source = context && typeof context === 'object' ? context : {};
    var explicit = text(fallback || source.contextVersion);
    if (/^\d{13}$/.test(explicit)) return explicit;
    var parsed = Date.parse(text(source.updatedAt || (source.audit && source.audit.updatedAt)));
    return Number.isFinite(parsed) && parsed > 0 ? String(Math.round(parsed)) : '';
  }

  function hashCartToken(value) {
    var clean = text(value);
    if (!clean || !window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
      return Promise.resolve('');
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(clean)).then(function (buffer) {
      return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    }).catch(function () { return ''; });
  }

  function buildStaffOrderProperties(state, sourceProperties, contextId) {
    var payload = state && typeof state === 'object' ? state : {};
    var source = sourceProperties && typeof sourceProperties === 'object' ? sourceProperties : {};
    var publicProperties = buildPublicProperties(payload);
    // Product option rows are keyed by staff-authored holder labels (Sides,
    // Stakes, Stock, ...), so the static allowlist alone drops them whenever a
    // line is context-signed after a cart-side update.
    var holderLabelKeys = Object.create(null);
    (Array.isArray(payload.optionSelections) ? payload.optionSelections : []).forEach(function (entry) {
      var label = text(entry && entry.holderLabel);
      if (label) holderLabelKeys[label] = true;
    });
    normalizeCustomerInputs(payload.customerInputs).forEach(function (entry) {
      if (entry.label) holderLabelKeys[entry.label] = true;
    });
    var out = {};
    Object.keys(publicProperties).forEach(function (key) {
      if (!STAFF_PROPERTY_KEYS[key] && !holderLabelKeys[key]) return;
      var value = text(publicProperties[key]);
      if (!value) return;
      out[key] = value;
    });
    var finalSku = text(payload.finalSku || source._bg_final_sku || source['_Production SKU'] || source['Production SKU']);
    if (finalSku) out['_Production SKU'] = finalSku;
    var cleanContextId = readCommerceContextIdProperty(source, contextId);
    if (cleanContextId) out['_Context ID'] = cleanContextId;
    return out;
  }

  function readFormDataProperties(formData) {
    var properties = {};
    if (!formData || typeof formData.entries !== 'function') return properties;
    var matcher = /^properties\[(.+)\]$/;
    formData.forEach(function (value, key) {
      var match = String(key || '').match(matcher);
      if (!match) return;
      properties[match[1]] = value;
    });
    return properties;
  }

  function setFormDataProperty(formData, key, value) {
    if (!formData || typeof formData.set !== 'function') return;
    formData.set('properties[' + key + ']', text(value));
  }

  function deleteFormDataProperty(formData, key) {
    if (!formData || typeof formData.delete !== 'function') return;
    formData.delete('properties[' + key + ']');
  }

  function buildCommerceContextPayload(properties, options) {
    var settings = options && typeof options === 'object' ? options : {};
    var source = properties && typeof properties === 'object' ? properties : {};
    var fullState = parseJson(source._bg_designer_state_v1, null);
    if (!fullState || typeof fullState !== 'object') {
      fullState = readDesignerStateFromProperties(source);
    }
    if (!fullState || typeof fullState !== 'object') return null;
    var pricingState = parseJson(source._bg_cart_transform_state_v1, null);
    if (!pricingState || typeof pricingState !== 'object') {
      pricingState = buildCartTransformState(fullState);
    }
    var sourceContextId = readCommerceContextIdProperty(source);
    var staffProperties = buildStaffOrderProperties(fullState, source, sourceContextId);
    var project = fullState.project && typeof fullState.project === 'object' ? fullState.project : {};
    var template = fullState.template && typeof fullState.template === 'object' ? fullState.template : {};
    return {
      contextId: sourceContextId,
      storeKey: text(settings.storeKey),
      shop: text(settings.shop || (window.Shopify && window.Shopify.shop)),
      customerId: text(settings.customerId),
      cartTokenHash: text(settings.cartTokenHash),
      lineKey: text(settings.lineKey || source._bg_update_line_key),
      source: text(settings.source || 'storefront'),
      product: {
        handle: text(fullState.handle || source._bg_designer_handle),
        sourceHandle: text(fullState.sourceHandle || source._bg_designer_source_handle || fullState.handle || source._bg_designer_handle),
        productId: text(fullState.productId),
        baseVariantId: text(fullState.baseVariantId || source._bg_base_variant_id),
        finalSku: text(fullState.finalSku || source._bg_final_sku)
      },
      design: {
        provider: text(fullState.launchProvider || project.provider || source._bg_designer_provider),
        projectId: text(project.projectId),
        designId: text(project.designId || template.designId || source['_Design ID'] || source['Design ID']),
        designNumber: text(project.designNumber || template.designNumber || source['Design #']),
        templateLookup: text(template.templateLookup || template.templatePublicId || template.publicId),
        templatePublicId: text(template.templatePublicId || template.templateLookup || template.publicId),
        title: text(template.title),
        previewUrl: text(project.previewUrl || template.previewUrl),
        numPages: Number(numberValue(project.numPages || project.pages || project.pageCount || project.pageLength, 0) || 0),
        previews: Array.isArray(project.previews) && project.previews.length
          ? project.previews.map(text).filter(Boolean)
          : (Array.isArray(template.previews) ? template.previews.map(text).filter(Boolean) : [])
      },
      properties: {
        staffProperties: staffProperties,
        pricingState: pricingState,
        fullState: fullState
      }
    };
  }

  function shouldDeleteCommerceContextProperty(key) {
    if (!key) return false;
    if (key === '_bg_update_line_key') return true;
    if (key === '_bg_reprice_nonce') return true;
    if (key.indexOf('_bg_completion_') === 0) return true;
    return false;
  }

  function applyCommerceContextToProperties(properties, context, state) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var contextId = text(context && (context.contextId || context.id)) || readCommerceContextIdProperty(source);
    if (!contextId) return source;
    var payloadState = state && typeof state === 'object' ? state : readDesignerStateFromProperties(source);
    var publicProperties = payloadState ? buildPublicProperties(payloadState) : {};
    Object.keys(publicProperties).forEach(function (key) {
      delete source[key];
    });
    EXTRA_PUBLIC_PROPERTY_KEYS.forEach(function (key) {
      delete source[key];
    });
    Object.keys(source).forEach(function (key) {
      if (shouldDeleteCommerceContextProperty(key)) delete source[key];
    });
    source._bg_context_id = contextId;
    delete source._bg_context_version;
    var contextVersion = readCommerceContextVersion(context);
    if (contextVersion) source._bg_context_version = contextVersion;
    source._bg_cart_transform_state_v1 = JSON.stringify(buildCartTransformState(payloadState || {}));
    if (payloadState && typeof payloadState === 'object') {
      source._bg_designer_state_v1 = JSON.stringify(payloadState);
    }
    var staffProperties = buildStaffOrderProperties(payloadState || {}, source, contextId);
    Object.keys(staffProperties).forEach(function (key) {
      var value = text(staffProperties[key]);
      if (!value) return;
      source[key] = value;
    });
    return source;
  }

  function signCartTransformProperties(properties, options) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var settings = options && typeof options === 'object' ? options : {};
    var expectedProjectReference = readSelfHostedProjectReference(source);
    var expectedProjectAccessRequired = Boolean(
      expectedProjectReference
      && !expectedProjectReference.conflicted
      && /^shp_[A-Za-z0-9_-]{8,128}$/.test(text(expectedProjectReference.projectId))
    );
    if (
      (expectedProjectReference && !expectedProjectAccessRequired)
      || (!expectedProjectAccessRequired && (
        text(source._bg_project_id_v1)
        || text(source._bg_project_access_sig_v1)
        || text(source._bg_project_access_attestation_v1)
      ))
    ) {
      return Promise.reject(new Error('Project-bound cart identity is inconsistent.'));
    }
    var state = parseJson(source._bg_cart_transform_state_v1, null);
    if (!state || typeof state !== 'object') {
      return Promise.reject(new Error('Cart pricing state is invalid.'));
    }
    var expectedContextId = readCommerceContextIdProperty(source);
    var expectedContextVersion = text(source._bg_context_version);
    if (!expectedContextId || !/^\d{13}$/.test(expectedContextVersion)) {
      return Promise.reject(new Error('Cart pricing context is incomplete.'));
    }
    var designerSessionToken = text(settings.sessionToken);
    if (!designerSessionToken && expectedProjectAccessRequired) {
      // The signing seal requires a session whose projectId claim matches the
      // line's project; the page session never carries one, so a project-bound
      // sign resolves the stored project-scoped session (guest claim proof
      // included) before falling back to the page token.
      var signingProjectSession = readStoredCommerceProjectSession(text(expectedProjectReference.projectId));
      if (signingProjectSession) designerSessionToken = text(signingProjectSession.sessionToken);
    }
    if (!designerSessionToken) designerSessionToken = getDesignerSessionTokenFromPage();
    var requestHeaders = {
      accept: 'application/json',
      'content-type': 'application/json',
      'x-qps-cart-token-hash': text(settings.cartTokenHash)
    };
    if (designerSessionToken) {
      requestHeaders['x-designer-session-token'] = designerSessionToken;
    }
    delete source._bg_pt_v4;
    delete source._bg_pt_v5;
    delete source._bg_project_id_v1;
    delete source._bg_project_access_sig_v1;
    delete source._bg_project_access_attestation_v1;
    return fetch(CART_TRANSFORM_SIGN_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders,
      body: JSON.stringify({
        state: state,
        contextId: expectedContextId,
        cartTokenHash: text(settings.cartTokenHash)
      })
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        if (
          !response.ok
          || !body
          || body.ok !== true
          || !body.signature
          || (!text(body.priceTokenV5) && !text(body.priceTokenV4))
          || (body.projectAccessRequired === true && (
            !text(body.projectAccessProjectId)
            || !/^[A-Za-z0-9_-]{43}$/.test(text(body.projectAccessSignature))
            || !text(body.projectAccessAttestation)
          ))
        ) {
          var signingError = new Error(text(body && body.error) || 'Cart pricing could not be verified.');
          signingError.status = Number(response.status || 0) || 0;
          signingError.payload = body;
          throw signingError;
        }
        var signedState = body.state && typeof body.state === 'object'
          ? body.state
          : parseJson(body.stateJson, null);
        if (!signedState || typeof signedState !== 'object' || Array.isArray(signedState)) {
          throw new Error('Cart pricing state could not be verified.');
        }
        var responseContextId = text(body.contextId);
        var responseContextVersion = text(body.contextVersion);
        var requiresBoundContextEcho = Boolean(text(body.priceTokenV5));
        if (
          (requiresBoundContextEcho && (
            responseContextId !== expectedContextId
            || responseContextVersion !== expectedContextVersion
          ))
          || (responseContextId && responseContextId !== expectedContextId)
          || (responseContextVersion && responseContextVersion !== expectedContextVersion)
        ) {
          throw new Error('Cart pricing context changed before it could be verified.');
        }
        var responseProjectId = text(body.projectAccessProjectId);
        var responseProjectAccessSignature = text(body.projectAccessSignature);
        var isBoundV5Response = Boolean(text(body.priceTokenV5));
        if (
          (isBoundV5Response && (body.projectAccessRequired === true) !== expectedProjectAccessRequired)
          || (!isBoundV5Response && body.projectAccessRequired === true)
        ) {
          throw new Error('Project-bound cart access mode changed before it could be verified.');
        }
        if (body.projectAccessRequired === true) {
          var responseAttestationParts = text(body.projectAccessAttestation).split('.');
          if (
            !expectedProjectReference
            || expectedProjectReference.conflicted
            || !/^shp_[A-Za-z0-9_-]{8,128}$/.test(responseProjectId)
            || responseProjectId !== text(expectedProjectReference.projectId)
            || responseAttestationParts.length !== 7
            || responseProjectAccessSignature !== text(responseAttestationParts[6])
          ) {
            throw new Error('Project-bound cart identity changed before it could be verified.');
          }
        } else if (responseProjectId || responseProjectAccessSignature || text(body.projectAccessAttestation)) {
          throw new Error('Cart pricing returned unexpected project access proof.');
        }
        source._bg_cart_transform_state_v1 = JSON.stringify(signedState);
        if (text(signedState.baseVariantId)) source._bg_base_variant_id = text(signedState.baseVariantId);
        if (text(signedState.finalSku)) source._bg_final_sku = text(signedState.finalSku);
        if (text(signedState.cartQuantityMode)) source._bg_cart_quantity_mode = text(signedState.cartQuantityMode);
        source._bg_cart_transform_sig_v1 = text(body.signature);
        if (text(body.projectAccessAttestation)) {
          source._bg_project_id_v1 = responseProjectId;
          source._bg_project_access_sig_v1 = responseProjectAccessSignature;
          source._bg_project_access_attestation_v1 = text(body.projectAccessAttestation);
        }
        if (text(body.priceTokenV5)) {
          source._bg_pt_v5 = text(body.priceTokenV5);
        } else if (text(body.priceTokenV4)) {
          source._bg_pt_v4 = text(body.priceTokenV4);
        }
        return source;
      });
    });
  }

  function buildCommerceContextCacheKey(contextId, cartTokenHash) {
    return text(contextId) + ':' + text(cartTokenHash);
  }

  // Write-through for every cached cartTokenHash variant of a context: a read
  // after a context write must never serve the pre-write context or a cached
  // miss, no matter which cartTokenHash the earlier read used.
  function storeCommerceContextInCache(contextId, context) {
    var lookup = text(contextId);
    if (!lookup) return;
    var fresh = Promise.resolve(context);
    Object.keys(commerceContextCache).forEach(function (cacheKey) {
      if (cacheKey.indexOf(lookup + ':') === 0) {
        commerceContextCache[cacheKey] = fresh;
      }
    });
    commerceContextCache[buildCommerceContextCacheKey(lookup, '')] = fresh;
  }

  function readCustomerReferenceCode() {
    try {
      var telemetry = window.BGDesignerTelemetry;
      if (!telemetry || typeof telemetry.getSessionId !== 'function') return '';
      var sessionId = text(telemetry.getSessionId()).replace(/[^A-Za-z0-9]/g, '');
      return sessionId.length >= 6 ? sessionId.slice(-6).toUpperCase() : '';
    } catch (_) {
      return '';
    }
  }

  // One plain message for every failed cart save or signing; `operation` is
  // 'update' for a cart line edit or quantity change, anything else is an add.
  function buildCartFailureMessage(operation) {
    var message = operation === 'update'
      ? 'We could not update this cart item. Please try again.'
      : 'We could not add this item to your cart. Please try again.';
    var referenceCode = readCustomerReferenceCode();
    return message + (referenceCode ? ' Your reference code is ' + referenceCode + '.' : '');
  }

  // The customer sees only the plain message and reference code; the technical
  // text rides serverError (120 characters) for telemetry, and the HTTP status
  // and signer payload stay on the error for callers.
  function toCustomerCartFailure(error, operation) {
    var source = error || {};
    var failure = new Error(buildCartFailureMessage(operation));
    failure.status = Number(source.status || 0) || 0;
    failure.referenceCode = readCustomerReferenceCode();
    failure.serverError = text(source.serverError || source.message).slice(0, 120);
    if (source.payload !== undefined) failure.payload = source.payload;
    return failure;
  }

  function persistCommerceContextPayload(payload, options) {
    if (!payload || typeof payload !== 'object') {
      return Promise.reject(new Error('Commerce context payload is required.'));
    }
    var headers = {
      accept: 'application/json',
      'content-type': 'application/json'
    };
    var sessionToken = text(options && options.sessionToken);
    if (sessionToken) {
      // Guest carts rotate their Shopify cart token on the first add, so a
      // later context write (quantity change, cart edit) can no longer match
      // the write-once cart binding. The project session lets the worker
      // defer that one guest shape to the API project-proof seal — the same
      // adjudication the sign lane already trusts. The token stays in the
      // header, never in the payload body.
      headers['x-designer-session-token'] = sessionToken;
    }
    return fetch(COMMERCE_CONTEXT_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        if (!response.ok || !body || body.ok !== true || !body.contextId) {
          var storageError = new Error('Commerce context storage failed.');
          storageError.status = Number(response.status || 0) || 0;
          storageError.serverError = text(body && body.error);
          throw storageError;
        }
        var context = body.context || { contextId: body.contextId };
        var topLevelContextId = text(body.contextId);
        var nestedContextId = text(context && (context.contextId || context.id));
        if (nestedContextId && nestedContextId !== topLevelContextId) {
          throw new Error('Commerce context storage returned inconsistent identity.');
        }
        storeCommerceContextInCache(body.contextId || context.contextId || context.id, context);
        return context;
      });
    }, function (networkError) {
      var failure = new Error(text(networkError && networkError.message) || 'Commerce context storage is unreachable.');
      failure.status = 0;
      throw failure;
    });
  }

  // ORDER-META-01: coarse browser + device classification for order
  // analytics. Values are advisory metadata only — never inputs to pricing,
  // signing, or context identity.
  function readClientUserAgentAnalytics() {
    try {
      var nav = typeof window !== 'undefined' && window.navigator ? window.navigator : null;
      var ua = text(nav && nav.userAgent);
      if (!ua) return { device: '', browser: '' };
      var device = 'desktop';
      if (
        /iPad/i.test(ua)
        || (/Android/i.test(ua) && !/Mobile/i.test(ua))
        || (/Macintosh/.test(ua) && nav && Number(nav.maxTouchPoints || 0) > 1)
      ) {
        device = 'tablet';
      } else if (/Mobi|iPhone|iPod|Android/i.test(ua)) {
        device = 'mobile';
      }
      var browser = 'other';
      var match = null;
      if ((match = ua.match(/Edg(?:e|A|iOS)?\/(\d+)/))) browser = 'edge ' + match[1];
      else if ((match = ua.match(/SamsungBrowser\/(\d+)/))) browser = 'samsung ' + match[1];
      else if ((match = ua.match(/OPR\/(\d+)/))) browser = 'opera ' + match[1];
      else if ((match = ua.match(/(?:CriOS|Chrome)\/(\d+)/))) browser = 'chrome ' + match[1];
      else if ((match = ua.match(/(?:FxiOS|Firefox)\/(\d+)/))) browser = 'firefox ' + match[1];
      else if (/Safari\//.test(ua) && (match = ua.match(/Version\/(\d+)/))) browser = 'safari ' + match[1];
      return { device: device, browser: browser };
    } catch (_) {
      return { device: '', browser: '' };
    }
  }

  // Stamped AFTER signing: the cart-transform signature binds its named
  // security fields, so these hidden analytics properties ride the order
  // line without touching the trusted-pricing corridor.
  function applyOrderAnalyticsProperties(properties) {
    var target = properties && typeof properties === 'object' ? properties : {};
    var analytics = readClientUserAgentAnalytics();
    if (analytics.device && !text(target._bg_ua_device)) target._bg_ua_device = analytics.device;
    if (analytics.browser && !text(target._bg_ua_browser)) target._bg_ua_browser = analytics.browser;
    return target;
  }

  function isNativeChannelOfferProperties(properties) {
    var state = readDesignerStateFromProperties(properties || {});
    var origin = normalizeChannelOfferOrigin(state && state.channelOffer);
    return !!(origin && origin.mode === 'native' && origin.productId === text(state.productId)
      && origin.variantId !== text(state.baseVariantId));
  }

  function isNativeChannelOfferLine(line) {
    return !!(line && typeof line.sku === 'string' && /^BGCO_[a-f0-9]{32}$/.test(line.sku));
  }

  function prepareCommerceContextProperties(properties, options) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var state = readDesignerStateFromProperties(source);
    var hasDesignerMarker = Boolean(text(source._bg_designer_version));
    if (!hasDesignerMarker && (!state || !text(state.runtimeVersion))) {
      return Promise.resolve(source);
    }
    var settings = options && typeof options === 'object' ? options : {};
    var isAdd = !text(settings.lineKey) && !text(source._bg_update_line_key);
    var failAsCustomerMessage = function (error) {
      throw toCustomerCartFailure(error, isAdd ? 'add' : 'update');
    };
    if (!state || !text(source._bg_designer_version || state.runtimeVersion)) {
      return Promise.reject(new Error('Designer cart state is invalid.')).catch(failAsCustomerMessage);
    }
    if (isAdd) {
      // An add is a new cart line; a prior prepare's form ID is bound to another cart read.
      source = Object.assign({}, source);
      ['_bg_context_id', '_Context ID', 'Context ID', 'QPS Context ID', '_bg_context_version'].forEach(function (key) {
        delete source[key];
      });
    }
    var payload = buildCommerceContextPayload(source, options);
    if (!payload) return Promise.reject(new Error('Commerce context payload is invalid.')).catch(failAsCustomerMessage);
    var projectReference = readSelfHostedProjectReference(source);
    var needsProjectSession = Boolean(
      !text(settings.sessionToken)
      && projectReference
      && !projectReference.conflicted
      && /^shp_[A-Za-z0-9_-]{8,128}$/.test(text(projectReference.projectId))
    );
    // Project-bound adds must sign with a project-scoped session or the
    // signing seal rejects the line; resolve it up front (stored proof, or a
    // fresh proof-headered mint when storage was clobbered) instead of
    // letting the sign lane fall back to the page token.
    var sessionResolution = needsProjectSession
      ? resolveCommerceProjectSession(source).catch(function () { return null; })
      : Promise.resolve(null);
    return sessionResolution.then(function (projectSession) {
      var signOptions = projectSession && text(projectSession.sessionToken)
        ? Object.assign({}, settings, { sessionToken: text(projectSession.sessionToken) })
        : options;
      return persistCommerceContextPayload(payload, {
        sessionToken: text(signOptions && signOptions.sessionToken)
      }).then(function (context) {
        var prepared = applyCommerceContextToProperties(source, context, state);
        if (isNativeChannelOfferProperties(prepared)) {
          ['_bg_cart_transform_state_v1', '_bg_cart_transform_sig_v1', '_bg_pt_v4', '_bg_pt_v5',
            '_bg_project_id_v1', '_bg_project_access_sig_v1', '_bg_project_access_attestation_v1'].forEach(function (key) { delete prepared[key]; });
          return prepared;
        }
        return signCartTransformProperties(prepared, signOptions);
      }).then(applyOrderAnalyticsProperties);
    }).catch(failAsCustomerMessage);
  }

  function isProjectBoundCommerceProperties(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var reference = readSelfHostedProjectReference(source);
    var projectId = text(reference && reference.projectId);
    var contextId = readCommerceContextIdProperty(source);
    var contextVersion = text(source._bg_context_version);
    return /^shp_[A-Za-z0-9_-]{8,128}$/.test(projectId)
      && /^ctx_[A-Za-z0-9_-]{8,96}$/.test(contextId)
      && /^\d{13}$/.test(contextVersion);
  }

  function readCommerceProjectStateCandidates(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var states = [
      parseJson(source._bg_designer_state_v1, null),
      parseJson(source._bg_cart_transform_state_v1, null)
    ];
    var candidates = states.filter(function (state) {
      return state && typeof state === 'object' && !Array.isArray(state);
    }).map(function (state) {
      var project = state.project && typeof state.project === 'object' ? state.project : {};
      // Resume-restored states can carry the self-hosted-<id> publicId
      // alias; commerce lanes require the canonical shp_ id.
      return {
        state: state,
        projectId: text(project.projectId).replace(/^self-hosted-(?=shp_)/, '')
      };
    });
    var directProjectId = text(source._bg_project_id_v1);
    if (directProjectId) {
      candidates.push({
        state: null,
        projectId: directProjectId,
        securityBinding: true
      });
    }
    return candidates;
  }

  function readSelfHostedProjectReference(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var candidates = readCommerceProjectStateCandidates(source);
    var selfHostedCandidates = candidates.filter(function (candidate) {
      return candidate.projectId.indexOf('shp_') === 0;
    });
    if (!selfHostedCandidates.length) return null;
    var uniqueProjectIds = [];
    candidates.forEach(function (candidate) {
      if (candidate.projectId && uniqueProjectIds.indexOf(candidate.projectId) === -1) {
        uniqueProjectIds.push(candidate.projectId);
      }
    });
    var conflicted = uniqueProjectIds.length > 1;
    var referencedProjectId = selfHostedCandidates[0].projectId;
    var matchingCandidates = selfHostedCandidates.filter(function (candidate) {
      return candidate.projectId === referencedProjectId;
    });
    var selected = matchingCandidates.filter(function (candidate) {
      return text(candidate.state && candidate.state.productId);
    })[0] || matchingCandidates[0];
    var state = selected && selected.state ? selected.state : {};
    return {
      projectId: conflicted ? '' : referencedProjectId,
      referencedProjectId: referencedProjectId,
      conflicted: conflicted,
      productId: text(state && state.productId),
      productHandle: text(state && (state.handle || state.sourceHandle)),
      contextId: readCommerceContextIdProperty(source),
      contextVersion: text(source._bg_context_version)
    };
  }

  function hasSelfHostedProjectReference(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    return Boolean(
      readSelfHostedProjectReference(source)
      || text(source._bg_project_access_sig_v1)
      || text(source._bg_project_access_attestation_v1)
    );
  }

  function requiresProjectAccessCheckoutRefresh(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var projectAccessAttestation = text(source._bg_project_access_attestation_v1);
    var projectAccessSignature = text(source._bg_project_access_sig_v1);
    return Boolean(projectAccessAttestation || projectAccessSignature)
      || (hasSelfHostedProjectReference(source) && Boolean(text(source._bg_pt_v5)));
  }

  function readStoredJsonObject(storage, key) {
    try {
      var parsed = parseJson(storage && storage.getItem(key), null);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  function readBootstrapProjectId(bootstrap) {
    var source = bootstrap && typeof bootstrap === 'object' ? bootstrap : {};
    var session = source.session && typeof source.session === 'object' ? source.session : {};
    var launchContext = source.launchContext && typeof source.launchContext === 'object' ? source.launchContext : {};
    return text(source.projectId || session.projectId || launchContext.projectId);
  }

  function readBootstrapProjectSession(bootstrap, projectId, sourceLabel) {
    var source = bootstrap && typeof bootstrap === 'object' ? bootstrap : {};
    var session = source.session && typeof source.session === 'object' ? source.session : {};
    var bootstrapProjectId = readBootstrapProjectId(source);
    var sessionToken = text(source.sessionToken || session.token);
    if (!sessionToken || bootstrapProjectId !== projectId) return null;
    return {
      projectId: projectId,
      sessionToken: sessionToken,
      source: text(sourceLabel) || 'stored-bootstrap'
    };
  }

  function readSessionTokenProjectClaim(token) {
    var parts = text(token).split('.');
    if (parts.length !== 3 || typeof window.atob !== 'function') {
      return { parsed: false, projectId: '' };
    }
    try {
      var normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      while (normalized.length % 4) normalized += '=';
      var payload = JSON.parse(window.atob(normalized));
      // Designer session tokens mint the payload as {version:'v1', claims:{...}},
      // so the projectId claim lives one level down; flat payloads are the
      // legacy shape.
      var claims = payload && payload.claims && typeof payload.claims === 'object' && !Array.isArray(payload.claims)
        ? payload.claims
        : payload;
      return { parsed: true, projectId: text(claims && claims.projectId) };
    } catch (_) {
      return { parsed: false, projectId: '' };
    }
  }

  function sessionCandidateCarriesProject(candidate, projectId) {
    if (!candidate) return false;
    // The cart-signing project-proof seal requires the presented session's
    // projectId claim to equal the line's project, so a token bound to a
    // different (or no) project can never seal; skip it so a later source —
    // the guest claim proof or a fresh project-scoped mint — serves instead.
    // Unparseable tokens pass through unchanged.
    var claim = readSessionTokenProjectClaim(candidate.sessionToken);
    if (!claim.parsed) return true;
    return claim.projectId === projectId;
  }

  function readStoredGuestClaimProofToken(projectId) {
    var sessionStorageRef = null;
    try { sessionStorageRef = window.sessionStorage; } catch (_) {}
    var guestProofs = readStoredJsonObject(sessionStorageRef, 'bg_designer_guest_claim_proofs_v1');
    // Proofs are keyed by the canonical id; launches may reference the
    // project through its self-hosted-<id> publicId alias.
    var canonicalProjectId = text(projectId).replace(/^self-hosted-/, '');
    var guestProof = (guestProofs && guestProofs[projectId] && typeof guestProofs[projectId] === 'object' && guestProofs[projectId])
      || (guestProofs && guestProofs[canonicalProjectId] && typeof guestProofs[canonicalProjectId] === 'object' && guestProofs[canonicalProjectId])
      || {};
    return text(guestProof.token);
  }

  // The strongest locally stored credential able to read this project's
  // record: the guest claim proof, else a project-scoped bootstrap session.
  // Empty when this browser session holds nothing for the project — callers
  // use that to skip protected reads entirely on cold loads.
  // Every locally stored credential that might read this project's record,
  // strongest first. Not all candidates are owner-scoped (a page prewarm
  // bootstrap can echo the projectId without read rights), so record reads
  // try them in order instead of trusting the first hit.
  function readStoredProjectReadCredentialCandidates(projectId) {
    var cleanProjectId = text(projectId);
    if (!cleanProjectId) return [];
    var candidates = [];
    var guestProof = readStoredGuestClaimProofToken(cleanProjectId);
    if (guestProof) candidates.push(guestProof);
    var storedSession = readStoredCommerceProjectSession(cleanProjectId);
    if (storedSession && text(storedSession.sessionToken)) candidates.push(text(storedSession.sessionToken));
    var editorCacheToken = readEditorBootstrapCacheSessionToken(cleanProjectId);
    if (editorCacheToken) candidates.push(editorCacheToken);
    return candidates.filter(function (value, index) {
      return candidates.indexOf(value) === index;
    });
  }

  function readStoredProjectReadCredential(projectId) {
    return text(readStoredProjectReadCredentialCandidates(projectId)[0]);
  }

  // The editor page caches its bootstrap (token included) in per-tab
  // sessionStorage; a same-tab navigation return can present that session to
  // read the project it just saved. Expired or foreign-project entries never
  // match, and cold loads have no entries at all.
  function readEditorBootstrapCacheSessionToken(projectId) {
    var sessionStorageRef = null;
    try { sessionStorageRef = window.sessionStorage; } catch (_) { return ''; }
    if (!sessionStorageRef) return '';
    try {
      for (var index = 0; index < sessionStorageRef.length; index += 1) {
        var key = sessionStorageRef.key(index) || '';
        if (key.indexOf('bg-designer-v2-bootstrap:') !== 0) continue;
        var parsed = null;
        try { parsed = JSON.parse(sessionStorageRef.getItem(key) || ''); } catch (_) { continue; }
        var bootstrap = parsed && parsed.bootstrap && typeof parsed.bootstrap === 'object' ? parsed.bootstrap : null;
        if (!bootstrap || text(bootstrap.projectId) !== projectId) continue;
        var tokenValue = text(bootstrap.sessionToken);
        if (!tokenValue) continue;
        var expiresAt = Date.parse(text(bootstrap.sessionExpiresAt) || '');
        if (Number.isFinite(expiresAt) && expiresAt <= Date.now()) continue;
        return tokenValue;
      }
    } catch (_) {}
    return '';
  }

  function readStoredCommerceProjectSession(projectId) {
    var cachedToken = text(commerceProjectSessionCache[projectId]);
    if (cachedToken) {
      var cached = { projectId: projectId, sessionToken: cachedToken, source: 'memory' };
      if (sessionCandidateCarriesProject(cached, projectId)) return cached;
    }
    var current = readBootstrapProjectSession(window.BG_DESIGNER_BOOTSTRAP, projectId, 'page-bootstrap');
    if (current && sessionCandidateCarriesProject(current, projectId)) return current;
    var sessionStorageRef = null;
    try { sessionStorageRef = window.sessionStorage; } catch (_) {}
    var storedBootstrap = readStoredJsonObject(sessionStorageRef, 'bg_designer_bootstrap_v1');
    var stored = readBootstrapProjectSession(storedBootstrap, projectId, 'stored-bootstrap');
    if (stored && sessionCandidateCarriesProject(stored, projectId)) return stored;
    var guestToken = readStoredGuestClaimProofToken(projectId);
    if (guestToken) {
      var guest = { projectId: projectId, sessionToken: guestToken, source: 'guest-claim-proof' };
      if (sessionCandidateCarriesProject(guest, projectId)) return guest;
    }
    return null;
  }

  function fetchFreshCommerceProjectSession(reference) {
    var projectId = text(reference && reference.projectId);
    if (!/^shp_[A-Za-z0-9_-]{8,128}$/.test(projectId)) {
      return Promise.reject(new Error('Project-bound cart access is incomplete.'));
    }
    var endpoint;
    try {
      endpoint = new URL(
        text(window.BG_DESIGNER_BOOTSTRAP_ENDPOINT) || COMMERCE_PROJECT_BOOTSTRAP_URL,
        window.location.origin
      );
      endpoint.searchParams.set('projectId', projectId);
      if (text(reference && reference.productId)) endpoint.searchParams.set('productId', text(reference.productId));
      if (text(reference && reference.productHandle)) endpoint.searchParams.set('productHandle', text(reference.productHandle));
      endpoint.searchParams.set('bgStorefrontRuntime', 'designer-storefront-v1');
    } catch (_) {
      return Promise.reject(new Error('Project-bound cart access is unavailable.'));
    }
    var freshHeaders = {
      accept: 'application/json',
      'cache-control': 'no-cache',
      pragma: 'no-cache'
    };
    var guestClaimToken = readStoredGuestClaimProofToken(projectId);
    if (guestClaimToken) {
      // Present the guest claim proof so the bootstrap lane can mint a
      // project-scoped guest session instead of denying the projectId.
      freshHeaders['x-designer-session-token'] = guestClaimToken;
    }
    return fetch(endpoint.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: freshHeaders
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        var bootstrap = body && body.bootstrap && typeof body.bootstrap === 'object'
          ? body.bootstrap
          : null;
        var resolved = readBootstrapProjectSession(bootstrap, projectId, 'bootstrap');
        if (!response.ok || !body || body.ok !== true || !resolved) {
          var error = new Error(text(body && body.error) || 'Project-bound cart access could not be refreshed.');
          error.status = Number(response.status || 0) || 0;
          throw error;
        }
        commerceProjectSessionCache[projectId] = resolved.sessionToken;
        return resolved;
      });
    });
  }

  function resolveCommerceProjectSession(properties, options) {
    var reference = readSelfHostedProjectReference(properties);
    if (!reference || reference.conflicted || !/^shp_[A-Za-z0-9_-]{8,128}$/.test(reference.projectId)) {
      return Promise.reject(new Error('Project-bound cart access is incomplete.'));
    }
    var forceFresh = Boolean(options && options.forceFresh);
    var stored = forceFresh ? null : readStoredCommerceProjectSession(reference.projectId);
    return stored ? Promise.resolve(stored) : fetchFreshCommerceProjectSession(reference);
  }

  function resignCommerceContextProperties(properties, options) {
    var source = properties && typeof properties === 'object'
      ? Object.assign({}, properties)
      : {};
    if (!isProjectBoundCommerceProperties(source)) {
      return Promise.reject(new Error('Project-bound cart context is incomplete.'));
    }
    return signCartTransformProperties(source, options).then(function (signed) {
      if (
        !signed
        || !text(signed._bg_pt_v5)
        || !text(signed._bg_project_id_v1)
        || !text(signed._bg_project_access_sig_v1)
        || !text(signed._bg_project_access_attestation_v1)
        || !isProjectBoundCommerceProperties(signed)
      ) {
        throw new Error('Project-bound cart access could not be refreshed.');
      }
      return signed;
    });
  }

  function prepareCommerceContextFormData(formData, options) {
    var properties = readFormDataProperties(formData);
    var originalKeys = Object.keys(properties);
    return prepareCommerceContextProperties(properties, options).then(function (nextProperties) {
      originalKeys.forEach(function (key) {
        deleteFormDataProperty(formData, key);
      });
      Object.keys(nextProperties).forEach(function (key) {
        var value = text(nextProperties[key]);
        if (!value) return;
        setFormDataProperty(formData, key, value);
      });
      return nextProperties;
    });
  }

  function readCommerceContextFullState(context) {
    var payload = context && typeof context === 'object' ? context : {};
    var properties = payload.properties && typeof payload.properties === 'object' ? payload.properties : {};
    var fullState = properties.fullState && typeof properties.fullState === 'object' ? properties.fullState : null;
    return fullState || null;
  }

  function fetchCommerceContext(contextId, options) {
    var lookup = text(contextId);
    if (!lookup) return Promise.resolve(null);
    var settings = options && typeof options === 'object' ? options : {};
    var cartTokenHash = text(settings.cartTokenHash);
    var cacheKey = buildCommerceContextCacheKey(lookup, cartTokenHash);
    if (commerceContextCache[cacheKey]) return commerceContextCache[cacheKey];
    var requestUrl = COMMERCE_CONTEXT_URL + '/' + encodeURIComponent(lookup);
    if (cartTokenHash) requestUrl += '?cartTokenHash=' + encodeURIComponent(cartTokenHash);
    commerceContextCache[cacheKey] = fetch(requestUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        accept: 'application/json',
        'x-qps-cart-token-hash': cartTokenHash
      }
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        if (!response.ok || !body || body.ok !== true || !body.context) return null;
        return body.context;
      });
    }).catch(function () {
      return null;
    });
    return commerceContextCache[cacheKey];
  }

  function buildCartTransformMapEntry(state) {
    if (normalizeChannelOfferOrigin(state && state.channelOffer)?.mode === 'native') return null;
    var compactState = buildCartTransformState(state);
    if (!text(compactState.baseVariantId) || !text(compactState.finalSku)) {
      return null;
    }
    return compactState;
  }

  function collectCartTransformMapEntries(cart, options) {
    var settings = options && typeof options === 'object' ? options : {};
    var mode = text(settings.mode) || 'sync';
    var targetLineKey = text(settings.lineKey);
    var pendingState = settings.state && typeof settings.state === 'object' ? settings.state : null;
    var pendingEntry = pendingState ? buildCartTransformMapEntry(pendingState) : null;
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var entries = [];
    var replaced = false;

    if (mode === 'add' && pendingEntry) {
      entries.push(pendingEntry);
    }

    items.forEach(function (item) {
      if (isNativeChannelOfferLine(item)) return;
      var itemKey = text(item && item.key);
      if (targetLineKey && itemKey === targetLineKey) {
        if (mode === 'remove') {
          replaced = true;
          return;
        }
        if (pendingEntry) {
          entries.push(pendingEntry);
          replaced = true;
          return;
        }
      }
      var itemState = readDesignerStateFromProperties(item && item.properties);
      var itemEntry = itemState ? buildCartTransformMapEntry(itemState) : null;
      if (itemEntry) {
        entries.push(itemEntry);
      }
    });

    if (mode !== 'add' && pendingEntry && !replaced) {
      entries.push(pendingEntry);
    }

    return entries;
  }

  function buildCartTransformStateMapPayload(cart, options) {
    return {
      version: 'designer-storefront-cart-transform-map-v1',
      updatedAt: new Date().toISOString(),
      lines: collectCartTransformMapEntries(cart, options)
    };
  }

  function updateCartAttributes(attributes) {
    return fetch(getRootUrl() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes && typeof attributes === 'object' ? attributes : {}
      })
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (payload) {
        if (!response.ok || !payload) {
          throw new Error('Unable to update cart attributes.');
        }
        CART_STATE_PROMISE = null;
        return payload;
      });
    });
  }

  function hasCartTransformStateMapAttributes(cart) {
    var attributes = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
    return !!(text(attributes[CART_TRANSFORM_STATE_MAP_KEY]) || text(attributes[LEGACY_CART_TRANSFORM_STATE_MAP_KEY]));
  }

  function clearCartTransformStateMapAttributes() {
    return fetchCartState().then(function (cart) {
      var nextAttributes = Object.assign({}, cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {});
      var hadCurrent = text(nextAttributes[CART_TRANSFORM_STATE_MAP_KEY]);
      var hadLegacy = text(nextAttributes[LEGACY_CART_TRANSFORM_STATE_MAP_KEY]);
      if (!hadCurrent && !hadLegacy) return cart;
      nextAttributes[CART_TRANSFORM_STATE_MAP_KEY] = '';
      nextAttributes[LEGACY_CART_TRANSFORM_STATE_MAP_KEY] = '';
      return updateCartAttributes(nextAttributes);
    });
  }

  function syncCartTransformStateMap(options) {
    void options;
    // The live cart transform now reads each line's compact state directly.
    // Keeping a cart-level map creates stale cross-line metadata after removals
    // and can conflict with other active checkout/cart rules.
    return clearCartTransformStateMapAttributes();
  }

  function syncCartTransformStateMapForProperties(properties, options) {
    void properties;
    void options;
    return clearCartTransformStateMapAttributes();
  }

  function syncCartTransformStateMapForRemoval(lineKey) {
    void lineKey;
    return clearCartTransformStateMapAttributes();
  }

  function fetchCartState(options) {
    var settings = options && typeof options === 'object' ? options : {};
    var forceFresh = settings.forceFresh === true || settings.noCache === true;
    if (!forceFresh && CART_STATE_PROMISE) return CART_STATE_PROMISE;
    var cartUrl = getRootUrl() + 'cart.js';
    if (forceFresh) {
      try {
        var freshUrl = new URL(cartUrl, window.location.origin);
        freshUrl.searchParams.set('_bg_cart_fresh', String(Date.now()));
        cartUrl = freshUrl.toString();
      } catch (_) {
        cartUrl += (cartUrl.indexOf('?') === -1 ? '?' : '&') + '_bg_cart_fresh=' + encodeURIComponent(String(Date.now()));
      }
    }
    var promise = fetch(cartUrl, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        accept: 'application/json',
        'cache-control': 'no-cache',
        pragma: 'no-cache'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load the current cart.');
      return response.json();
    }).then(function (payload) {
      if (!forceFresh) CART_STATE_PROMISE = null;
      return payload;
    }, function (error) {
      if (!forceFresh) CART_STATE_PROMISE = null;
      throw error;
    });
    if (!forceFresh) CART_STATE_PROMISE = promise;
    return promise;
  }

  // A guest session has no durable cart until Shopify sets the `cart` cookie,
  // and every cookieless /cart.js read mints a DIFFERENT transient token, so a
  // commerce context created from one read can never match the hash a later
  // prepare presents and the add fails closed before /cart/add ever runs (the
  // pre-first-add flavor of guest cart-token rotation; the post-add flavor is
  // the project-proof seal deferral). One empty /cart/update.js materializes
  // the cart and pins its token, so every hash bound into a commerce context
  // survives the whole prepare -> sign -> add corridor.
  function hasDurableCartCookie() {
    try {
      var jar = String((window.document && window.document.cookie) || '');
      var parts = jar.split(';');
      for (var index = 0; index < parts.length; index += 1) {
        var separator = parts[index].indexOf('=');
        if (
          separator > 0
          && parts[index].slice(0, separator).trim() === 'cart'
          && parts[index].slice(separator + 1).trim()
        ) return true;
      }
    } catch (_) {
      // Cookie access can throw in sandboxed frames; the materializing lane
      // below is safe to repeat, so fail toward it.
    }
    return false;
  }

  function resolveDurableCartTokenHash() {
    var materialized = hasDurableCartCookie()
      ? Promise.resolve(null)
      : fetch(getRootUrl() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json'
        },
        body: JSON.stringify({ updates: {} })
      }).catch(function () {
        // Materialization is best-effort: fall back to the previous
        // fresh-read behavior instead of blocking the add outright.
        return null;
      });
    return materialized.then(function () {
      return fetchCartState({ forceFresh: true });
    }).then(function (cart) {
      return hashCartToken(cart && cart.token);
    });
  }

  function findLineByKey(cart, lineKey) {
    var cleanKey = text(lineKey);
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var index = 0; index < items.length; index += 1) {
      if (text(items[index] && items[index].key) === cleanKey) return items[index];
    }
    return null;
  }

  // The one fingerprint of a cart line (#461 artwork flow): key, variant,
  // quantity and properties exactly as the cart returns them.
  function cartLineFingerprint(line) {
    if (!line) return '';
    return JSON.stringify([text(line.key), text(line.variant_id || line.id), Number(line.quantity), line.properties || {}]);
  }
  async function readCartLineFingerprint(lineKey) {
    var cart = await fetchCartState({ forceFresh: true });
    return cartLineFingerprint(findLineByKey(cart, lineKey));
  }
  // SALE-DISPLAY-PER-UNIT-ROUNDING fix round 1 (Astra 1, review of #690): the ONE
  // rule for the Shopify quantity an update of a designer cart line submits. A
  // channel package (the edited state names a channel offer, or the line is a
  // native offer variant) keeps the sets the line holds; every other line, and
  // a new add (no line), is submitted at 1. The product page's line totals read
  // the same rule (runtime getRetainedSetCount).
  function resolveDesignerLineSubmitQuantity(state, originalLine) {
    var channel = normalizeChannelOfferOrigin(state && state.channelOffer);
    return channel || isNativeChannelOfferLine(originalLine)
      ? Math.max(1, Number(originalLine && originalLine.quantity) || 1)
      : 1;
  }
  var CART_LINE_CHANGED_ELSEWHERE = 'This cart item changed in another tab. Review your cart and try again.';
  var RELOAD_TO_UPDATE = 'Please reload the page and try again.';
  async function updateDesignerCartLine(lineKey, variantId, properties, options) {
    var cart = await fetchCartState({ forceFresh: true });
    var original = findLineByKey(cart, lineKey);
    var targetId = text(variantId);
    if (!/^\d+$/.test(targetId) || !original) throw new Error('This cart item changed. Reopen it from your cart.');
    // Another tab may have changed the line since the caller read it: compare
    // this fresh read with the caller's fingerprint before any write.
    var expected = options && options.expectedFingerprint;
    if (expected && cartLineFingerprint(original) !== expected) throw new Error(CART_LINE_CHANGED_ELSEWHERE);
    // The caller decides last (ARTWORK-FLOW-3), once, immediately before the
    // actual mutation (the /cart/change POST or the replacement add), after
    // every awaited preparation including the attribute cleanup: anything but an
    // explicit ok (or a throw) writes nothing.
    var beforeWrite = options && typeof options.beforeMutation === 'function' ? function () {
      var allowed = options.beforeMutation();
      if (!(allowed === true || (allowed && typeof allowed === 'object' && allowed.ok === true))) {
        throw new Error(String((allowed && allowed.message) || 'This cart item was not updated.'));
      }
      return true;
    } : null;
    var state = readDesignerStateFromProperties(properties || {});
    var channel = normalizeChannelOfferOrigin(state && state.channelOffer);
    var quantity = resolveDesignerLineSubmitQuantity(state, original);
    if (text(original.variant_id || original.id) === targetId) return changeCartLine(lineKey, quantity, properties, beforeWrite);
    // Only channel edits replace merchandise. A normal calculator edit must
    // not silently move an unrelated cart line to another product/variant.
    if (!channel || text(original.product_id) !== text(state.productId)) throw new Error('This cart item does not match the selected offer.');
    var replacementProperties = Object.assign({}, properties, { _bg_replacement_for: text(lineKey) });
    var replacement = (cart.items || []).find(function (line) {
      return text(line.variant_id || line.id) === targetId && text((line.properties || {})._bg_replacement_for) === text(lineKey);
    });
    if (replacement) {
      if (readCommerceContextIdProperty(replacement.properties) !== readCommerceContextIdProperty(properties)) {
        throw new Error('A previous update needs review. Open your cart before trying again.');
      }
      await changeCartLine(replacement.key, quantity, replacementProperties, beforeWrite);
    } else {
      // An older add-once owner kept on this tab cannot ask at send time, and an
      // earlier ask is not enough: a guarded replacement is refused (nothing is
      // sent through it; its journals and in-flight work stay as they are).
      if (beforeWrite && !window.BGCartAddOnce.acceptsSendGuard) throw new Error(RELOAD_TO_UPDATE);
      var outcome = await window.BGCartAddOnce.runAdd({ config: { method: 'POST', credentials: 'same-origin',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: targetId, quantity: quantity, properties: replacementProperties }] }) },
        sendGuard: beforeWrite ? function () {
          try { return beforeWrite() ? { ok: true } : { ok: false }; } catch (error) { return { ok: false, reason: 'before-mutation', message: error && error.message }; }
        } : null,
        // A guarded replacement goes only into the existing cart: if the cart
        // cookie is gone, the owner refuses before creating a cart (RCARTADD10).
        existingCartOnly: !!beforeWrite });
      if (outcome.state === 'rejected' && (outcome.blockedBy === 'guard' || outcome.blockedBy === 'no-cart')) throw new Error(outcome.message);
      if (outcome.state !== 'handoff') throw new Error('We could not add the updated package. Your original item is still in your cart.');
    }
    CART_STATE_PROMISE = null;
    var verifiedCart = await fetchCartState({ forceFresh: true });
    var currentOriginal = findLineByKey(verifiedCart, lineKey);
    if (!currentOriginal || Number(currentOriginal.quantity) !== Number(original.quantity)
      || text(currentOriginal.variant_id || currentOriginal.id) !== text(original.variant_id || original.id)) {
      throw new Error('The original item changed during this update. Open your cart to review both items.');
    }
    var verified = (verifiedCart.items || []).filter(function (line) {
      return text(line.variant_id || line.id) === targetId && text((line.properties || {})._bg_replacement_for) === text(lineKey)
        && readCommerceContextIdProperty(line.properties) === readCommerceContextIdProperty(properties)
        && Number(line.quantity) === quantity;
    });
    if (verified.length !== 1) throw new Error('Your cart update needs review. Open your cart to check the items.');
    try {
      var updated = await changeCartLine(lineKey, 0, {});
      if (findLineByKey(updated, lineKey)) throw new Error('Original item remains');
      if (outcome && !await window.BGCartAddOnce.verifyReplacementRemoval(outcome.opId, text(lineKey))) throw new Error('Original item removal needs review');
      return updated;
    } catch (_) {
      // Never delete a potentially merged or already-used replacement as a
      // compensating action. A retry recognizes our exact replacement marker.
      throw new Error('The updated package was added, but the original could not be removed. Open your cart to review both items.');
    }
  }

  // beforeWrite (optional, internal): asked right before the POST with no await
  // between; a throw posts nothing. With it, the preparation only reads, and the
  // cart-transform map cleanup is written only after the line write succeeded.
  function changeCartLine(lineKey, quantity, properties, beforeWrite) {
    var request = function () {
      if (typeof beforeWrite === 'function') beforeWrite();
      return fetch(getRootUrl() + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json'
        },
        body: JSON.stringify({
          id: text(lineKey),
          quantity: Math.max(0, numberValue(quantity, 1) || 0),
          properties: properties && typeof properties === 'object' ? properties : {}
        })
      }).then(function (response) {
        return response.json().catch(function () { return null; }).then(function (payload) {
          if (!response.ok || !payload) {
            throw new Error('Unable to update the cart line.');
          }
          CART_STATE_PROMISE = null;
          return payload;
        });
      });
    };
    var state = readDesignerStateFromProperties(properties);
    if (typeof beforeWrite === 'function') {
      if (!state) return Promise.resolve().then(request);
      return fetchCartState().then(hasCartTransformStateMapAttributes, function () { return true; }).then(function (cleanup) {
        return request().then(function (payload) {
          if (!cleanup) return payload;
          return clearCartTransformStateMapAttributes().catch(function () { return null; }).then(function () { return payload; });
        });
      });
    }
    if (!state) return request();
    return syncCartTransformStateMap({
      mode: Math.max(0, numberValue(quantity, 1) || 0) === 0 ? 'remove' : 'update',
      lineKey: lineKey,
      state: state
    }).catch(function () {
      return null;
    }).then(request);
  }

  function fetchProjectRecord(config, projectId) {
    var cleanProjectId = text(projectId);
    if (!cleanProjectId) return Promise.resolve(null);
    // A guest-owned project is readable only with an owner-scoped session
    // proof. Some stored candidates (page prewarm bootstraps) echo the
    // projectId without read rights, so try each stored credential in order
    // and keep the first record that resolves.
    var credentials = readStoredProjectReadCredentialCandidates(cleanProjectId);
    if (!credentials.length) credentials = [''];
    var requestRecord = function (credentialIndex) {
      var recordHeaders = { accept: 'application/json' };
      if (credentials[credentialIndex]) recordHeaders['x-designer-session-token'] = credentials[credentialIndex];
      return fetch(getProjectsUrl(config) + '/' + encodeURIComponent(cleanProjectId), {
        credentials: 'same-origin',
        headers: recordHeaders
      }).then(function (response) {
        if (!response.ok) return null;
        return response.json().catch(function () { return null; });
      }).then(function (payload) {
        var project = payload && payload.project && typeof payload.project === 'object' ? payload.project : null;
        if (project) return project;
        var nextIndex = credentialIndex + 1;
        return nextIndex < credentials.length ? requestRecord(nextIndex) : null;
      });
    };
    return requestRecord(0).catch(function () {
      return null;
    });
  }

  function fetchProjectCompletionEligibility(config, payload, options) {
    var requestPayload = payload && typeof payload === 'object' ? deepClone(payload, {}) : {};
    var sessionToken = text(options && options.sessionToken) || getDesignerSessionTokenFromPage();
    var headers = {
      accept: 'application/json',
      'content-type': 'application/json'
    };
    if (sessionToken) {
      headers['x-designer-session-token'] = sessionToken;
    }
    return fetch(getDesignerProxyRoot(config) + '/projects/completion-eligibility', {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify(requestPayload)
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (body) {
        if (!response.ok || !body || body.ok !== true || !body.completionEligibility || typeof body.completionEligibility !== 'object') {
          var error = new Error(text(body && body.error) || 'Unable to verify print readiness.');
          error.status = Number(response.status || 0) || 0;
          error.payload = body;
          throw error;
        }
        return body.completionEligibility;
      });
    });
  }

  // EDITOR-LANES-EMPTY-SAVE-01: the purchase gate needs the truth about
  // artwork, and that truth is the saved document, never the project id. A
  // board background fill lives on the board (not in objects) and does not
  // count; hidden objects and reference-only objects are not printed and do
  // not count either, and neither does an UNFILLED image slot (a shape/path
  // placeholder carrying metadata.imageSlot: editor-only presentation that the
  // render service prints as nothing; a FILLED slot is an image object and
  // counts). Same eligibility as the render service's getRenderableBoardObjects.
  // Returns true / false from a document with boards, and null when the record
  // carries no document (unknown, never "empty").
  function isEmptyImageSlotObject(object) {
    var metadata = object && object.metadata && typeof object.metadata === 'object' ? object.metadata : {};
    var slot = metadata.imageSlot && typeof metadata.imageSlot === 'object' ? metadata.imageSlot : null;
    if (!slot || slot.enabled !== true) return false;
    return text(object.type).toLowerCase() !== 'image';
  }

  function isPrintableArtworkObject(object) {
    if (!object || typeof object !== 'object') return false;
    if (object.visible === false || object.isReference === true) return false;
    return !isEmptyImageSlotObject(object);
  }

  function readProjectArtworkPresence(project) {
    var documentValue = project && project.document && typeof project.document === 'object' ? project.document : null;
    var boards = documentValue && Array.isArray(documentValue.boards) ? documentValue.boards : null;
    if (!boards) return null;
    return boards.some(function (board) {
      var objects = board && Array.isArray(board.objects) ? board.objects : [];
      return objects.some(isPrintableArtworkObject);
    });
  }

  function fetchProjectPreview(config, projectId) {
    return fetchProjectRecord(config, projectId).then(function (project) {
      if (!project) return null;
      var previews = collectProjectPreviewUrls(project);
      return {
        projectId: text(project.id || project.projectId || projectId),
        hasArtwork: readProjectArtworkPresence(project),
        designId: text(project.designId),
        designNumber: text(project.designNumber),
        title: text(project.title || project.name || project.designTitle || (project.document && project.document.title)),
        updatedAt: text(project.updatedAt || project.lastEditedAt || project.modifiedAt),
        documentOrientation: readProjectDocumentOrientation(project),
        revision: Number(project.revision) || 0,
        boardPreviews: collectProjectBoardPreviews(project),
        previewUrl: text(previews[0]),
        previews: previews,
        // 3D preview Slice 7: server-computed product-mockup poster. Present
        // ONLY while the api judges it current for this design; absent means
        // the consumer keeps the ordinary 2D preview. Signed URLs expire, so
        // callers must never persist this field.
        mockupPoster: readProjectMockupPoster(project),
        numPages: Number(numberValue(project.numPages || project.pages || project.pageCount || project.pageLength, 0) || 0)
      };
    });
  }

  function readProjectDocumentOrientation(project) {
    var boards = project && project.document && project.document.boards;
    var board = Array.isArray(boards) ? boards[0] : null;
    var width = Number(board && board.width);
    var height = Number(board && board.height);
    if (!Number.isFinite(width) || width <= 0 || !Number.isFinite(height) || height <= 0) return '';
    if (Math.abs(width - height) < 0.0001) return 'square';
    return width > height ? 'landscape' : 'portrait';
  }

  function readProjectMockupPoster(project) {
    var poster = project && project.mockupPoster && typeof project.mockupPoster === 'object' ? project.mockupPoster : null;
    var url = text(poster && poster.url);
    if (!url) return null;
    return {
      url: url,
      width: Number(numberValue(poster.width, 0) || 0),
      height: Number(numberValue(poster.height, 0) || 0),
      fingerprint: text(poster.fingerprint)
    };
  }

  function ensurePreviewLightbox() {
    var existing = document.getElementById(LIGHTBOX_ID);
    if (existing) return existing;

    var lightbox = document.createElement('div');
    lightbox.id = LIGHTBOX_ID;
    lightbox.className = 'bg-designer-preview-lightbox';
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = '' +
      '<div class="bg-designer-preview-lightbox__panel" role="dialog" aria-modal="true" aria-label="Design preview">' +
        '<button type="button" class="bg-designer-preview-lightbox__dismiss" data-bg-designer-preview-dismiss aria-label="Close preview">Close</button>' +
        '<div class="bg-designer-preview-lightbox__frame">' +
          '<img class="bg-designer-preview-lightbox__image" data-bg-designer-preview-image alt="">' +
        '</div>' +
      '</div>';
    document.body.appendChild(lightbox);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) {
        closePreviewLightbox();
      }
    });
    var dismiss = lightbox.querySelector('[data-bg-designer-preview-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', closePreviewLightbox);
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closePreviewLightbox();
      }
    });
    return lightbox;
  }

  function openPreviewLightbox(previewUrl, title) {
    var cleanUrl = text(previewUrl);
    if (!cleanUrl) return false;
    var lightbox = ensurePreviewLightbox();
    var image = lightbox.querySelector('[data-bg-designer-preview-image]');
    if (!image) return false;
    image.src = cleanUrl;
    image.alt = text(title) ? ('Preview image for ' + title) : 'Preview image';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bg-designer-preview-lightbox--open');
    return true;
  }

  function closePreviewLightbox() {
    var lightbox = document.getElementById(LIGHTBOX_ID);
    if (!lightbox) return false;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    var image = lightbox.querySelector('[data-bg-designer-preview-image]');
    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }
    document.body.classList.remove('bg-designer-preview-lightbox--open');
    return true;
  }

  function isAllowedOrigin(origin) {
    try {
      if (window.BGDesignerIsAllowedOrigin && typeof window.BGDesignerIsAllowedOrigin === 'function') {
        return window.BGDesignerIsAllowedOrigin(origin);
      }
    } catch (_) {}
    return text(origin) === window.location.origin;
  }

  // Phone-class devices must open the editor as a FULL-PAGE navigation, not
  // the overlay iframe: inside an iframe the editor cannot see the on-screen
  // keyboard — the viewport meta (interactive-widget/viewport-fit), the
  // visualViewport keyboard shrink, and safe-area env() all belong to the TOP
  // document, and iOS pans the top page on input focus where the embedded
  // shell cannot counter it — so the mobile keyboard/format-bar behavior is
  // only correct top-level. Same standards signals as the editor's own
  // mobile-shell gate (touch + coarse pointer + not hybrid + width <= 860).
  function isTouchEditingShellViewport() {
    try {
      if (!window.matchMedia) return false;
      var hasCoarsePointer = window.matchMedia('(any-pointer: coarse)').matches;
      var hasFinePointer = window.matchMedia('(any-pointer: fine)').matches;
      var hasTouch = Number(window.navigator && window.navigator.maxTouchPoints || 0) > 0 || hasCoarsePointer;
      var isHybridDevice = hasCoarsePointer && hasFinePointer;
      var width = window.innerWidth || (document.documentElement && document.documentElement.clientWidth) || 0;
      return hasTouch && hasCoarsePointer && !isHybridDevice && width > 0 && width <= 860;
    } catch (_) {
      return false;
    }
  }

  function createEditorShell(options) {
    var settings = options && typeof options === 'object' ? options : {};
    var config = settings.config || {};
    var overlayId = text(settings.overlayId) || ('bg-designer-editor-shell-' + buildStableCacheKey(JSON.stringify({
      handle: config.handle,
      source: settings.source
    })));
    var activeContext = null;
    var activeLaunchUrl = '';
    var shellDocumentWarmUrl = '';
    var shellDocumentWarmPromise = null;
    var shellDocumentWarmResolver = null;
    var shellDocumentWarmTimer = 0;
    var loadingRevealWatchdogTimer = 0;

    function ensureOverlay() {
      var existing = document.getElementById(overlayId);
      if (existing) return existing;

      var overlay = document.createElement('div');
      overlay.id = overlayId;
      overlay.className = 'bg-designer-editor-shell';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = '' +
        '<div class="bg-designer-editor-shell__backdrop" data-bg-designer-shell-close></div>' +
        '<div class="bg-designer-editor-shell__panel" role="dialog" aria-modal="true" aria-label="Designer">' +
          '<div class="bg-designer-editor-shell__loading" data-bg-designer-shell-loading>' +
            '<div class="bg-designer-editor-shell__loading-card">' +
              '<div class="bg-designer-editor-shell__spinner" aria-hidden="true"></div>' +
              '<p class="bg-designer-editor-shell__loading-copy">' + escapeHtml(text(settings.loadingCopy) || 'Loading designer…') + '</p>' +
            '</div>' +
          '</div>' +
          '<iframe class="bg-designer-editor-shell__frame" data-bg-designer-shell-frame title="Designer" loading="eager" allow="clipboard-read; clipboard-write"></iframe>' +
        '</div>';
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (event) {
        if (event.target && event.target.getAttribute('data-bg-designer-shell-close') !== null) {
          close();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
          close();
        }
      });
      return overlay;
    }

    function postCachedPayloadToFrame(payload) {
      var frame = getFrame();
      var cleanPayload = payload && typeof payload === 'object' ? payload : null;
      if (!frame || !frame.contentWindow || !cleanPayload || !cleanPayload.bootstrap) return false;
      try {
        frame.contentWindow.postMessage({
          type: 'storefront:swap-context',
          payload: cleanPayload
        }, '*');
        frame.dataset.bgContextPushed = '1';
        return true;
      } catch (_) {
        return false;
      }
    }

    function getFrame() {
      var overlay = ensureOverlay();
      return overlay.querySelector('[data-bg-designer-shell-frame]');
    }

    function setLoadingVisible(visible) {
      var overlay = ensureOverlay();
      var loading = overlay.querySelector('[data-bg-designer-shell-loading]');
      if (!loading) return;
      if (loadingRevealWatchdogTimer) {
        window.clearTimeout(loadingRevealWatchdogTimer);
        loadingRevealWatchdogTimer = 0;
      }
      if (visible) {
        // Force-reveal if no identity-matching ready message ever arrives:
        // the opaque scrim must never strand the customer.
        loadingRevealWatchdogTimer = window.setTimeout(function () {
          loadingRevealWatchdogTimer = 0;
          setLoadingVisible(false);
        }, EDITOR_SHELL_LOADING_WATCHDOG_MS);
      }
      loading.hidden = !visible;
      overlay.classList.toggle('is-loading', !!visible);
    }

    function resolveShellDocumentWarm(value) {
      if (shellDocumentWarmTimer) {
        window.clearTimeout(shellDocumentWarmTimer);
        shellDocumentWarmTimer = 0;
      }
      if (typeof shellDocumentWarmResolver === 'function') {
        shellDocumentWarmResolver(Boolean(value));
      }
      shellDocumentWarmResolver = null;
      shellDocumentWarmPromise = null;
    }

    function prewarmDocument(context) {
      // Phones navigate top-level (see open) — never boot a hidden iframe
      // editor they will not use.
      if (isTouchEditingShellViewport()) return Promise.resolve(false);
      var overlay = ensureOverlay();
      var frame = getFrame();
      // BD-B20: the owner passes the page's current launch context so the
      // warmed editor boots with a selection the server accepts, built the
      // same way open() builds a launch URL (a matching launch reuses it).
      var warmUrl = buildEditorUrl(config, context && typeof context === 'object'
        ? Object.assign({}, context, { source: text(settings.source) || 'product' })
        : {
          source: text(settings.source) || 'product',
          productHandle: config && config.handle,
          productId: config && config.productId,
          runtimeVersion: config && config.runtimeVersion
        });
      if (!frame || !warmUrl) return Promise.resolve(false);
      // Never clobber a real launch. This idle warm force-closes the overlay
      // and re-points the iframe at its warm URL; when a
      // customer clicked a launch control inside the post-boot idle window
      // (0.9-2.2s), that overwrote the in-flight launch navigation and
      // minted a bindingless session (the fast-click launch race). Once the
      // overlay is open, a launch promise is in flight, or open() has
      // recorded a launch URL, the warm stands down for this page view.
      if (
        overlay.classList.contains('is-open')
        || SHELL_PROMISES[overlayId]
        || text(activeLaunchUrl)
      ) {
        return Promise.resolve(false);
      }
      if (
        frame.contentWindow
        && frame.dataset.bgShellReady === '1'
        && text(frame.dataset.bgFrameUrl) === warmUrl
      ) {
        shellDocumentWarmUrl = warmUrl;
        return Promise.resolve(true);
      }
      if (shellDocumentWarmPromise && shellDocumentWarmUrl === warmUrl) {
        return shellDocumentWarmPromise;
      }
      shellDocumentWarmUrl = warmUrl;
      frame.dataset.bgFrameUrl = warmUrl;
      frame.dataset.bgBootstrapCacheKey = getBootstrapCacheKeyForLaunchUrl(config, warmUrl);
      // A launch with this exact context reuses the ready warmed frame at
      // once; the editor does not re-announce ready for the same payload.
      frame.dataset.bgContextIdentity = context && typeof context === 'object'
        ? buildEditorLaunchIdentity(config, context, warmUrl)
        : '';
      frame.dataset.bgContextPushed = '';
      frame.dataset.bgShellReady = '';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open');
      document.body.classList.remove('bg-designer-editor-shell--open');
      setLoadingVisible(false);
      shellDocumentWarmPromise = new Promise(function (resolve) {
        shellDocumentWarmResolver = resolve;
        shellDocumentWarmTimer = window.setTimeout(function () {
          // A warm that never became ready (rate limit, server or network
          // error) must not hold a matching launch behind the scrim: drop its
          // labels and document so the launch loads the editor fresh.
          if (frame.dataset.bgShellReady !== '1' && !text(activeLaunchUrl)) {
            frame.dataset.bgContextIdentity = '';
            frame.dataset.bgFrameUrl = '';
            frame.removeAttribute('src');
          }
          resolveShellDocumentWarm(false);
        }, 12000);
      });
      if (text(frame.getAttribute('src')) !== warmUrl) {
        frame.src = warmUrl;
      } else if (frame.contentWindow) {
        window.setTimeout(function () {
          if (frame.dataset.bgShellReady === '1') {
            resolveShellDocumentWarm(true);
          }
        }, 0);
      }
      return shellDocumentWarmPromise;
    }

    function refreshBootstrap(detail) {
      if (!activeLaunchUrl) return Promise.resolve(false);
      var frame = getFrame();
      var currentCacheKey = text(frame && frame.dataset.bgBootstrapCacheKey);
      var nextLaunchUrl = buildUpdatedLaunchUrl(config, activeLaunchUrl, detail);
      var nextCacheKey = getBootstrapCacheKeyForLaunchUrl(config, nextLaunchUrl);
      if (currentCacheKey) deleteCachedBootstrap(currentCacheKey);
      if (nextCacheKey && nextCacheKey !== currentCacheKey) deleteCachedBootstrap(nextCacheKey);
      activeLaunchUrl = nextLaunchUrl || activeLaunchUrl;
      if (frame) {
        if (nextCacheKey) {
          frame.dataset.bgBootstrapCacheKey = nextCacheKey;
        } else {
          delete frame.dataset.bgBootstrapCacheKey;
        }
        if (activeLaunchUrl) frame.dataset.bgFrameUrl = activeLaunchUrl;
        frame.dataset.bgContextPushed = '';
        if (activeContext) {
          frame.dataset.bgContextIdentity = buildEditorLaunchIdentity(config, activeContext, activeLaunchUrl);
        }
      }
      return Promise.resolve(true);
    }

    function open(context) {
      var nextContext = deepClone(context, {});
      var nextLaunchUrl = buildEditorUrl(config, Object.assign({}, nextContext, {
        source: text(settings.source) || 'product'
      }));
      if (!nextLaunchUrl) return Promise.resolve(false);
      if (isTouchEditingShellViewport()) {
        // The launch URL is fully self-sufficient (project/template/size/
        // sides context all ride it) and the editor's close/approve flow
        // navigates back to the product page on its own when no parent
        // shell answers. settings.navigate is an injection seam for tests
        // (jsdom's location.assign is unforgeable).
        activeContext = nextContext;
        activeLaunchUrl = nextLaunchUrl;
        // The page is about to unload: the owner may persist form-owned
        // launch state (MOBILE-DTC-PARITY-01 quantity/options stash) here.
        // A bookkeeping failure must never block the launch itself.
        if (typeof settings.onBeforeTopLevelLaunchNavigate === 'function') {
          try {
            settings.onBeforeTopLevelLaunchNavigate(deepClone(nextContext, {}), nextLaunchUrl);
          } catch (_) {}
        }
        if (typeof settings.navigate === 'function') {
          settings.navigate(nextLaunchUrl);
        } else {
          window.location.assign(nextLaunchUrl);
        }
        return Promise.resolve(true);
      }
      var frame = getFrame();
      var overlay = ensureOverlay();
      var nextContextIdentity = buildEditorLaunchIdentity(config, nextContext, nextLaunchUrl);
      var canReuseReadyFrame = Boolean(
        frame
        && frame.contentWindow
        && frame.dataset.bgShellReady === '1'
        && frame.dataset.bgContextIdentity
        && frame.dataset.bgContextIdentity === nextContextIdentity
      );
      activeContext = nextContext;
      activeLaunchUrl = nextLaunchUrl;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bg-designer-editor-shell--open');
      frame.dataset.bgContextIdentity = nextContextIdentity;
      if (canReuseReadyFrame) {
        frame.dataset.bgFrameUrl = activeLaunchUrl;
        setLoadingVisible(false);
        return Promise.resolve(true);
      }
      setLoadingVisible(true);

      if (SHELL_PROMISES[overlayId]) return SHELL_PROMISES[overlayId];
      SHELL_PROMISES[overlayId] = prewarmEditorBootstrap(config, activeLaunchUrl).catch(function () {
        return { cacheKey: '', payload: null };
      }).then(function (result) {
        // A faster second open() may have superseded the context this fetch
        // started under (it mutates activeContext/activeLaunchUrl and gets
        // this same promise back). Re-derive EVERYTHING from the current
        // module state so the shared continuation always applies the LATEST
        // launch — the fast-click race applied the old cache key, identity,
        // and payload to a frame already labeled with the new URL.
        var launchUrl = text(activeLaunchUrl);
        var launchIdentity = buildEditorLaunchIdentity(config, activeContext, launchUrl);
        var launchCacheKey = getBootstrapCacheKeyForLaunchUrl(config, launchUrl);
        var resultMatchesLaunch = text(result && result.cacheKey) === launchCacheKey;
        var cachedPayload = resultMatchesLaunch && result && result.payload && typeof result.payload === 'object'
          ? result.payload
          : readCachedBootstrap(launchCacheKey);
        var requiresProjectNavigation = !!text(activeContext && activeContext.projectId);
        var currentFrameMatchesLaunchUrl = text(frame.getAttribute('src') || frame.src) === launchUrl;
        frame.dataset.bgFrameUrl = launchUrl;
        frame.dataset.bgBootstrapCacheKey = launchCacheKey;
        frame.dataset.bgContextIdentity = launchIdentity;
        if (
          !requiresProjectNavigation
          && frame.contentWindow
          && frame.dataset.bgShellReady === '1'
          && cachedPayload
          && cachedPayload.bootstrap
          && currentFrameMatchesLaunchUrl
        ) {
          postCachedPayloadToFrame(cachedPayload);
          return true;
        }
        if (
          requiresProjectNavigation
          && text(frame.getAttribute('src')) === launchUrl
          && frame.contentWindow
          && frame.dataset.bgShellReady === '1'
          && cachedPayload
          && cachedPayload.bootstrap
        ) {
          postCachedPayloadToFrame(cachedPayload);
          return true;
        }
        if (
          frame.contentWindow
          && frame.dataset.bgShellReady === '1'
          && cachedPayload
          && cachedPayload.bootstrap
        ) {
          frame.dataset.bgShellReady = '';
          frame.dataset.bgContextPushed = '';
          frame.src = launchUrl;
          return true;
        }
        if (text(frame.getAttribute('src')) !== launchUrl) {
          frame.dataset.bgShellReady = '';
          frame.dataset.bgContextPushed = '';
          frame.src = launchUrl;
        }
        return true;
      }).finally(function () {
        delete SHELL_PROMISES[overlayId];
      });
      return SHELL_PROMISES[overlayId];
    }

    function prewarm(context) {
      var launchUrl = buildEditorUrl(config, Object.assign({}, context || {}, {
        source: text(settings.source) || 'product'
      }));
      if (!launchUrl) return Promise.resolve(false);
      return prewarmEditorBootstrap(config, launchUrl).then(function () {
        return true;
      }).catch(function () {
        return false;
      });
    }

    function close() {
      var overlay = ensureOverlay();
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bg-designer-editor-shell--open');
      setLoadingVisible(false);
      return true;
    }

    // Parent -> editor notification lane (pass-through direct cart): the
    // background add corridor reports progress/failure INTO the still-open
    // editor overlay, because the product page's message block is invisible
    // behind it. Scoped to the editor's own origin.
    function postMessageToEditor(type, detail) {
      var frame = getFrame();
      if (!frame || !frame.contentWindow || !text(type)) return false;
      var editorOrigin = window.location.origin;
      try {
        editorOrigin = new URL(getEditorBaseUrl(config), window.location.origin).origin;
      } catch (_) {
        editorOrigin = window.location.origin;
      }
      try {
        frame.contentWindow.postMessage({
          type: text(type),
          detail: detail && typeof detail === 'object' ? detail : {},
          source: 'bg-designer-storefront-shell'
        }, editorOrigin);
        return true;
      } catch (_) {
        return false;
      }
    }

    window.addEventListener('message', function (event) {
      var frame = getFrame();
      var overlay = ensureOverlay();
      if (!frame || event.source !== frame.contentWindow) return;
      if (!isAllowedOrigin(event.origin)) return;
      var data = event.data;
      if (!data || typeof data !== 'object') return;

      if (data.type === 'storefront:ready-first-usable') {
        frame.dataset.bgShellReady = '1';
        if (shellDocumentWarmResolver && text(frame.dataset.bgFrameUrl) === text(frame.getAttribute('src') || frame.src || activeLaunchUrl || shellDocumentWarmUrl)) {
          resolveShellDocumentWarm(true);
        }
        if (!frame.dataset.bgContextIdentity && activeContext) {
          frame.dataset.bgContextIdentity = buildEditorLaunchIdentity(config, activeContext, activeLaunchUrl);
        }
        if (frame.dataset.bgContextPushed !== '1') {
          var cachedPayload = readCachedBootstrap(text(frame.dataset.bgBootstrapCacheKey));
          if (cachedPayload && cachedPayload.bootstrap) {
            postCachedPayloadToFrame(cachedPayload);
          }
        }
        // Only a ready from the active launch target may reveal the editor.
        // The prewarmed default-product document can emit ready while open()
        // is still re-navigating the frame to the real launch URL; revealing
        // on that message shows the wrong (default) design. Keep the opaque
        // scrim up instead — the launch target emits its own ready after
        // navigation, and the setLoadingVisible watchdog bounds a lost one.
        var readyFrameUrl = text(frame.getAttribute('src') || frame.src);
        var readyMatchesActiveLaunch = !activeLaunchUrl || (
          readyFrameUrl === text(activeLaunchUrl)
          && (!activeContext || text(frame.dataset.bgContextIdentity) === buildEditorLaunchIdentity(config, activeContext, activeLaunchUrl))
        );
        if (readyMatchesActiveLaunch) {
          setLoadingVisible(false);
        }
        if (typeof settings.onReadyFirstUsable === 'function') {
          settings.onReadyFirstUsable(data.detail && typeof data.detail === 'object' ? data.detail : {}, deepClone(activeContext, {}));
        }
        return;
      }

      if (data.type === 'storefront:ready-full') {
        if (typeof settings.onReadyFull === 'function') {
          settings.onReadyFull(data.detail && typeof data.detail === 'object' ? data.detail : {}, deepClone(activeContext, {}));
        }
        return;
      }

      if (data.type === 'storefront:relaunch-product') {
        // Stage 2 S6 (ECO-SIGNS-04): the editor executed a cross-product
        // move; the design now belongs to another product. The THEME owns
        // page URLs, so the shell hands the validated detail to the host
        // page, which navigates to the moved product with the saved-design
        // resume + configuration-session params.
        var relaunchDetail = data.detail && typeof data.detail === 'object' ? data.detail : {};
        if (typeof settings.onRelaunchProduct === 'function') {
          try {
            settings.onRelaunchProduct({
              productHandle: text(relaunchDetail.productHandle),
              projectId: text(relaunchDetail.projectId),
              configurationSessionId: text(relaunchDetail.configurationSessionId)
            });
          } catch (_) { /* the editor keeps its own fallback lane */ }
        }
        return;
      }

      if (data.type === 'storefront:close') {
        var storefrontCloseDetail = data.detail && typeof data.detail === 'object' ? data.detail : {};
        if (activeContext) {
          activeContext.projectId = text(storefrontCloseDetail.projectId || activeContext.projectId);
          activeContext.designId = text(storefrontCloseDetail.designId || activeContext.designId);
          activeContext.designNumber = text(storefrontCloseDetail.designNumber || activeContext.designNumber);
          frame.dataset.bgContextIdentity = buildEditorLaunchIdentity(config, activeContext, activeLaunchUrl);
        }
        refreshBootstrap(storefrontCloseDetail);
        // Pass-through direct cart: onClose runs FIRST so its owner can claim
        // the close ({ deferShellClose: true }) and keep the overlay up while
        // the background add-to-cart corridor runs — hiding the shell before
        // asking is the product-page flash. Any onClose that does not claim
        // the close (or throws) keeps the classic hide-then-return behavior.
        var storefrontCloseResult = null;
        if (typeof settings.onClose === 'function') {
          try {
            storefrontCloseResult = settings.onClose(storefrontCloseDetail, deepClone(activeContext, {}));
          } catch (_) {
            storefrontCloseResult = null;
          }
        }
        if (!storefrontCloseResult || storefrontCloseResult.deferShellClose !== true) {
          close();
        }
        return;
      }

      if (data.type !== 'designer-admin-embedded-lifecycle') return;
      var detail = data.detail && typeof data.detail === 'object' ? data.detail : {};
      if (data.event === 'project-saved') {
        if (activeContext) {
          activeContext.projectId = text(detail.projectId || activeContext.projectId);
          activeContext.designId = text(detail.designId || activeContext.designId);
          activeContext.designNumber = text(detail.designNumber || activeContext.designNumber);
          frame.dataset.bgContextIdentity = buildEditorContextIdentity(activeContext);
        }
        refreshBootstrap(detail);
        if (typeof settings.onProjectSaved === 'function') {
          settings.onProjectSaved(detail, deepClone(activeContext, {}));
        }
        return;
      }
      if (data.event === 'after-close-app') {
        if (activeContext) {
          activeContext.projectId = text(detail.projectId || activeContext.projectId);
          activeContext.designId = text(detail.designId || activeContext.designId);
          activeContext.designNumber = text(detail.designNumber || activeContext.designNumber);
          frame.dataset.bgContextIdentity = buildEditorContextIdentity(activeContext);
        }
        refreshBootstrap(detail);
        close();
        if (typeof settings.onClose === 'function') {
          settings.onClose(detail, deepClone(activeContext, {}));
        }
        return;
      }

      if (!overlay.classList.contains('is-open')) return;
      if (typeof settings.onLifecycleEvent === 'function') {
        settings.onLifecycleEvent(data.event, detail, deepClone(activeContext, {}));
      }
    });

    return {
      ensureOverlay: ensureOverlay,
      open: open,
      prewarmDocument: prewarmDocument,
      prewarm: prewarm,
      close: close,
      postMessageToEditor: postMessageToEditor,
      getActiveContext: function () {
        return deepClone(activeContext, {});
      }
    };
  }

  var coreApi = {
    coreRevision: CORE_REVISION,
    text: text,
    numberValue: numberValue,
    roundMoney: roundMoney,
    scaleMoney: scaleMoney,
    parseJson: parseJson,
    deepClone: deepClone,
    escapeHtml: escapeHtml,
    slugify: slugify,
    uniqueStrings: uniqueStrings,
    loadJson: loadJson,
    readConfig: readConfig,
    formatMoney: formatMoney,
    formatPresentmentMoney: formatPresentmentMoney,
    formatShopMoney: formatShopMoney,
    parsePresentmentRate: parsePresentmentRate,
    presentmentCents: presentmentCents,
    isPresentmentConverting: isPresentmentConverting,
    presentmentCentsOf: presentmentCentsOf,
    presentmentAmount: presentmentAmount,
    calculateDesignerOptionAddOns: calculateDesignerOptionAddOns,
    buildDesignerSplitPrice: buildDesignerSplitPrice,
    buildSelectionDisplayLabel: buildSelectionDisplayLabel,
    buildOptionSelection: buildOptionSelection,
    buildDesignerState: buildDesignerState,
    normalizeChannelCatalog: normalizeChannelCatalog,
    findChannelOfferByVariant: findChannelOfferByVariant,
    normalizeChannelOfferOrigin: normalizeChannelOfferOrigin,
    channelOfferMatches: channelOfferMatches,
    resolveChannelPurchase: resolveChannelPurchase,
    buildPublicProperties: buildPublicProperties,
    buildCartTransformState: buildCartTransformState,
    buildStaffOrderProperties: buildStaffOrderProperties,
    readDesignerStateFromProperties: readDesignerStateFromProperties,
    buildCommerceContextPayload: buildCommerceContextPayload,
    hasSelfHostedProjectReference: hasSelfHostedProjectReference,
    isProjectBoundCommerceProperties: isProjectBoundCommerceProperties,
    requiresProjectAccessCheckoutRefresh: requiresProjectAccessCheckoutRefresh,
    resolveCommerceProjectSession: resolveCommerceProjectSession,
    readCustomerReferenceCode: readCustomerReferenceCode,
    buildCartFailureMessage: buildCartFailureMessage,
    prepareCommerceContextProperties: prepareCommerceContextProperties,
    updateDesignerCartLine: updateDesignerCartLine,
    resolveDesignerLineSubmitQuantity: resolveDesignerLineSubmitQuantity,
    cartLineFingerprint: cartLineFingerprint,
    readCartLineFingerprint: readCartLineFingerprint,
    updateDesignerCartLineAcceptsBeforeMutation: true,
    isNativeChannelOfferProperties: isNativeChannelOfferProperties,
    isNativeChannelOfferLine: isNativeChannelOfferLine,
    readClientUserAgentAnalytics: readClientUserAgentAnalytics,
    resignCommerceContextProperties: resignCommerceContextProperties,
    prepareCommerceContextFormData: prepareCommerceContextFormData,
    fetchCommerceContext: fetchCommerceContext,
    readCommerceContextFullState: readCommerceContextFullState,
    getCartTransformStateMapKey: getCartTransformStateMapKey,
    buildCartTransformStateMapPayload: buildCartTransformStateMapPayload,
    clearCartTransformStateMapAttributes: clearCartTransformStateMapAttributes,
    syncCartTransformStateMap: syncCartTransformStateMap,
    syncCartTransformStateMapForProperties: syncCartTransformStateMapForProperties,
    syncCartTransformStateMapForRemoval: syncCartTransformStateMapForRemoval,
    normalizeDesignerQuantityMode: normalizeDesignerQuantityMode,
    normalizeApparelSizes: normalizeApparelSizes,
    normalizeArtworkMode: normalizeArtworkMode,
    normalizeLaunchProvider: normalizeLaunchProvider,
    buildEditorContextIdentity: buildEditorContextIdentity,
    hashCartToken: hashCartToken,
    resolveDurableCartTokenHash: resolveDurableCartTokenHash,
    normalizeCompletionState: normalizeCompletionState,
    fetchCartState: fetchCartState,
    findLineByKey: findLineByKey,
    changeCartLine: changeCartLine,
    fetchProjectRecord: fetchProjectRecord,
    fetchProjectCompletionEligibility: fetchProjectCompletionEligibility,
    fetchProjectPreview: fetchProjectPreview,
    readProjectArtworkPresence: readProjectArtworkPresence,
    readProjectDocumentOrientation: readProjectDocumentOrientation,
    hasStoredProjectReadCredential: function (projectId) {
      return !!readStoredProjectReadCredential(projectId);
    },
    fetchTemplateSummary: fetchTemplateSummary,
    collectProjectPreviewUrls: collectProjectPreviewUrls,
    collectProjectBoardPreviews: collectProjectBoardPreviews,
    buildEditorUrl: buildEditorUrl,
    openPreviewLightbox: openPreviewLightbox,
    closePreviewLightbox: closePreviewLightbox,
    createEditorShell: createEditorShell,
    parseSizeToken: parseSizeToken,
    PARTNER_TIER_PRICE_KEY: PARTNER_TIER_PRICE_KEY,
    PARTNER_TIER_TAG: PARTNER_TIER_TAG,
    LEGACY_PARTNER_TIER_PRICE_KEY: LEGACY_PARTNER_TIER_PRICE_KEY,
    LEGACY_PARTNER_TIER_TAG: LEGACY_PARTNER_TIER_TAG,
    readTierPrice: readTierPrice,
    withPartnerTierPriceKey: withPartnerTierPriceKey,
    withPartnerTierPricingData: withPartnerTierPricingData
  };

  var loadedCore = window.BGDesignerStorefrontCore;
  if (loadedCore && typeof loadedCore === 'object') {
    Object.keys(coreApi).forEach(function (key) {
      loadedCore[key] = coreApi[key];
    });
  } else {
    window.BGDesignerStorefrontCore = coreApi;
  }
})();
